/* eslint-disable */
import { useState, useEffect, useCallback, useRef, createContext, useContext } from "react";

// ─── THEME ────────────────────────────────────────────────
const DARK_THEME = {
  bg:"#060a12", surface:"#0d1420", card:"#111827", border:"#1a2540",
  accent:"#6366f1", accent2:"#8b5cf6", accentGlow:"#6366f155",
  gold:"#f59e0b", green:"#10b981", red:"#ef4444",
  text:"#e2e8f0", muted:"#64748b",
};
const LIGHT_THEME = {
  bg:"#f8fafc", surface:"#ffffff", card:"#ffffff", border:"#e2e8f0",
  accent:"#6366f1", accent2:"#8b5cf6", accentGlow:"#6366f133",
  gold:"#d97706", green:"#059669", red:"#dc2626",
  text:"#1e293b", muted:"#64748b",
};
// T is set dynamically — default dark
let T = {...DARK_THEME};

// ─── API ──────────────────────────────────────────────────
const API = process.env.REACT_APP_API_URL || "http://localhost:4000";

async function apiFetch(path, method="GET", body=null, token=null) {
  const headers = {"Content-Type":"application/json"};
  if (token) headers["Authorization"] = `Bearer ${token}`;
  const res = await fetch(`${API}${path}`, {
    method, headers,
    body: body ? JSON.stringify(body) : null,
  });
  const data = await res.json();
  if (!res.ok) {
    // If server says forceLogout, clear session immediately
    if (data.forceLogout) {
      localStorage.removeItem("cp_token");
      window.location.reload();
    }
    throw new Error(data.error || "Request failed");
  }
  return data;
}

// ─── POINTS COSTS ─────────────────────────────────────────
const COSTS = { RESUME:4, ATS:4, COVER:4, INTERVIEW:2, PDF:2, APPLY:5 };
const PACKAGES = [
  { id:"p1", points:20,  price:"₦500",   bonus:0,  label:"Starter" },
  { id:"p2", points:50,  price:"₦1,000", bonus:5,  label:"Popular" },
  { id:"p3", points:100, price:"₦2,000", bonus:10, label:"Best Value" },
  { id:"p4", points:150, price:"₦3,000", bonus:20, label:"Pro" },
];
const AFRICAN_COUNTRIES = {"Nigeria":{"flag":"🇳🇬","states":["Abia","Adamawa","Akwa Ibom","Anambra","Bauchi","Bayelsa","Benue","Borno","Cross River","Delta","Ebonyi","Edo","Ekiti","Enugu","FCT Abuja","Gombe","Imo","Jigawa","Kaduna","Kano","Katsina","Kebbi","Kogi","Kwara","Lagos","Nasarawa","Niger","Ogun","Ondo","Osun","Oyo","Plateau","Rivers","Sokoto","Taraba","Yobe","Zamfara"]},"Ghana":{"flag":"🇬🇭","states":["Ahafo","Ashanti","Bono","Bono East","Central","Eastern","Greater Accra","North East","Northern","Oti","Savannah","Upper East","Upper West","Volta","Western","Western North"]},"Kenya":{"flag":"🇰🇪","states":["Baringo","Bomet","Bungoma","Busia","Embu","Garissa","Homa Bay","Isiolo","Kajiado","Kakamega","Kericho","Kiambu","Kilifi","Kirinyaga","Kisii","Kisumu","Kitui","Kwale","Laikipia","Lamu","Machakos","Makueni","Mandera","Marsabit","Meru","Migori","Mombasa","Murang'a","Nairobi","Nakuru","Nandi","Narok","Nyamira","Nyandarua","Nyeri","Samburu","Siaya","Taita Taveta","Tana River","Trans Nzoia","Turkana","Uasin Gishu","Vihiga","Wajir","West Pokot"]},"South Africa":{"flag":"🇿🇦","states":["Eastern Cape","Free State","Gauteng","KwaZulu-Natal","Limpopo","Mpumalanga","Northern Cape","North West","Western Cape"]},"Ethiopia":{"flag":"🇪🇹","states":["Addis Ababa","Afar","Amhara","Benishangul-Gumuz","Dire Dawa","Gambela","Harari","Oromia","Sidama","Somali","Southern Nations","Tigray"]},"Tanzania":{"flag":"🇹🇿","states":["Arusha","Dar es Salaam","Dodoma","Geita","Iringa","Kagera","Kilimanjaro","Manyara","Mara","Mbeya","Morogoro","Mtwara","Mwanza","Pwani","Ruvuma","Shinyanga","Tabora","Tanga","Zanzibar"]},"Uganda":{"flag":"🇺🇬","states":["Kampala","Central","Eastern","Northern","Western"]},"Egypt":{"flag":"🇪🇬","states":["Cairo","Giza","Alexandria","Aswan","Assiut","Beheira","Beni Suef","Dakahlia","Damietta","Faiyum","Gharbia","Ismailia","Kafr el-Sheikh","Luxor","Matruh","Minya","Monufia","North Sinai","Port Said","Qalyubia","Qena","Red Sea","Sharqia","Sohag","South Sinai","Suez"]},"Cameroon":{"flag":"🇨🇲","states":["Adamawa","Centre","East","Far North","Littoral","North","Northwest","South","Southwest","West"]},"Senegal":{"flag":"🇸🇳","states":["Dakar","Diourbel","Fatick","Kaffrine","Kaolack","Kedougou","Kolda","Louga","Matam","Saint-Louis","Sedhiou","Tambacounda","Thies","Ziguinchor"]},"Ivory Coast":{"flag":"🇨🇮","states":["Abidjan","Bas-Sassandra","Comoé","Denguélé","Gôh-Djiboua","Lacs","Lagunes","Montagnes","Sassandra-Marahoué","Savanes","Vallée du Bandama","Woroba","Yamoussoukro","Zanzan"]},"Rwanda":{"flag":"🇷🇼","states":["Kigali","Eastern","Northern","Southern","Western"]},"Zimbabwe":{"flag":"🇿🇼","states":["Bulawayo","Harare","Manicaland","Mashonaland Central","Mashonaland East","Mashonaland West","Masvingo","Matabeleland North","Matabeleland South","Midlands"]},"Zambia":{"flag":"🇿🇲","states":["Central","Copperbelt","Eastern","Luapula","Lusaka","Muchinga","North-Western","Northern","Southern","Western"]},"Morocco":{"flag":"🇲🇦","states":["Beni Mellal-Khenifra","Casablanca-Settat","Draa-Tafilalet","Fes-Meknes","Marrakesh-Safi","Oriental","Rabat-Sale-Kenitra","Souss-Massa","Tanger-Tetouan-Al Hoceima"]},"Algeria":{"flag":"🇩🇿","states":["Algiers","Oran","Constantine","Annaba","Blida","Batna","Setif","Bejaia","Tlemcen","Biskra","Tizi Ouzou","Ghardaia","Ouargla","Tamanrasset"]},"Tunisia":{"flag":"🇹🇳","states":["Ariana","Ben Arous","Bizerte","Gabès","Gafsa","Jendouba","Kairouan","Kasserine","Monastir","Nabeul","Sfax","Sousse","Tunis"]},"Angola":{"flag":"🇦🇴","states":["Benguela","Huambo","Huíla","Luanda","Malanje","Namibe","Uíge"]},"Mozambique":{"flag":"🇲🇿","states":["Cabo Delgado","Gaza","Inhambane","Manica","Maputo","Nampula","Sofala","Tete","Zambezia"]},"Sierra Leone":{"flag":"🇸🇱","states":["Eastern","Northern","Southern","Western Area"]},"Mali":{"flag":"🇲🇱","states":["Bamako","Gao","Kayes","Koulikoro","Mopti","Segou","Sikasso"]},"Burkina Faso":{"flag":"🇧🇫","states":["Centre","Centre-Est","Centre-Nord","Centre-Ouest","Est","Hauts-Bassins","Nord","Sahel"]},"Benin":{"flag":"🇧🇯","states":["Alibori","Atacora","Atlantique","Borgou","Collines","Donga","Littoral","Mono","Ouémé","Plateau","Zou"]},"Togo":{"flag":"🇹🇬","states":["Centrale","Kara","Maritime","Plateaux","Savanes"]},"Sudan":{"flag":"🇸🇩","states":["Blue Nile","Gezira","Kassala","Khartoum","North Kordofan","Northern","Red Sea","Sennar","South Darfur","White Nile"]},"Malawi":{"flag":"🇲🇼","states":["Central Region","Northern Region","Southern Region"]},"Botswana":{"flag":"🇧🇼","states":["Central","Ghanzi","Kgalagadi","Kgatleng","Kweneng","North East","South East","Southern"]},"Namibia":{"flag":"🇳🇦","states":["Erongo","Hardap","Khomas","Kunene","Ohangwena","Oshana","Oshikoto","Otjozondjupa","Zambezi"]},"Liberia":{"flag":"🇱🇷","states":["Bomi","Bong","Grand Bassa","Grand Cape Mount","Lofa","Margibi","Montserrado","Nimba"]},"Madagascar":{"flag":"🇲🇬","states":["Analamanga","Boeny","Diana","Haute Matsiatra","SAVA","Sofia","Vakinankaratra"]}};

// ─── AUTH CONTEXT ─────────────────────────────────────────
const AuthCtx = createContext(null);
function useAuth() { return useContext(AuthCtx); }

function AuthProvider({ children }) {
  const [user,  setUser]  = useState(null);
  const [token, setToken] = useState(null);
  const [booting, setBoot] = useState(true);

  useEffect(() => {
    const t = localStorage.getItem("cp_token");
    if (!t) { setBoot(false); return; }
    apiFetch("/api/auth/me", "GET", null, t)
      .then(u => { setUser(u); setToken(t); })
      .catch(() => localStorage.removeItem("cp_token"))
      .finally(() => setBoot(false));
  }, []);

  const login = (u, t) => {
    setUser(u); setToken(t);
    localStorage.setItem("cp_token", t);
  };
  const logout = () => {
    setUser(null); setToken(null);
    localStorage.removeItem("cp_token");
  };
  const setPoints = (pts) => setUser(u => u ? {...u, points: pts} : u);

  if (booting) return (
    <div style={{minHeight:"100vh",background:T.bg,display:"flex",alignItems:"center",justifyContent:"center",flexDirection:"column",gap:16,fontFamily:"sans-serif"}}>
      <style>{`@keyframes spin{to{transform:rotate(360deg)}}`}</style>
      <div style={{width:40,height:40,border:`3px solid ${T.border}`,borderTopColor:T.accent,borderRadius:"50%",animation:"spin 0.8s linear infinite"}}/>
      <span style={{color:T.muted,fontSize:14}}>Loading Career Pilot...</span>
    </div>
  );

  return (
    <AuthCtx.Provider value={{user, token, login, logout, setPoints}}>
      {children}
    </AuthCtx.Provider>
  );
}

// ─── CAREERS ──────────────────────────────────────────────
const CAREERS = [
  // ── Technology & Software ──────────────────────────────
  {id:"swe",label:"Software Engineer",icon:"💻",cat:"Technology",skills:["React","Node.js","Python","SQL","AWS","Docker","TypeScript","Git"]},
  {id:"fe",label:"Frontend Developer",icon:"🖥️",cat:"Technology",skills:["HTML","CSS","JavaScript","React","Vue.js","TypeScript","Tailwind"]},
  {id:"be",label:"Backend Developer",icon:"⚙️",cat:"Technology",skills:["Node.js","Python","Java","PostgreSQL","MongoDB","Redis","Docker"]},
  {id:"fs",label:"Full Stack Developer",icon:"🔧",cat:"Technology",skills:["React","Node.js","Python","SQL","NoSQL","Docker","AWS"]},
  {id:"mobile",label:"Mobile App Developer",icon:"📱",cat:"Technology",skills:["React Native","Flutter","Swift","Kotlin","iOS","Android","Firebase"]},
  {id:"ios",label:"iOS Developer",icon:"🍎",cat:"Technology",skills:["Swift","Objective-C","Xcode","UIKit","SwiftUI","CoreData","Firebase"]},
  {id:"android",label:"Android Developer",icon:"🤖",cat:"Technology",skills:["Kotlin","Java","Android Studio","Firebase","Jetpack Compose","REST APIs"]},
  {id:"devops",label:"DevOps Engineer",icon:"🔄",cat:"Technology",skills:["Docker","Kubernetes","AWS","CI/CD","Terraform","Linux","Git","Jenkins"]},
  {id:"cloud",label:"Cloud Architect",icon:"☁️",cat:"Technology",skills:["AWS","Azure","GCP","Terraform","Kubernetes","Microservices","Serverless"]},
  {id:"sre",label:"Site Reliability Engineer",icon:"🛠️",cat:"Technology",skills:["Linux","Kubernetes","Monitoring","Python","Incident Response","SLOs"]},
  {id:"data",label:"Data Analyst",icon:"📊",cat:"Technology",skills:["Python","SQL","Tableau","Excel","Power BI","Statistics","R"]},
  {id:"ds",label:"Data Scientist",icon:"🔬",cat:"Technology",skills:["Python","Machine Learning","TensorFlow","SQL","Statistics","R","Jupyter"]},
  {id:"ml",label:"ML Engineer",icon:"🤖",cat:"Technology",skills:["Python","TensorFlow","PyTorch","MLOps","NLP","Computer Vision","Kubeflow"]},
  {id:"ai",label:"AI Engineer",icon:"🧠",cat:"Technology",skills:["Python","LLMs","OpenAI API","LangChain","RAG","Fine-tuning","Prompt Engineering"]},
  {id:"de",label:"Data Engineer",icon:"🗄️",cat:"Technology",skills:["Python","Spark","Kafka","Airflow","SQL","dbt","Hadoop","ETL"]},
  {id:"dba",label:"Database Administrator",icon:"🗃️",cat:"Technology",skills:["SQL","PostgreSQL","MySQL","Oracle","MongoDB","Performance Tuning"]},
  {id:"bi",label:"Business Intelligence Analyst",icon:"📈",cat:"Technology",skills:["Power BI","Tableau","SQL","Excel","DAX","Data Modeling","ETL"]},
  {id:"cyber",label:"Cybersecurity Analyst",icon:"🔐",cat:"Technology",skills:["Network Security","SIEM","Penetration Testing","CISSP","Risk Assessment"]},
  {id:"pentest",label:"Penetration Tester",icon:"🕵️",cat:"Technology",skills:["Kali Linux","Metasploit","Burp Suite","Python","OSCP","Network Security"]},
  {id:"infosec",label:"Information Security Manager",icon:"🛡️",cat:"Technology",skills:["ISO 27001","Risk Management","CISSP","Compliance","Incident Response"]},
  {id:"qa",label:"QA Engineer",icon:"✅",cat:"Technology",skills:["Selenium","Jest","Cypress","Manual Testing","Automation","API Testing","Jira"]},
  {id:"sysadmin",label:"System Administrator",icon:"🖧",cat:"Technology",skills:["Linux","Windows Server","Networking","Active Directory","VMware","Bash"]},
  {id:"net",label:"Network Engineer",icon:"🌐",cat:"Technology",skills:["Cisco","TCP/IP","BGP","OSPF","Firewalls","VPN","Network Monitoring"]},
  {id:"embed",label:"Embedded Systems Engineer",icon:"🔌",cat:"Technology",skills:["C","C++","RTOS","Microcontrollers","FPGA","PCB Design","Assembly"]},
  {id:"iot",label:"IoT Engineer",icon:"📡",cat:"Technology",skills:["Embedded C","Arduino","MQTT","AWS IoT","Python","Edge Computing","Sensors"]},
  {id:"blockchain",label:"Blockchain Developer",icon:"⛓️",cat:"Technology",skills:["Solidity","Ethereum","Web3.js","Smart Contracts","DeFi","Rust","Hardhat"]},
  {id:"game",label:"Game Developer",icon:"🎮",cat:"Technology",skills:["Unity","Unreal Engine","C#","C++","3D Modeling","Game Design","OpenGL"]},
  {id:"arvr",label:"AR/VR Developer",icon:"🥽",cat:"Technology",skills:["Unity","ARKit","ARCore","WebXR","3D Modeling","Oculus SDK","Spatial Computing"]},
  {id:"pm",label:"Product Manager",icon:"📋",cat:"Technology",skills:["Roadmapping","Jira","Analytics","A/B Testing","Agile","PRDs","User Stories"]},
  {id:"scrum",label:"Scrum Master",icon:"🏃",cat:"Technology",skills:["Agile","Scrum","Jira","Sprint Planning","Kanban","Retrospectives","Coaching"]},
  {id:"it",label:"IT Support Specialist",icon:"🛠️",cat:"Technology",skills:["Troubleshooting","Windows","macOS","Networking","Help Desk","O365","Hardware"]},
  {id:"techwriter",label:"Technical Writer",icon:"📝",cat:"Technology",skills:["Documentation","API Writing","Markdown","DITA","Confluence","Jira","Editing"]},
  // ── Design ────────────────────────────────────────────
  {id:"uiux",label:"UI/UX Designer",icon:"🎨",cat:"Design",skills:["Figma","Adobe XD","Prototyping","User Research","Wireframing","Usability Testing"]},
  {id:"graphic",label:"Graphic Designer",icon:"🖌️",cat:"Design",skills:["Photoshop","Illustrator","InDesign","Canva","Typography","Branding"]},
  {id:"motion",label:"Motion Designer",icon:"🎬",cat:"Design",skills:["After Effects","Premiere Pro","Cinema 4D","Animation","Lottie","Storyboarding"]},
  {id:"brand",label:"Brand Designer",icon:"✨",cat:"Design",skills:["Brand Identity","Logo Design","Adobe Suite","Typography","Style Guides","Figma"]},
  {id:"webdes",label:"Web Designer",icon:"🌐",cat:"Design",skills:["HTML","CSS","Figma","WordPress","Responsive Design","Webflow","Adobe XD"]},
  {id:"3dart",label:"3D Artist",icon:"🎲",cat:"Design",skills:["Blender","Maya","3ds Max","ZBrush","Texturing","Rendering","Cinema 4D"]},
  {id:"illustrator",label:"Illustrator",icon:"✏️",cat:"Design",skills:["Adobe Illustrator","Procreate","Drawing","Vector Art","Character Design"]},
  {id:"fashdes",label:"Fashion Designer",icon:"👗",cat:"Design",skills:["Sketching","Adobe Illustrator","Pattern Making","Fabric Knowledge","Trend Analysis"]},
  {id:"intdes",label:"Interior Designer",icon:"🏠",cat:"Design",skills:["AutoCAD","SketchUp","Space Planning","3D Rendering","Revit","Material Selection"]},
  {id:"proddes",label:"Product Designer",icon:"🔨",cat:"Design",skills:["CAD","SolidWorks","Prototyping","User Research","Figma","Design Thinking"]},
  // ── Finance & Accounting ───────────────────────────────
  {id:"acct",label:"Accountant",icon:"📒",cat:"Finance",skills:["QuickBooks","Excel","GAAP","Tax Preparation","Auditing","IFRS","Xero"]},
  {id:"finana",label:"Financial Analyst",icon:"💹",cat:"Finance",skills:["Excel","Financial Modeling","Bloomberg","Valuation","SQL","PowerPoint"]},
  {id:"invest",label:"Investment Banker",icon:"🏦",cat:"Finance",skills:["Financial Modeling","M&A","Valuation","Bloomberg","Excel","Capital Markets"]},
  {id:"audit",label:"Auditor",icon:"🔍",cat:"Finance",skills:["GAAP","IFRS","Risk Assessment","Internal Controls","Excel","Compliance","CPA"]},
  {id:"tax",label:"Tax Specialist",icon:"📑",cat:"Finance",skills:["Tax Law","QuickBooks","GAAP","Tax Filing","Compliance","Excel","Research"]},
  {id:"risk",label:"Risk Analyst",icon:"⚠️",cat:"Finance",skills:["Risk Modeling","Excel","SQL","VaR","Regulatory Compliance","Financial Analysis"]},
  {id:"actuary",label:"Actuary",icon:"📐",cat:"Finance",skills:["Statistics","R","Excel","Probability","SAS","Risk Assessment","Financial Modeling"]},
  {id:"cfo",label:"Chief Financial Officer",icon:"💼",cat:"Finance",skills:["Financial Strategy","Fundraising","Investor Relations","M&A","Budgeting","Leadership"]},
  {id:"banker",label:"Bank Teller",icon:"🏧",cat:"Finance",skills:["Cash Handling","Customer Service","Banking Software","Communication","Compliance"]},
  {id:"finplan",label:"Financial Planner",icon:"📅",cat:"Finance",skills:["CFP","Retirement Planning","Tax Planning","Investment Strategy","Client Relations"]},
  {id:"insure",label:"Insurance Agent",icon:"🛡️",cat:"Finance",skills:["Policy Knowledge","Sales","CRM","Risk Assessment","Customer Service","Negotiation"]},
  {id:"stockbroker",label:"Stockbroker",icon:"📉",cat:"Finance",skills:["Securities","Trading","Bloomberg","CFA","Financial Analysis","Client Management"]},
  {id:"crypto",label:"Crypto Analyst",icon:"₿",cat:"Finance",skills:["Blockchain","DeFi","Technical Analysis","Trading","Market Research","Web3"]},
  {id:"mfinance",label:"Microfinance Officer",icon:"💰",cat:"Finance",skills:["Loan Processing","Credit Analysis","Financial Inclusion","Risk Assessment","Community Outreach"]},
  // ── Business & Management ──────────────────────────────
  {id:"biz",label:"Business Analyst",icon:"📊",cat:"Business",skills:["Requirements Gathering","SQL","Excel","Stakeholder Management","Agile","UML"]},
  {id:"proj",label:"Project Manager",icon:"📌",cat:"Business",skills:["PMP","MS Project","Agile","Risk Management","Budgeting","Jira","Stakeholder Communication"]},
  {id:"ops",label:"Operations Manager",icon:"⚙️",cat:"Business",skills:["Process Improvement","Lean","Six Sigma","KPIs","ERP","Budgeting","Supply Chain"]},
  {id:"strat",label:"Strategy Consultant",icon:"♟️",cat:"Business",skills:["Business Strategy","Financial Modeling","Market Analysis","PowerPoint","Problem Solving"]},
  {id:"mgmt",label:"Management Consultant",icon:"🏢",cat:"Business",skills:["Problem Solving","PowerPoint","Data Analysis","Change Management","Stakeholder Management"]},
  {id:"entrep",label:"Entrepreneur",icon:"🚀",cat:"Business",skills:["Business Development","Fundraising","Leadership","Product Management","Marketing","Networking"]},
  {id:"exec",label:"Executive Assistant",icon:"👔",cat:"Business",skills:["Calendar Management","Travel Planning","Microsoft Office","Communication","Discretion"]},
  {id:"supchain",label:"Supply Chain Manager",icon:"🔗",cat:"Business",skills:["Logistics","SAP","Inventory Management","Procurement","ERP","Forecasting"]},
  {id:"procure",label:"Procurement Specialist",icon:"🛒",cat:"Business",skills:["Vendor Management","Contract Negotiation","SAP","Excel","Cost Analysis","RFPs"]},
  {id:"logist",label:"Logistics Coordinator",icon:"🚚",cat:"Business",skills:["Supply Chain","Inventory","ERP","Shipping","Excel","Customs","Communication"]},
  {id:"change",label:"Change Management Specialist",icon:"🔄",cat:"Business",skills:["ADKAR","Communication","Training","Stakeholder Engagement","Process Improvement"]},
  {id:"ceo",label:"Chief Executive Officer",icon:"👑",cat:"Business",skills:["Leadership","Strategic Planning","P&L Management","Fundraising","Board Relations","Vision"]},
  {id:"coo",label:"Chief Operating Officer",icon:"🏭",cat:"Business",skills:["Operations","Process Optimization","Leadership","KPIs","Strategic Planning","Team Building"]},
  {id:"cto",label:"Chief Technology Officer",icon:"💡",cat:"Business",skills:["Technology Strategy","Team Leadership","Architecture","Product Roadmap","Innovation","Agile"]},
  {id:"cmo",label:"Chief Marketing Officer",icon:"📣",cat:"Business",skills:["Brand Strategy","Growth","Digital Marketing","Analytics","Team Leadership","Budget Management"]},
  {id:"franchise",label:"Franchise Manager",icon:"🏪",cat:"Business",skills:["Franchise Operations","Training","Compliance","P&L","Vendor Relations","Quality Control"]},
  // ── Sales & Marketing ─────────────────────────────────
  {id:"sales",label:"Sales Representative",icon:"🤝",cat:"Sales",skills:["CRM","Salesforce","Cold Calling","Negotiation","HubSpot","Pipeline Management"]},
  {id:"salesm",label:"Sales Manager",icon:"📈",cat:"Sales",skills:["Team Leadership","CRM","Salesforce","Forecasting","Coaching","B2B Sales","Territory Management"]},
  {id:"bde",label:"Business Development Executive",icon:"🌱",cat:"Sales",skills:["Lead Generation","Networking","CRM","Proposal Writing","Negotiation","Partnership Building"]},
  {id:"acc",label:"Account Manager",icon:"🤝",cat:"Sales",skills:["Client Relations","CRM","Upselling","Contract Management","Salesforce","Retention"]},
  {id:"inside",label:"Inside Sales Representative",icon:"📞",cat:"Sales",skills:["Cold Calling","CRM","Email Outreach","Objection Handling","Pipeline Management","Demo Skills"]},
  {id:"mkt",label:"Digital Marketer",icon:"📣",cat:"Marketing",skills:["SEO","Google Ads","Social Media","Content Strategy","Analytics","Email Marketing","Meta Ads"]},
  {id:"seo",label:"SEO Specialist",icon:"🔎",cat:"Marketing",skills:["On-page SEO","Ahrefs","SEMrush","Google Analytics","Link Building","Technical SEO"]},
  {id:"social",label:"Social Media Manager",icon:"📱",cat:"Marketing",skills:["Instagram","TikTok","Facebook","Content Creation","Analytics","Canva","Community Management"]},
  {id:"content",label:"Content Creator",icon:"✍️",cat:"Marketing",skills:["Video Editing","SEO","Canva","Storytelling","Blog Writing","Social Media","Scripting"]},
  {id:"email",label:"Email Marketing Specialist",icon:"✉️",cat:"Marketing",skills:["Mailchimp","Klaviyo","Segmentation","A/B Testing","Copywriting","Analytics","Automation"]},
  {id:"copy",label:"Copywriter",icon:"🖊️",cat:"Marketing",skills:["SEO Writing","Ad Copy","Landing Pages","Storytelling","Research","Brand Voice","Editing"]},
  {id:"pr",label:"Public Relations Specialist",icon:"📰",cat:"Marketing",skills:["Media Relations","Press Releases","Crisis Management","Brand Management","Event Planning"]},
  {id:"growth",label:"Growth Hacker",icon:"📊",cat:"Marketing",skills:["A/B Testing","Analytics","SEO","Paid Ads","Funnel Optimization","Python","User Acquisition"]},
  {id:"brand2",label:"Brand Manager",icon:"💡",cat:"Marketing",skills:["Brand Strategy","Market Research","Campaign Management","Analytics","Consumer Insights","P&L"]},
  {id:"ecom",label:"E-Commerce Manager",icon:"🛍️",cat:"Marketing",skills:["Shopify","WooCommerce","Google Analytics","Amazon","SEO","Email Marketing","Paid Ads"]},
  {id:"affiliate",label:"Affiliate Marketing Manager",icon:"🔗",cat:"Marketing",skills:["Affiliate Networks","CPA","CPC","Analytics","Partnerships","Commission Structures"]},
  {id:"influencer",label:"Influencer Marketing Manager",icon:"⭐",cat:"Marketing",skills:["Campaign Management","Contract Negotiation","Analytics","Social Media","Content Strategy"]},
  {id:"media",label:"Media Buyer",icon:"📺",cat:"Marketing",skills:["Programmatic Advertising","Google Ads","Meta Ads","Budget Management","Analytics","Audience Targeting"]},
  // ── Healthcare & Medical ───────────────────────────────
  {id:"nurse",label:"Nurse",icon:"🏥",cat:"Healthcare",skills:["Patient Care","EMR","IV Therapy","CPR","Medication Administration","Clinical Assessment"]},
  {id:"rn",label:"Registered Nurse",icon:"💉",cat:"Healthcare",skills:["Patient Care","EMR","IV Therapy","CPR","Wound Care","Clinical Assessment","ACLS"]},
  {id:"doctor",label:"Medical Doctor",icon:"👨‍⚕️",cat:"Healthcare",skills:["Clinical Diagnosis","EMR","Patient Care","ICD-10","Evidence-Based Medicine","Surgery"]},
  {id:"surgeon",label:"Surgeon",icon:"🔪",cat:"Healthcare",skills:["Surgical Techniques","Anatomy","Patient Safety","Pre-op Assessment","Post-op Care","Laparoscopy"]},
  {id:"pharma",label:"Pharmacist",icon:"💊",cat:"Healthcare",skills:["Drug Dispensing","Patient Counseling","Drug Interactions","Inventory","Compounding","Compliance"]},
  {id:"physio",label:"Physiotherapist",icon:"🦽",cat:"Healthcare",skills:["Manual Therapy","Exercise Prescription","Rehabilitation","Patient Assessment","SOAP Notes"]},
  {id:"dentist",label:"Dentist",icon:"🦷",cat:"Healthcare",skills:["Clinical Dentistry","X-rays","Patient Management","Oral Surgery","Orthodontics","EMR"]},
  {id:"psychol",label:"Psychologist",icon:"🧠",cat:"Healthcare",skills:["CBT","Assessment","Psychotherapy","Diagnosis","Report Writing","Research","Ethics"]},
  {id:"midwife",label:"Midwife",icon:"👶",cat:"Healthcare",skills:["Prenatal Care","Labor Support","Postnatal Care","Emergency Obstetrics","Patient Education"]},
  {id:"labtech",label:"Laboratory Technician",icon:"🔬",cat:"Healthcare",skills:["Sample Analysis","LIMS","Quality Control","PCR","Data Recording","Safety Protocols"]},
  {id:"radtech",label:"Radiographer",icon:"🩻",cat:"Healthcare",skills:["CT Scan","MRI","X-ray","PACS","Patient Positioning","Radiation Safety","DICOM"]},
  {id:"optom",label:"Optometrist",icon:"👁️",cat:"Healthcare",skills:["Eye Examination","Prescription Writing","Contact Lenses","Ophthalmic Instruments","EMR"]},
  {id:"nutrition",label:"Nutritionist/Dietitian",icon:"🥗",cat:"Healthcare",skills:["Meal Planning","Clinical Nutrition","Patient Counseling","Medical Nutrition Therapy"]},
  {id:"mentalh",label:"Mental Health Counselor",icon:"🧘",cat:"Healthcare",skills:["CBT","Psychotherapy","Crisis Intervention","Case Management","Group Therapy","HIPAA"]},
  {id:"sw",label:"Social Worker",icon:"🤲",cat:"Healthcare",skills:["Case Management","Crisis Intervention","Community Resources","Advocacy","Counseling"]},
  {id:"paramedic",label:"Paramedic/EMT",icon:"🚑",cat:"Healthcare",skills:["Emergency Care","BLS","ACLS","IV Therapy","Patient Assessment","Trauma Care","CPR"]},
  {id:"vet",label:"Veterinarian",icon:"🐾",cat:"Healthcare",skills:["Animal Surgery","Diagnosis","Pharmacology","Patient Care","Lab Analysis","Client Communication"]},
  {id:"pubhealth",label:"Public Health Officer",icon:"🌍",cat:"Healthcare",skills:["Epidemiology","Health Education","Disease Surveillance","Data Analysis","Community Outreach"]},
  {id:"occup",label:"Occupational Therapist",icon:"🖐️",cat:"Healthcare",skills:["Functional Assessment","Rehabilitation","Assistive Technology","Home Modifications","ADLs"]},
  {id:"speech",label:"Speech Therapist",icon:"🗣️",cat:"Healthcare",skills:["Speech Assessment","Dysphagia","Language Disorders","AAC","Therapy Planning","Documentation"]},
  {id:"healthadmin",label:"Healthcare Administrator",icon:"🏥",cat:"Healthcare",skills:["Hospital Management","Healthcare Policy","Budgeting","Compliance","Staff Management","EMR"]},
  {id:"clinresearch",label:"Clinical Research Coordinator",icon:"📋",cat:"Healthcare",skills:["Clinical Trials","GCP","IRB","Data Collection","Protocol Compliance","Patient Recruitment"]},
  {id:"medrecord",label:"Medical Records Officer",icon:"📂",cat:"Healthcare",skills:["ICD Coding","EMR","HIPAA","Data Entry","Medical Terminology","Patient Privacy"]},
  {id:"homecare",label:"Home Care Aide",icon:"🏡",cat:"Healthcare",skills:["Personal Care","Patient Assistance","Medication Reminders","Companionship","Mobility Support"]},
  // ── Education ─────────────────────────────────────────
  {id:"teach",label:"Teacher",icon:"📚",cat:"Education",skills:["Curriculum Design","Classroom Management","Assessment","Lesson Planning","Google Classroom"]},
  {id:"principal",label:"School Principal",icon:"🏫",cat:"Education",skills:["Educational Leadership","Staff Management","Curriculum Oversight","Budgeting","Policy"]},
  {id:"counsel",label:"School Counselor",icon:"🧑‍💼",cat:"Education",skills:["Career Counseling","Academic Planning","Crisis Intervention","Student Advocacy","FERPA"]},
  {id:"elearn",label:"E-Learning Developer",icon:"💻",cat:"Education",skills:["Articulate Storyline","LMS","Instructional Design","SCORM","Adobe Captivate","Video Production"]},
  {id:"tutor",label:"Tutor/Private Teacher",icon:"📖",cat:"Education",skills:["Subject Expertise","Lesson Planning","Patience","Communication","Assessment","Personalized Learning"]},
  {id:"librarian",label:"Librarian",icon:"📗",cat:"Education",skills:["Cataloging","Research Assistance","Library Systems","Information Literacy","Community Programs"]},
  {id:"trainer",label:"Corporate Trainer",icon:"🎯",cat:"Education",skills:["Instructional Design","Facilitation","LMS","Adult Learning","Training Needs Analysis"]},
  {id:"prof",label:"Professor/Lecturer",icon:"🎓",cat:"Education",skills:["Research","Academic Writing","Curriculum Design","Student Assessment","Grant Writing","Publication"]},
  {id:"speceduc",label:"Special Education Teacher",icon:"💛",cat:"Education",skills:["IEP Development","Behavioral Management","Adaptive Instruction","Assistive Technology"]},
  {id:"earlyc",label:"Early Childhood Educator",icon:"🧒",cat:"Education",skills:["Child Development","Play-Based Learning","Classroom Management","Parent Communication","Safety"]},
  {id:"instdes",label:"Instructional Designer",icon:"📐",cat:"Education",skills:["ADDIE","Articulate","Storyboarding","LMS","Adult Learning","Graphic Design","Needs Analysis"]},
  {id:"languageteach",label:"Language Teacher",icon:"🌐",cat:"Education",skills:["Language Instruction","Curriculum Design","Cultural Competency","TEFL","Assessment","Patience"]},
  {id:"coach",label:"Life Coach",icon:"🎯",cat:"Education",skills:["Coaching Techniques","Goal Setting","Active Listening","Motivation","NLP","Communication","Empathy"]},
  // ── Engineering & Trades ──────────────────────────────
  {id:"civil",label:"Civil Engineer",icon:"🏗️",cat:"Engineering",skills:["AutoCAD","Structural Analysis","Project Management","Revit","Surveying","Materials Testing"]},
  {id:"mech",label:"Mechanical Engineer",icon:"⚙️",cat:"Engineering",skills:["CAD","SolidWorks","FEA","Thermodynamics","Manufacturing","ANSYS","GD&T"]},
  {id:"elec",label:"Electrical Engineer",icon:"⚡",cat:"Engineering",skills:["Circuit Design","PLC","MATLAB","Power Systems","AutoCAD","Embedded Systems","PCB Design"]},
  {id:"chem",label:"Chemical Engineer",icon:"⚗️",cat:"Engineering",skills:["Process Design","HYSYS","Aspen Plus","Chemical Reactions","Safety","Plant Operations"]},
  {id:"petro",label:"Petroleum Engineer",icon:"🛢️",cat:"Engineering",skills:["Reservoir Simulation","Drilling","Production Optimization","Petrel","Eclipse","Well Testing"]},
  {id:"aero",label:"Aerospace Engineer",icon:"✈️",cat:"Engineering",skills:["MATLAB","CFD","Structural Analysis","CAD","Flight Mechanics","Avionics","Propulsion"]},
  {id:"environ",label:"Environmental Engineer",icon:"🌿",cat:"Engineering",skills:["EIA","GIS","Waste Management","AutoCAD","Remediation","Regulatory Compliance"]},
  {id:"marine",label:"Marine Engineer",icon:"⚓",cat:"Engineering",skills:["Ship Systems","Marine Engines","Maintenance","Safety Management","AutoCAD","STCW"]},
  {id:"mining",label:"Mining Engineer",icon:"⛏️",cat:"Engineering",skills:["Mine Planning","Blast Design","AutoCAD","Safety","Ventilation","Ore Processing"]},
  {id:"struct",label:"Structural Engineer",icon:"🏛️",cat:"Engineering",skills:["SAP2000","ETABS","Revit","Load Analysis","AutoCAD","Seismic Design","Steel Design"]},
  {id:"biomed",label:"Biomedical Engineer",icon:"🩺",cat:"Engineering",skills:["Medical Devices","FDA Regulations","MATLAB","CAD","Biomechanics","Quality Systems","R&D"]},
  {id:"electrician",label:"Electrician",icon:"🔌",cat:"Engineering",skills:["Wiring","Electrical Codes","Conduit Installation","Troubleshooting","Safety","Blueprint Reading"]},
  {id:"plumber",label:"Plumber",icon:"🔧",cat:"Engineering",skills:["Pipe Installation","Maintenance","Code Compliance","Blueprint Reading","Problem Solving","Safety"]},
  {id:"hvac",label:"HVAC Technician",icon:"❄️",cat:"Engineering",skills:["HVAC Systems","Refrigerants","Electrical","Troubleshooting","EPA 608","Preventive Maintenance"]},
  {id:"welder",label:"Welder",icon:"🔥",cat:"Engineering",skills:["MIG","TIG","Stick Welding","Blueprint Reading","Safety","Metal Fabrication","Quality Inspection"]},
  {id:"carpenter",label:"Carpenter",icon:"🪚",cat:"Engineering",skills:["Woodworking","Blueprint Reading","Framing","Finishing","Safety","Measurement","Power Tools"]},
  {id:"arch",label:"Architect",icon:"🏛️",cat:"Engineering",skills:["AutoCAD","Revit","SketchUp","Building Codes","Project Management","3D Rendering"]},
  {id:"survey",label:"Land Surveyor",icon:"📏",cat:"Engineering",skills:["Total Station","GPS","AutoCAD","GIS","Boundary Surveying","Topographic Mapping"]},
  {id:"geotech",label:"Geotechnical Engineer",icon:"🪨",cat:"Engineering",skills:["Soil Testing","Foundation Design","AutoCAD","Risk Assessment","Geotechnics"]},
  {id:"indust",label:"Industrial Engineer",icon:"🏭",cat:"Engineering",skills:["Lean Manufacturing","Six Sigma","AutoCAD","Process Improvement","Ergonomics","Time Study"]},
  {id:"mechatronic",label:"Mechatronics Engineer",icon:"🦾",cat:"Engineering",skills:["Robotics","PLC","Sensors","Actuators","MATLAB","CAD","Embedded Systems"]},
  {id:"nuklear",label:"Nuclear Engineer",icon:"☢️",cat:"Engineering",skills:["Nuclear Physics","Radiation Safety","Reactor Design","MATLAB","Regulatory Compliance"]},
  {id:"safety",label:"Health & Safety Officer",icon:"⛑️",cat:"Engineering",skills:["OSHA","Risk Assessment","Safety Training","Incident Investigation","HSE","First Aid"]},
  {id:"quality",label:"Quality Engineer",icon:"✅",cat:"Engineering",skills:["ISO 9001","Six Sigma","Root Cause Analysis","SOPs","Compliance","Statistical Analysis"]},
  // ── Legal & HR ────────────────────────────────────────
  {id:"lawyer",label:"Lawyer/Attorney",icon:"⚖️",cat:"Legal",skills:["Legal Research","Contract Drafting","Litigation","Negotiation","Legal Writing","Client Relations"]},
  {id:"paralegal",label:"Paralegal",icon:"📜",cat:"Legal",skills:["Legal Research","Document Drafting","Case Management","E-Discovery","Legal Writing","Filing"]},
  {id:"compliance",label:"Compliance Officer",icon:"🛡️",cat:"Legal",skills:["Regulatory Compliance","Risk Assessment","Policy Development","AML","KYC","Auditing"]},
  {id:"judge",label:"Judge/Magistrate",icon:"🔨",cat:"Legal",skills:["Legal Analysis","Judicial Writing","Court Procedure","Evidence Evaluation","Impartiality"]},
  {id:"notary",label:"Notary Public",icon:"📋",cat:"Legal",skills:["Document Authentication","Legal Knowledge","Attention to Detail","Record Keeping","Client Service"]},
  {id:"hr",label:"HR Manager",icon:"👥",cat:"HR",skills:["Recruitment","HRIS","Employee Relations","Payroll","Performance Management","Labor Law","Onboarding"]},
  {id:"recruiter",label:"Recruiter",icon:"🔍",cat:"HR",skills:["Sourcing","LinkedIn Recruiter","ATS","Interviewing","Negotiation","Employer Branding","Pipeline Management"]},
  {id:"lnd",label:"L&D Specialist",icon:"📖",cat:"HR",skills:["Training Design","LMS","Facilitation","eLearning","Needs Analysis","Adult Learning","Evaluation"]},
  {id:"compben",label:"Compensation & Benefits Analyst",icon:"💰",cat:"HR",skills:["Job Evaluation","Salary Benchmarking","Benefits Administration","Excel","HRIS","Pay Equity"]},
  {id:"hrbp",label:"HR Business Partner",icon:"🤝",cat:"HR",skills:["Strategic HR","Employee Relations","Talent Management","Coaching","Organizational Development"]},
  {id:"payroll",label:"Payroll Specialist",icon:"💵",cat:"HR",skills:["Payroll Processing","HRIS","Tax Compliance","Excel","Attention to Detail","Confidentiality"]},
  // ── Science & Research ────────────────────────────────
  {id:"biolog",label:"Biologist/Scientist",icon:"🧬",cat:"Science",skills:["Lab Techniques","PCR","CRISPR","Data Analysis","R","Python","Grant Writing","Scientific Writing"]},
  {id:"chemist",label:"Chemist",icon:"⚗️",cat:"Science",skills:["Lab Safety","HPLC","GC-MS","NMR","Data Analysis","QC","Documentation","R&D"]},
  {id:"physicist",label:"Physicist",icon:"⚛️",cat:"Science",skills:["MATLAB","Python","Data Analysis","Simulation","Lab Equipment","Mathematical Modeling"]},
  {id:"geolog",label:"Geologist",icon:"🪨",cat:"Science",skills:["GIS","Rock Identification","ArcGIS","Geochemistry","Field Work","Seismic Interpretation"]},
  {id:"envscient",label:"Environmental Scientist",icon:"🌿",cat:"Science",skills:["GIS","ArcGIS","Data Analysis","EIA","Regulatory Compliance","Field Work"]},
  {id:"forensic",label:"Forensic Scientist",icon:"🔍",cat:"Science",skills:["Evidence Analysis","Chain of Custody","Lab Techniques","Report Writing","Toxicology"]},
  {id:"foodscient",label:"Food Scientist",icon:"🍱",cat:"Science",skills:["Food Safety","HACCP","Sensory Analysis","Product Development","QC","Lab Techniques"]},
  {id:"astro",label:"Astronomer",icon:"🔭",cat:"Science",skills:["Python","MATLAB","Data Analysis","Telescope Operation","Physics","Scientific Writing"]},
  {id:"biotech",label:"Biotechnologist",icon:"🧪",cat:"Science",skills:["Cell Culture","PCR","Bioinformatics","CRISPR","Lab Management","Regulatory Affairs"]},
  {id:"pharmacol",label:"Pharmacologist",icon:"💊",cat:"Science",skills:["Drug Discovery","Clinical Trials","Toxicology","Laboratory Techniques","Statistical Analysis"]},
  // ── Agriculture & Environment ─────────────────────────
  {id:"agro",label:"Agronomist",icon:"🌾",cat:"Agriculture",skills:["Crop Management","Soil Science","GIS","Irrigation","Precision Agriculture","Pest Management"]},
  {id:"farmer",label:"Farm Manager",icon:"🚜",cat:"Agriculture",skills:["Crop Production","Staff Management","Budgeting","Equipment Operation","Supply Chain","Record Keeping"]},
  {id:"forester",label:"Forester",icon:"🌲",cat:"Agriculture",skills:["Forest Management","GIS","Tree Identification","Timber Harvesting","Conservation","Mapping"]},
  {id:"fisheries",label:"Fisheries Officer",icon:"🐟",cat:"Agriculture",skills:["Aquaculture","Fish Species ID","Environmental Monitoring","Regulatory Compliance","Conservation"]},
  {id:"agritech",label:"AgriTech Specialist",icon:"🌱",cat:"Agriculture",skills:["Precision Agriculture","Drone Technology","IoT Sensors","GIS","Data Analysis","Sustainability"]},
  {id:"urban",label:"Urban Planner",icon:"🏙️",cat:"Agriculture",skills:["GIS","Zoning","Land Use","AutoCAD","Community Engagement","Environmental Assessment","Sustainability"]},
  // ── Government & Public Service ───────────────────────
  {id:"civilserv",label:"Civil Servant/Government Officer",icon:"🏛️",cat:"Government",skills:["Policy Analysis","Report Writing","Public Administration","Legislation","Data Analysis"]},
  {id:"diplomat",label:"Diplomat/Foreign Service Officer",icon:"🌐",cat:"Government",skills:["International Relations","Languages","Negotiation","Cultural Competency","Policy Analysis"]},
  {id:"police",label:"Police Officer",icon:"👮",cat:"Government",skills:["Law Enforcement","Investigation","Community Policing","Report Writing","De-escalation"]},
  {id:"military",label:"Military Officer",icon:"🎖️",cat:"Government",skills:["Leadership","Strategic Planning","Operations Management","Crisis Management","Discipline"]},
  {id:"firesafe",label:"Fire Safety Officer",icon:"🚒",cat:"Government",skills:["Fire Suppression","Hazmat","Emergency Response","Risk Assessment","First Aid","Training"]},
  {id:"customs",label:"Customs Officer",icon:"🛂",cat:"Government",skills:["Trade Regulations","Risk Assessment","Investigation","Border Control","Documentation"]},
  {id:"taxoff",label:"Tax Officer/Revenue Agent",icon:"🏦",cat:"Government",skills:["Tax Law","Auditing","Investigation","Financial Analysis","Report Writing","Compliance"]},
  {id:"ambulance",label:"Ambulance Dispatcher",icon:"🚨",cat:"Government",skills:["Emergency Dispatch","Communication","Decision Making","Computer Aided Dispatch","Stress Management"]},
  // ── Media & Creative ──────────────────────────────────
  {id:"journalist",label:"Journalist/Reporter",icon:"📰",cat:"Media",skills:["Investigative Reporting","Interviewing","AP Style","Photography","Fact-Checking"]},
  {id:"editor",label:"Editor",icon:"✏️",cat:"Media",skills:["Proofreading","Style Guides","CMS","Content Strategy","AP Style","SEO","Project Management"]},
  {id:"photog",label:"Photographer",icon:"📷",cat:"Media",skills:["Lightroom","Photoshop","Composition","Lighting","Photo Editing","Client Relations"]},
  {id:"videog",label:"Videographer/Video Editor",icon:"🎥",cat:"Media",skills:["Premiere Pro","Final Cut","DaVinci Resolve","Color Grading","Storytelling","Camera Operation"]},
  {id:"podcast",label:"Podcast Producer",icon:"🎙️",cat:"Media",skills:["Audio Editing","Audacity","Adobe Audition","Content Planning","RSS","Promotion","Interviewing"]},
  {id:"animator",label:"Animator",icon:"🎞️",cat:"Media",skills:["After Effects","Adobe Animate","Blender","Character Animation","Storyboarding","2D/3D","Rigging"]},
  {id:"writer",label:"Writer/Author",icon:"📝",cat:"Media",skills:["Creative Writing","Research","Editing","SEO","Storytelling","Publishing","Content Strategy"]},
  {id:"translator",label:"Translator/Interpreter",icon:"🌐",cat:"Media",skills:["Fluency 2+ Languages","CAT Tools","Localization","Cultural Competency","Proofreading"]},
  {id:"voice",label:"Voice Over Artist",icon:"🎤",cat:"Media",skills:["Voice Acting","Recording Equipment","Audacity","Adobe Audition","Script Reading","Editing"]},
  {id:"musicprod",label:"Music Producer",icon:"🎵",cat:"Media",skills:["Ableton Live","Logic Pro","FL Studio","Mixing","Mastering","Sound Design","Music Theory"]},
  {id:"filmmaker",label:"Film Director/Producer",icon:"🎬",cat:"Media",skills:["Directing","Production Management","Script Analysis","Budgeting","Post-Production","Casting"]},
  {id:"broadcaster",label:"TV/Radio Presenter",icon:"📡",cat:"Media",skills:["Public Speaking","Script Reading","Interviewing","Voice Modulation","Research","Ad-libbing"]},
  {id:"gamedesign",label:"Game Designer",icon:"🕹️",cat:"Media",skills:["Game Mechanics","Unity","Level Design","Prototyping","User Testing","Narrative Design"]},
  {id:"artdir",label:"Art Director",icon:"🖼️",cat:"Media",skills:["Visual Direction","Adobe Suite","Typography","Brand Strategy","Team Leadership","Concept Development"]},
  {id:"creative",label:"Creative Director",icon:"🎨",cat:"Media",skills:["Creative Strategy","Campaign Development","Team Leadership","Brand Vision","Adobe Suite","Storytelling"]},
  // ── Hospitality & Tourism ─────────────────────────────
  {id:"chef",label:"Chef/Cook",icon:"👨‍🍳",cat:"Hospitality",skills:["Culinary Arts","Menu Planning","HACCP","Kitchen Management","Food Safety","Inventory"]},
  {id:"hotel",label:"Hotel Manager",icon:"🏨",cat:"Hospitality",skills:["Revenue Management","Guest Relations","PMS","Budgeting","F&B","Staff Management","OTA"]},
  {id:"tourguide",label:"Tour Guide",icon:"🗺️",cat:"Hospitality",skills:["Local Knowledge","Public Speaking","Foreign Languages","Customer Service","First Aid","Navigation"]},
  {id:"travel",label:"Travel Agent",icon:"✈️",cat:"Hospitality",skills:["GDS (Amadeus/Sabre)","Itinerary Planning","Visa Processing","Client Relations","Booking Systems","Sales"]},
  {id:"event",label:"Event Planner",icon:"🎉",cat:"Hospitality",skills:["Vendor Management","Budgeting","Logistics","Contracts","Marketing","Problem Solving"]},
  {id:"bartender",label:"Bartender",icon:"🍹",cat:"Hospitality",skills:["Mixology","Customer Service","POS Systems","Inventory","Cocktail Knowledge","Cash Handling"]},
  {id:"housekeep",label:"Housekeeping Supervisor",icon:"🧹",cat:"Hospitality",skills:["Quality Control","Team Supervision","Inventory","Time Management","Training","Health & Safety"]},
  {id:"airhost",label:"Flight Attendant",icon:"✈️",cat:"Hospitality",skills:["Safety Procedures","Customer Service","Emergency Response","First Aid","Cultural Sensitivity"]},
  {id:"concierge",label:"Concierge",icon:"🔑",cat:"Hospitality",skills:["Local Knowledge","Customer Service","Problem Solving","Languages","Networking","Reservation Management"]},
  {id:"catering",label:"Catering Manager",icon:"🍽️",cat:"Hospitality",skills:["Menu Planning","Event Coordination","Budgeting","Vendor Relations","Food Safety","Staff Management"]},
  {id:"restaurant",label:"Restaurant Manager",icon:"🍴",cat:"Hospitality",skills:["Food Safety","Staff Management","POS","Inventory","Customer Service","Budgeting","Scheduling"]},
  {id:"somelier",label:"Sommelier",icon:"🍷",cat:"Hospitality",skills:["Wine Knowledge","Food Pairing","Wine Service","Customer Relations","Inventory","Cellar Management"]},
  // ── Retail & E-Commerce ───────────────────────────────
  {id:"retail",label:"Retail Store Manager",icon:"🏪",cat:"Retail",skills:["Inventory Management","Visual Merchandising","POS","Staff Management","Sales Targets","Loss Prevention"]},
  {id:"fashbuy",label:"Fashion Buyer",icon:"🛍️",cat:"Retail",skills:["Trend Analysis","Vendor Negotiation","Inventory Planning","OTB","Excel","Market Research"]},
  {id:"merch",label:"Merchandiser",icon:"🏷️",cat:"Retail",skills:["Product Placement","Planogram","Inventory","Sales Analysis","Visual Merchandising","Retail Analytics"]},
  {id:"amazon",label:"Amazon FBA Seller",icon:"📦",cat:"Retail",skills:["Amazon Seller Central","PPC","Product Research","Inventory","Listing Optimization","Analytics"]},
  {id:"dropship",label:"Dropshipper",icon:"🛒",cat:"Retail",skills:["Shopify","Product Research","Facebook Ads","Customer Service","Supplier Management","Analytics"]},
  // ── Customer Service & Admin ──────────────────────────
  {id:"cs",label:"Customer Support Specialist",icon:"💬",cat:"Admin",skills:["Zendesk","Communication","CRM","Conflict Resolution","Problem Solving","Live Chat"]},
  {id:"callcenter",label:"Call Center Agent",icon:"📞",cat:"Admin",skills:["Active Listening","CRM","Data Entry","Problem Solving","Patience","Escalation Management"]},
  {id:"recept",label:"Receptionist",icon:"🏢",cat:"Admin",skills:["Front Desk","Scheduling","Microsoft Office","Multi-line Phone","Customer Service","Filing"]},
  {id:"va",label:"Virtual Assistant",icon:"💻",cat:"Admin",skills:["Email Management","Scheduling","Asana","Slack","Data Entry","Research","Calendar Management"]},
  {id:"dataentry",label:"Data Entry Specialist",icon:"⌨️",cat:"Admin",skills:["Typing Speed","Accuracy","Excel","Google Sheets","CRM","Attention to Detail","Database"]},
  {id:"admin",label:"Administrative Assistant",icon:"🗂️",cat:"Admin",skills:["Microsoft Office","Scheduling","Communication","Filing","Travel Arrangements","Multitasking"]},
  {id:"offmgr",label:"Office Manager",icon:"🏬",cat:"Admin",skills:["Facilities Management","Vendor Relations","Budgeting","HR Support","Microsoft Office","Event Planning"]},
  {id:"transcrip",label:"Transcriptionist",icon:"🎧",cat:"Admin",skills:["Typing Speed 80+WPM","Active Listening","Accuracy","Medical/Legal Terminology","Confidentiality"]},
  // ── Freelance & Independent ───────────────────────────
  {id:"free",label:"Freelancer",icon:"🚀",cat:"Freelance",skills:["Project Management","Client Relations","Time Tracking","Invoicing","Portfolio","Proposal Writing"]},
  {id:"consult",label:"Independent Consultant",icon:"💡",cat:"Freelance",skills:["Domain Expertise","Client Management","Proposal Writing","Problem Solving","Presentations"]},
  {id:"fiverr",label:"Online Freelancer (Fiverr/Upwork)",icon:"💻",cat:"Freelance",skills:["Gig Economy","Client Communication","Portfolio","Time Management","Niche Expertise"]},
  // ── Sports & Fitness ──────────────────────────────────
  {id:"fitness",label:"Fitness Trainer/Gym Instructor",icon:"💪",cat:"Sports",skills:["Exercise Science","Program Design","Nutrition","CPR","Motivational Coaching","Anatomy"]},
  {id:"athlete",label:"Professional Athlete/Sports Coach",icon:"⚽",cat:"Sports",skills:["Athletic Performance","Team Leadership","Training Programs","Strategy","Sports Psychology"]},
  {id:"physiology",label:"Sports Physiologist",icon:"🏃",cat:"Sports",skills:["Exercise Testing","VO2 Max","Sports Science","Performance Analysis","Nutrition","Rehabilitation"]},
  {id:"sportsman",label:"Sports Manager",icon:"🏆",cat:"Sports",skills:["Athlete Management","Contract Negotiation","Event Planning","Marketing","Sponsorship","Media Relations"]},
  {id:"yoga",label:"Yoga/Pilates Instructor",icon:"🧘",cat:"Sports",skills:["Yoga Techniques","Anatomy","Class Planning","Mindfulness","Client Motivation","CPR"]},
  // ── Real Estate & Property ────────────────────────────
  {id:"realest",label:"Real Estate Agent",icon:"🏠",cat:"Real Estate",skills:["Property Valuation","Negotiation","CRM","Market Analysis","MLS","Contract Management"]},
  {id:"propman",label:"Property Manager",icon:"🏢",cat:"Real Estate",skills:["Lease Administration","Tenant Relations","Maintenance","Budgeting","Compliance","Property Software"]},
  {id:"realestateinv",label:"Real Estate Investor",icon:"🏦",cat:"Real Estate",skills:["Market Analysis","Financial Modeling","Negotiation","Property Valuation","Risk Assessment"]},
  {id:"mortgage",label:"Mortgage Broker",icon:"📋",cat:"Real Estate",skills:["Loan Processing","Financial Analysis","Credit Assessment","Client Relations","Compliance","Negotiation"]},
  // ── Beauty & Personal Care ────────────────────────────
  {id:"makeup",label:"Makeup Artist",icon:"💄",cat:"Beauty",skills:["Makeup Techniques","Color Theory","Skin Care","Client Relations","Product Knowledge","Bridal","Editorial"]},
  {id:"hairdress",label:"Hairdresser/Stylist",icon:"✂️",cat:"Beauty",skills:["Hair Cutting","Coloring","Styling","Chemical Treatments","Client Consultation","Salon Management"]},
  {id:"aesthetician",label:"Aesthetician/Beautician",icon:"💅",cat:"Beauty",skills:["Skin Analysis","Facials","Waxing","Chemical Peels","Product Knowledge","Client Consultation"]},
  {id:"barbering",label:"Barber",icon:"💈",cat:"Beauty",skills:["Haircuts","Shaving","Beard Grooming","Client Relations","Sanitation","Business Management"]},
  {id:"nailtech",label:"Nail Technician",icon:"💅",cat:"Beauty",skills:["Nail Art","Manicure","Pedicure","Acrylics","Gel Nails","Sanitation","Client Service"]},
  // ── Transport & Logistics ─────────────────────────────
  {id:"driver",label:"Professional Driver",icon:"🚗",cat:"Transport",skills:["Defensive Driving","Route Planning","Vehicle Maintenance","Time Management","GPS","Safety"]},
  {id:"shipping",label:"Shipping/Freight Coordinator",icon:"🚢",cat:"Transport",skills:["Freight Forwarding","Customs Documentation","Incoterms","Logistics Software","Import/Export"]},
  {id:"pilot2",label:"Commercial Pilot",icon:"✈️",cat:"Transport",skills:["Flight Operations","Navigation","Instrument Rating","Crew Resource Management","Weather Analysis"]},
  {id:"warehouse",label:"Warehouse Manager",icon:"🏭",cat:"Transport",skills:["Inventory Management","WMS","Team Leadership","Safety","Process Improvement","Forklift"]},
  {id:"dispatcher",label:"Transport Dispatcher",icon:"🗺️",cat:"Transport",skills:["Route Planning","Communication","GPS Software","Problem Solving","Fleet Management","Scheduling"]},
  // ── Other ─────────────────────────────────────────────
  {id:"std",label:"Student/Intern",icon:"🎓",cat:"Other",skills:["Microsoft Office","Research","Teamwork","Communication","Time Management","Critical Thinking"]},
  {id:"ngo",label:"NGO/Non-profit Worker",icon:"❤️",cat:"Other",skills:["Grant Writing","Community Outreach","Fundraising","Program Management","M&E","Reporting"]},
  {id:"security",label:"Security Officer",icon:"🔒",cat:"Other",skills:["Surveillance","Access Control","Report Writing","Emergency Response","First Aid","Physical Security"]},
  {id:"artist",label:"Artist",icon:"🎨",cat:"Other",skills:["Drawing","Painting","Adobe Suite","Portfolio Management","Client Relations","Art Direction"]},
  {id:"pastor",label:"Pastor/Religious Leader",icon:"✝️",cat:"Other",skills:["Public Speaking","Counseling","Community Leadership","Event Organization","Writing","Team Management"]},
  {id:"influencer2",label:"Social Media Influencer",icon:"⭐",cat:"Other",skills:["Content Creation","Brand Partnerships","Audience Growth","Analytics","Video Production","Storytelling"]},
  {id:"streamer",label:"Live Streamer/Content Creator",icon:"🎮",cat:"Other",skills:["Video Production","Community Management","Platform Analytics","Brand Deals","Editing","Engagement"]},
  {id:"careergiver",label:"Caregiver",icon:"🤗",cat:"Other",skills:["Personal Care","Patience","First Aid","Medication Management","Emotional Support","Communication"]},
  {id:"interpreter",label:"Sign Language Interpreter",icon:"🤟",cat:"Other",skills:["ASL/BSL","Interpreting","Cultural Competency","Attention to Detail","Communication","Professionalism"]},
  {id:"curator",label:"Museum Curator",icon:"🏛️",cat:"Other",skills:["Art History","Collection Management","Research","Exhibition Planning","Grant Writing","Public Programming"]},
  {id:"archaeo",label:"Archaeologist",icon:"🏺",cat:"Other",skills:["Excavation","Artifact Analysis","GIS","Research","Report Writing","Field Work","Carbon Dating"]},
  {id:"pilot3",label:"Drone Operator",icon:"🚁",cat:"Other",skills:["Drone Operation","FAA/CAA Regulations","Aerial Photography","GIS Mapping","Maintenance","Post-processing"]},
  {id:"custom",label:"Other (Custom Career)",icon:"✏️",cat:"Other",skills:[]},
  // ── More Technology ─────────────────────────────────────
  {id:"cto",label:"Chief Technology Officer",icon:"🏢",cat:"Technology",skills:["Tech Strategy","Leadership","Architecture","Budgeting","Roadmapping","Team Building"]},
  {id:"ciso",label:"Cybersecurity Officer (CISO)",icon:"🔐",cat:"Technology",skills:["Information Security","Risk Management","Compliance","SIEM","Incident Response","CISSP"]},
  {id:"blockchain",label:"Blockchain Developer",icon:"⛓️",cat:"Technology",skills:["Solidity","Ethereum","Web3.js","Smart Contracts","DeFi","NFTs","Rust","Hardhat"]},
  {id:"iot",label:"IoT Engineer",icon:"📡",cat:"Technology",skills:["Embedded C","Arduino","MQTT","AWS IoT","Python","Edge Computing","Networking"]},
  {id:"ar",label:"AR/VR Developer",icon:"🥽",cat:"Technology",skills:["Unity","ARKit","ARCore","WebXR","C#","Oculus SDK","Spatial Computing"]},
  {id:"embed",label:"Embedded Systems Engineer",icon:"🔌",cat:"Technology",skills:["C","C++","RTOS","Microcontrollers","FPGA","PCB Design","Protocols"]},
  {id:"neteng",label:"Network Engineer",icon:"🌐",cat:"Technology",skills:["Cisco","TCP/IP","BGP","OSPF","VLAN","Firewalls","VPN","LAN/WAN"]},
  {id:"it",label:"IT Support Specialist",icon:"🛠️",cat:"Technology",skills:["Troubleshooting","Windows","macOS","Networking","Active Directory","Help Desk","O365"]},
  {id:"scrum",label:"Scrum Master",icon:"🏃",cat:"Technology",skills:["Agile","Scrum","Jira","Sprint Planning","Retrospectives","Kanban","Coaching"]},
  {id:"qa",label:"QA Engineer",icon:"✅",cat:"Technology",skills:["Selenium","Jest","Cypress","Manual Testing","Automation","API Testing","Test Planning"]},
  {id:"dba",label:"Database Administrator",icon:"🗃️",cat:"Technology",skills:["SQL","PostgreSQL","MySQL","Oracle","MongoDB","Performance Tuning","Backup & Recovery"]},
  {id:"sysadmin",label:"System Administrator",icon:"🖥️",cat:"Technology",skills:["Linux","Windows Server","Networking","Active Directory","Bash Scripting","VMware"]},
  {id:"bi",label:"Business Intelligence Analyst",icon:"📈",cat:"Technology",skills:["Power BI","Tableau","SQL","Excel","DAX","Data Modeling","ETL","KPIs"]},
  {id:"fullstack",label:"Full Stack Developer",icon:"🔧",cat:"Technology",skills:["React","Node.js","Python","SQL","NoSQL","Git","AWS","Docker","TypeScript"]},
  {id:"game",label:"Game Developer",icon:"🎮",cat:"Technology",skills:["Unity","Unreal Engine","C#","C++","Game Design","Physics","OpenGL","Animation"]},
  {id:"pentest",label:"Penetration Tester",icon:"🕵️",cat:"Technology",skills:["Kali Linux","Metasploit","Burp Suite","OWASP","Network Security","Ethical Hacking"]},
  {id:"cloud",label:"Cloud Architect",icon:"☁️",cat:"Technology",skills:["AWS","Azure","GCP","Terraform","Kubernetes","Serverless","Microservices","Security"]},
  {id:"mlops",label:"MLOps Engineer",icon:"⚙️",cat:"Technology",skills:["Python","Kubernetes","Docker","MLflow","CI/CD","Monitoring","Data Pipelines"]},
  {id:"mobile",label:"Mobile App Developer",icon:"📱",cat:"Technology",skills:["React Native","Flutter","Swift","Kotlin","iOS","Android","Firebase","REST APIs"]},
  {id:"fe",label:"Frontend Developer",icon:"🖥️",cat:"Technology",skills:["HTML","CSS","JavaScript","React","Vue.js","TypeScript","Tailwind","Webpack"]},
  {id:"be",label:"Backend Developer",icon:"⚙️",cat:"Technology",skills:["Node.js","Python","Java","Go","PostgreSQL","MongoDB","Redis","Docker","AWS"]},
  {id:"devops",label:"DevOps Engineer",icon:"🔄",cat:"Technology",skills:["Docker","Kubernetes","AWS","CI/CD","Jenkins","Terraform","Linux","Git","Ansible"]},
  {id:"ds",label:"Data Scientist",icon:"🔬",cat:"Technology",skills:["Python","R","Machine Learning","Statistics","SQL","TensorFlow","Data Visualization","A/B Testing"]},
  {id:"de",label:"Data Engineer",icon:"🗄️",cat:"Technology",skills:["Python","Spark","Kafka","Airflow","SQL","AWS","dbt","Hadoop","ETL","Data Warehousing"]},
  {id:"pm",label:"Product Manager",icon:"📋",cat:"Technology",skills:["Roadmapping","Jira","User Stories","A/B Testing","Analytics","Stakeholder Management","PRDs","Agile"]},
  // ── More Design ─────────────────────────────────────────
  {id:"brand",label:"Brand Designer",icon:"✨",cat:"Design",skills:["Brand Identity","Logo Design","Adobe Suite","Typography","Style Guides","Figma","Color Theory"]},
  {id:"3d",label:"3D Artist",icon:"🎲",cat:"Design",skills:["Blender","Maya","3ds Max","ZBrush","Texturing","Rigging","Rendering","Cinema 4D"]},
  {id:"webdes",label:"Web Designer",icon:"🌐",cat:"Design",skills:["HTML","CSS","Figma","WordPress","Responsive Design","Webflow","Adobe XD"]},
  {id:"illustr",label:"Illustrator",icon:"✏️",cat:"Design",skills:["Adobe Illustrator","Procreate","Character Design","Typography","Digital Art","Print Design"]},
  {id:"fashiondes",label:"Fashion Designer",icon:"👗",cat:"Design",skills:["Sketching","Pattern Making","Fabric Knowledge","Trend Analysis","Sewing","CAD","Portfolio"]},
  {id:"intdes",label:"Interior Designer",icon:"🏠",cat:"Design",skills:["AutoCAD","SketchUp","3D Rendering","Space Planning","Materials","Color Theory","Project Management"]},
  {id:"pkgdes",label:"Packaging Designer",icon:"📦",cat:"Design",skills:["Adobe Illustrator","Dieline Design","Typography","Branding","Print Production","3D Mockups"]},
  {id:"motiondes",label:"Motion Designer",icon:"🎬",cat:"Design",skills:["After Effects","Premiere Pro","Cinema 4D","Animation","Video Editing","Lottie","Storyboarding"]},
  // ── More Business ─────────────────────────────────────────
  {id:"ceo",label:"Chief Executive Officer",icon:"👔",cat:"Business",skills:["Leadership","Strategic Planning","Financial Management","Fundraising","Stakeholder Management"]},
  {id:"coo",label:"Chief Operating Officer",icon:"🏗️",cat:"Business",skills:["Operations Strategy","Process Improvement","Leadership","KPIs","Cross-functional Management"]},
  {id:"strat",label:"Strategy Consultant",icon:"♟️",cat:"Business",skills:["Business Strategy","Financial Modeling","Market Analysis","Problem Solving","PowerPoint","Excel"]},
  {id:"mgmt",label:"Management Consultant",icon:"🏢",cat:"Business",skills:["Problem Solving","Change Management","Stakeholder Management","Data Analysis","PowerPoint"]},
  {id:"entrep",label:"Entrepreneur",icon:"🚀",cat:"Business",skills:["Business Development","Fundraising","Leadership","Product Management","Marketing","Financial Planning"]},
  {id:"exec",label:"Executive Assistant",icon:"👔",cat:"Business",skills:["Calendar Management","Travel Planning","Microsoft Office","Communication","Event Planning","CRM"]},
  {id:"supchain",label:"Supply Chain Manager",icon:"🔗",cat:"Business",skills:["Logistics","SAP","Inventory Management","Procurement","Vendor Management","ERP","Forecasting"]},
  {id:"procure",label:"Procurement Specialist",icon:"🛒",cat:"Business",skills:["Vendor Management","Contract Negotiation","SAP","Excel","Cost Analysis","RFPs","Supply Chain"]},
  {id:"logist",label:"Logistics Coordinator",icon:"🚚",cat:"Business",skills:["Supply Chain","Inventory","ERP","Shipping Coordination","Excel","Customs","Communication"]},
  {id:"quality",label:"Quality Assurance Manager",icon:"✅",cat:"Business",skills:["ISO 9001","Six Sigma","Process Auditing","Root Cause Analysis","SOPs","Compliance"]},
  {id:"bizdev",label:"Business Development Manager",icon:"🌱",cat:"Business",skills:["Lead Generation","Networking","Proposal Writing","Negotiation","Market Research","CRM"]},
  {id:"franchise",label:"Franchise Manager",icon:"🏪",cat:"Business",skills:["Operations","Training","Brand Standards","Financial Analysis","Multi-unit Management"]},
  {id:"mktres",label:"Market Research Analyst",icon:"🔭",cat:"Business",skills:["SPSS","Excel","Survey Design","Focus Groups","Data Analysis","Tableau","Consumer Insights"]},
  // ── More Sales & Marketing ────────────────────────────────
  {id:"salesm",label:"Sales Manager",icon:"📈",cat:"Sales",skills:["Team Leadership","CRM","Salesforce","Forecasting","KPIs","Coaching","B2B Sales","Territory Management"]},
  {id:"acc",label:"Account Manager",icon:"🤝",cat:"Sales",skills:["Client Relations","CRM","Upselling","Contract Management","Salesforce","KPIs","Retention"]},
  {id:"affiliate",label:"Affiliate Marketing Manager",icon:"🔗",cat:"Marketing",skills:["Affiliate Networks","CPA","Analytics","Partnerships","Commission Structures","ROI Optimization"]},
  {id:"emailmkt",label:"Email Marketing Specialist",icon:"✉️",cat:"Marketing",skills:["Mailchimp","Klaviyo","Segmentation","A/B Testing","Copywriting","HTML","Analytics","Automation"]},
  {id:"growth",label:"Growth Hacker",icon:"📊",cat:"Marketing",skills:["A/B Testing","Analytics","SEO","Paid Ads","Funnel Optimization","SQL","Python","User Acquisition"]},
  {id:"influ",label:"Influencer Marketing Manager",icon:"⭐",cat:"Marketing",skills:["Campaign Management","Analytics","Social Media","Content Strategy","ROI Tracking","Contract Negotiation"]},
  {id:"ecom",label:"E-Commerce Manager",icon:"🛍️",cat:"Marketing",skills:["Shopify","WooCommerce","Google Analytics","Amazon FBA","SEO","Email Marketing","Paid Ads"]},
  {id:"pr",label:"Public Relations Specialist",icon:"📰",cat:"Marketing",skills:["Media Relations","Press Releases","Crisis Management","Brand Management","Social Media","Writing"]},
  {id:"brandmgr",label:"Brand Manager",icon:"💡",cat:"Marketing",skills:["Brand Strategy","Market Research","Campaign Management","Analytics","Consumer Insights","Agency Management"]},
  // ── More Healthcare ────────────────────────────────────────
  {id:"midwife",label:"Midwife",icon:"👶",cat:"Healthcare",skills:["Prenatal Care","Labor Support","Postnatal Care","Emergency Obstetrics","Patient Education"]},
  {id:"labtech",label:"Laboratory Technician",icon:"🔬",cat:"Healthcare",skills:["Sample Analysis","LIMS","Quality Control","Microscopy","PCR","Safety Protocols"]},
  {id:"radtech",label:"Radiographer",icon:"🩻",cat:"Healthcare",skills:["CT Scan","MRI","X-ray","PACS","Patient Positioning","Radiation Safety","DICOM"]},
  {id:"medrecord",label:"Medical Records Officer",icon:"📂",cat:"Healthcare",skills:["ICD Coding","EMR Systems","HIPAA","Data Entry","Medical Terminology","Patient Privacy"]},
  {id:"optom",label:"Optometrist",icon:"👁️",cat:"Healthcare",skills:["Eye Examination","Prescription Writing","Contact Lenses","Ophthalmic Instruments","Patient Education"]},
  {id:"nutrition",label:"Nutritionist/Dietitian",icon:"🥗",cat:"Healthcare",skills:["Meal Planning","Clinical Nutrition","Patient Counseling","Medical Nutrition Therapy","Documentation"]},
  {id:"mentalh",label:"Mental Health Counselor",icon:"🧘",cat:"Healthcare",skills:["CBT","Crisis Intervention","Case Management","HIPAA","Empathy","Group Therapy"]},
  {id:"paramedic",label:"Paramedic/EMT",icon:"🚑",cat:"Healthcare",skills:["Emergency Care","BLS","ACLS","IV Therapy","Patient Assessment","Trauma Care","CPR"]},
  {id:"pubhealth",label:"Public Health Officer",icon:"🌍",cat:"Healthcare",skills:["Epidemiology","Health Education","Disease Surveillance","Data Analysis","Community Outreach"]},
  {id:"occup",label:"Occupational Therapist",icon:"🖐️",cat:"Healthcare",skills:["Functional Assessment","Rehabilitation","Assistive Technology","Home Modifications","ADLs"]},
  {id:"speecht",label:"Speech Therapist",icon:"🗣️",cat:"Healthcare",skills:["Speech Assessment","Dysphagia","Language Disorders","AAC","Therapy Planning","Patient Education"]},
  {id:"pharmtech",label:"Pharmacy Technician",icon:"💊",cat:"Healthcare",skills:["Drug Dispensing","Inventory Management","Insurance Processing","Patient Service","Compliance"]},
  {id:"biomedeng",label:"Biomedical Engineer",icon:"🩺",cat:"Engineering",skills:["Medical Devices","FDA Regulations","MATLAB","CAD","Signal Processing","Biomechanics","R&D"]},
  {id:"veterin",label:"Veterinarian",icon:"🐾",cat:"Healthcare",skills:["Animal Surgery","Diagnosis","Pharmacology","Patient Care","Anesthesia","Lab Analysis","Client Communication"]},
  {id:"swrk",label:"Social Worker",icon:"🤲",cat:"Healthcare",skills:["Case Management","Crisis Intervention","Community Resources","Advocacy","Counseling","HIPAA"]},
  // ── More Education ─────────────────────────────────────────
  {id:"principal",label:"School Principal",icon:"🏫",cat:"Education",skills:["Educational Leadership","Staff Management","Curriculum Oversight","Budgeting","Policy"]},
  {id:"counsel",label:"School Counselor",icon:"🧑‍💼",cat:"Education",skills:["Career Counseling","Academic Planning","Crisis Intervention","Student Advocacy","FERPA"]},
  {id:"elearn",label:"E-Learning Developer",icon:"💻",cat:"Education",skills:["Articulate Storyline","LMS","Instructional Design","SCORM","Video Production"]},
  {id:"tutor",label:"Private Tutor",icon:"📖",cat:"Education",skills:["Subject Matter Expertise","Lesson Planning","Patience","Communication","Assessment"]},
  {id:"librarian",label:"Librarian",icon:"📗",cat:"Education",skills:["Cataloging","Research Assistance","Library Systems","Information Literacy","Community Programs"]},
  {id:"speceduc",label:"Special Education Teacher",icon:"💛",cat:"Education",skills:["IEP Development","Behavioral Management","Adaptive Instruction","Assessment","Assistive Technology"]},
  {id:"earlyc",label:"Early Childhood Educator",icon:"🧒",cat:"Education",skills:["Child Development","Play-Based Learning","Classroom Management","Parent Communication"]},
  {id:"instdes",label:"Instructional Designer",icon:"📐",cat:"Education",skills:["ADDIE","Articulate","Storyboarding","LMS Administration","Graphic Design","Adult Learning"]},
  {id:"academicdean",label:"Academic Dean",icon:"🎓",cat:"Education",skills:["Academic Planning","Faculty Management","Curriculum Development","Accreditation","Budgeting"]},
  // ── More Engineering ─────────────────────────────────────
  {id:"chem",label:"Chemical Engineer",icon:"⚗️",cat:"Engineering",skills:["Process Design","HYSYS","Aspen Plus","Safety","Plant Operations","Quality Control","Six Sigma"]},
  {id:"petro",label:"Petroleum Engineer",icon:"🛢️",cat:"Engineering",skills:["Reservoir Simulation","Drilling","Production Optimization","Petrel","Eclipse","Well Testing","HSE"]},
  {id:"aero",label:"Aerospace Engineer",icon:"✈️",cat:"Engineering",skills:["MATLAB","CFD","Structural Analysis","CAD","Flight Mechanics","Avionics","Propulsion"]},
  {id:"environ",label:"Environmental Engineer",icon:"🌿",cat:"Engineering",skills:["Environmental Impact Assessment","GIS","Waste Management","AutoCAD","Remediation","Regulatory Compliance"]},
  {id:"marine",label:"Marine Engineer",icon:"⚓",cat:"Engineering",skills:["Ship Systems","Marine Engines","Maintenance","Safety Management","AutoCAD","Hydraulics","STCW"]},
  {id:"mining",label:"Mining Engineer",icon:"⛏️",cat:"Engineering",skills:["Mine Planning","Blast Design","Surpac","AutoCAD","Geotechnics","Safety","Ventilation"]},
  {id:"struct",label:"Structural Engineer",icon:"🏛️",cat:"Engineering",skills:["SAP2000","ETABS","Revit","Load Analysis","Foundation Design","AutoCAD","Steel Design"]},
  {id:"electrician",label:"Electrician",icon:"⚡",cat:"Engineering",skills:["Wiring","Electrical Codes","Conduit Installation","Troubleshooting","Safety","Blueprint Reading"]},
  {id:"plumber",label:"Plumber",icon:"🔧",cat:"Engineering",skills:["Pipe Installation","Maintenance","Code Compliance","Blueprint Reading","Problem Solving","Soldering"]},
  {id:"hvac",label:"HVAC Technician",icon:"❄️",cat:"Engineering",skills:["HVAC Systems","Refrigerants","Electrical","Troubleshooting","EPA 608","Preventive Maintenance"]},
  {id:"welder",label:"Welder",icon:"🔥",cat:"Engineering",skills:["MIG","TIG","Stick Welding","Blueprint Reading","Safety","Metal Fabrication","Quality Inspection"]},
  {id:"carp",label:"Carpenter",icon:"🪚",cat:"Engineering",skills:["Woodworking","Blueprint Reading","Framing","Finishing","Safety","Measurement","Power Tools","Construction"]},
  {id:"survey",label:"Land Surveyor",icon:"📏",cat:"Engineering",skills:["Total Station","GPS","AutoCAD","GIS","Boundary Surveying","Data Collection","Topographic Mapping"]},
  {id:"reneweng",label:"Renewable Energy Engineer",icon:"🌱",cat:"Engineering",skills:["Solar PV","Wind Energy","Energy Storage","Grid Integration","Sustainability","AutoCAD"]},
  // ── Legal & HR ────────────────────────────────────────────
  {id:"paralegal",label:"Paralegal",icon:"📜",cat:"Legal",skills:["Legal Research","Document Drafting","Case Management","E-Discovery","Legal Writing","Filing","Billing"]},
  {id:"compliance",label:"Compliance Officer",icon:"🛡️",cat:"Legal",skills:["Regulatory Compliance","Risk Assessment","Policy Development","AML","KYC","Auditing","Training"]},
  {id:"lnd",label:"L&D Specialist",icon:"📖",cat:"HR",skills:["Training Design","LMS","Facilitation","eLearning","Needs Analysis","Adult Learning","Evaluation"]},
  {id:"hrbp",label:"HR Business Partner",icon:"🤝",cat:"HR",skills:["Strategic HR","Employee Relations","Talent Management","Coaching","Organizational Development","Labor Law"]},
  {id:"ehr",label:"Employee Relations Specialist",icon:"👥",cat:"HR",skills:["Conflict Resolution","Investigations","Policy Development","Labor Law","Mediation","Documentation"]},
  // ── More Media ────────────────────────────────────────────
  {id:"editor",label:"Editor",icon:"✏️",cat:"Media",skills:["Proofreading","Style Guides","CMS","Content Strategy","AP Style","SEO","Project Management"]},
  {id:"writer",label:"Writer/Author",icon:"📝",cat:"Media",skills:["Creative Writing","Research","Editing","SEO","Storytelling","Publishing","Content Strategy"]},
  {id:"transla",label:"Translator/Interpreter",icon:"🌐",cat:"Media",skills:["Fluency in 2+ Languages","CAT Tools","Localization","Cultural Competency","Proofreading"]},
  {id:"voice",label:"Voice Over Artist",icon:"🎤",cat:"Media",skills:["Voice Acting","Recording Equipment","Audacity","Adobe Audition","Script Reading","Microphone Technique"]},
  {id:"gamedesign",label:"Game Designer",icon:"🕹️",cat:"Media",skills:["Game Mechanics","Unity","Level Design","Prototyping","Narrative Design","Balance Testing"]},
  {id:"musicprod",label:"Music Producer",icon:"🎵",cat:"Media",skills:["Ableton Live","Logic Pro","FL Studio","Mixing","Mastering","Sound Design","Music Theory"]},
  {id:"filmmaker",label:"Film Director/Producer",icon:"🎬",cat:"Media",skills:["Directing","Production Management","Script Analysis","Budgeting","Post-Production","Casting"]},
  {id:"animator",label:"Animator",icon:"🎞️",cat:"Media",skills:["After Effects","Adobe Animate","Blender","Character Animation","Storyboarding","2D/3D","Rigging"]},
  {id:"screenwriter",label:"Screenwriter",icon:"📽️",cat:"Media",skills:["Screenwriting","Final Draft","Story Structure","Character Development","Dialogue","Script Coverage"]},
  // ── More Hospitality ──────────────────────────────────────
  {id:"tourguide",label:"Tour Guide",icon:"🗺️",cat:"Hospitality",skills:["Local Knowledge","Public Speaking","Customer Service","First Aid","Storytelling","Navigation"]},
  {id:"travel",label:"Travel Agent",icon:"✈️",cat:"Hospitality",skills:["GDS Amadeus/Sabre","Itinerary Planning","Visa Processing","Client Relations","Booking Systems"]},
  {id:"bartender",label:"Bartender",icon:"🍹",cat:"Hospitality",skills:["Mixology","Customer Service","POS Systems","Inventory","Cocktail Knowledge","Cash Handling"]},
  {id:"airhost",label:"Flight Attendant",icon:"🛫",cat:"Hospitality",skills:["Safety Procedures","Customer Service","Emergency Response","First Aid","Cultural Sensitivity"]},
  {id:"concierge",label:"Concierge",icon:"🔑",cat:"Hospitality",skills:["Local Knowledge","Customer Service","Problem Solving","Languages","Networking","Reservation Management"]},
  {id:"sommelier",label:"Sommelier",icon:"🍷",cat:"Hospitality",skills:["Wine Knowledge","Pairing","Cellar Management","Customer Service","Tasting","Purchasing","WSET"]},
  // ── Agriculture & Science ──────────────────────────────────
  {id:"agro",label:"Agronomist",icon:"🌾",cat:"Agriculture",skills:["Crop Management","Soil Science","Pesticides","GIS","Irrigation","Data Analysis","Precision Agriculture"]},
  {id:"farmer",label:"Farm Manager",icon:"🚜",cat:"Agriculture",skills:["Crop Production","Staff Management","Budgeting","Equipment Operation","Supply Chain","Pest Management"]},
  {id:"forester",label:"Forester",icon:"🌲",cat:"Agriculture",skills:["Forest Management","GIS","Tree Identification","Timber Harvesting","Conservation","Environmental Compliance"]},
  {id:"biolog",label:"Biologist",icon:"🧬",cat:"Science",skills:["Lab Techniques","PCR","CRISPR","Data Analysis","R","Python","Grant Writing","Scientific Writing"]},
  {id:"chemist",label:"Chemist",icon:"⚗️",cat:"Science",skills:["Lab Safety","HPLC","GC-MS","NMR","Data Analysis","QC","Documentation","R&D"]},
  {id:"physicist",label:"Physicist",icon:"⚛️",cat:"Science",skills:["MATLAB","Python","Data Analysis","Simulation","Lab Equipment","Mathematical Modeling","Research"]},
  {id:"geolog",label:"Geologist",icon:"🪨",cat:"Science",skills:["GIS","Rock Identification","ArcGIS","Geochemistry","Field Work","Seismic Interpretation","Report Writing"]},
  {id:"foodscient",label:"Food Scientist",icon:"🍱",cat:"Science",skills:["Food Safety","HACCP","Sensory Analysis","Product Development","QC","Regulatory Compliance","R&D"]},
  {id:"forensic",label:"Forensic Scientist",icon:"🔍",cat:"Science",skills:["Evidence Analysis","Chain of Custody","Lab Techniques","Report Writing","DNA Analysis","Toxicology"]},
  {id:"astro",label:"Astronomer",icon:"🔭",cat:"Science",skills:["Python","MATLAB","Data Analysis","Telescope Operation","Physics","Mathematical Modeling","Research"]},
  // ── Government ────────────────────────────────────────────
  {id:"civilserv",label:"Civil Servant",icon:"🏛️",cat:"Government",skills:["Policy Analysis","Report Writing","Public Administration","Stakeholder Engagement","Data Analysis"]},
  {id:"diplomat",label:"Diplomat",icon:"🌐",cat:"Government",skills:["International Relations","Languages","Negotiation","Cultural Competency","Report Writing","Policy Analysis"]},
  {id:"police",label:"Police Officer",icon:"👮",cat:"Government",skills:["Law Enforcement","Investigation","Community Policing","Report Writing","De-escalation","Physical Fitness"]},
  {id:"military",label:"Military Officer",icon:"🎖️",cat:"Government",skills:["Leadership","Strategic Planning","Operations Management","Team Building","Crisis Management"]},
  {id:"planner",label:"Urban Planner",icon:"🏙️",cat:"Government",skills:["GIS","Zoning","Land Use","AutoCAD","Community Engagement","Environmental Assessment","Policy"]},
  {id:"firefighter",label:"Firefighter",icon:"🔥",cat:"Government",skills:["Fire Suppression","Emergency Medical","Physical Fitness","Teamwork","Safety Procedures","Equipment Operation"]},
  // ── Retail ────────────────────────────────────────────────
  {id:"retail",label:"Retail Store Manager",icon:"🏪",cat:"Retail",skills:["Inventory Management","Visual Merchandising","POS","Staff Management","Sales Targets","Loss Prevention"]},
  {id:"fashbuy",label:"Fashion Buyer",icon:"👗",cat:"Retail",skills:["Trend Analysis","Vendor Negotiation","Inventory Planning","OTB","Excel","Market Research"]},
  {id:"ecomm",label:"E-Commerce Specialist",icon:"🛍️",cat:"Retail",skills:["Shopify","WooCommerce","SEO","Product Listing","Analytics","Customer Service","Logistics"]},
  {id:"stylist",label:"Personal Stylist",icon:"💅",cat:"Retail",skills:["Fashion Knowledge","Color Theory","Body Types","Client Relations","Trend Forecasting","Visual Merchandising"]},
  // ── Other specialties ─────────────────────────────────────
  {id:"lifecoach",label:"Life Coach",icon:"🌟",cat:"Other",skills:["Motivational Coaching","Active Listening","Goal Setting","Communication","Empathy","NLP","Business Development"]},
  {id:"makeup",label:"Makeup Artist",icon:"💄",cat:"Other",skills:["Makeup Techniques","Color Theory","Skin Care","Client Relations","Product Knowledge","Bridal","Editorial"]},
  {id:"barber",label:"Barber/Hair Stylist",icon:"💇",cat:"Other",skills:["Hair Cutting","Coloring","Client Service","Styling","Sanitation","Retail Sales","Trend Awareness"]},
  {id:"pilotcomm",label:"Commercial Pilot",icon:"✈️",cat:"Other",skills:["Flight Operations","Navigation","Instrument Rating","Crew Resource Management","Safety Management"]},
  {id:"deliverydriv",label:"Delivery Driver",icon:"📦",cat:"Other",skills:["Route Optimization","GPS Navigation","Time Management","Customer Service","Vehicle Maintenance"]},
  {id:"wedplan",label:"Wedding Planner",icon:"💒",cat:"Other",skills:["Vendor Management","Budget Planning","Timeline Management","Client Relations","Negotiation","Problem Solving"]},
  {id:"gencontract",label:"General Contractor",icon:"🔨",cat:"Other",skills:["Project Management","Subcontractor Management","Estimating","Building Codes","Safety","Blueprint Reading"]},
  {id:"animaltrainer",label:"Animal Trainer",icon:"🐕",cat:"Other",skills:["Behavior Modification","Positive Reinforcement","Animal Psychology","Safety","Client Education"]},
  {id:"dronepilot",label:"Drone Operator",icon:"🚁",cat:"Other",skills:["Drone Operation","FAA/CAA Regulations","Aerial Photography","GIS Mapping","Maintenance"]},
  {id:"slinterp",label:"Sign Language Interpreter",icon:"🤟",cat:"Other",skills:["ASL/BSL","Interpreting","Cultural Competency","Attention to Detail","Communication"]},
  {id:"caregiver",label:"Caregiver",icon:"🤗",cat:"Other",skills:["Personal Care","Patience","First Aid","Medication Management","Emotional Support","Communication"]},
  {id:"curator",label:"Museum Curator",icon:"🏛️",cat:"Other",skills:["Art History","Collection Management","Research","Exhibition Planning","Grant Writing","Public Programming"]},
  {id:"archaeo",label:"Archaeologist",icon:"🏺",cat:"Other",skills:["Excavation","Artifact Analysis","GIS","Research","Report Writing","Field Work","Carbon Dating"]},
  {id:"taxidriver",label:"Rideshare/Taxi Driver",icon:"🚕",cat:"Other",skills:["Customer Service","Navigation","Vehicle Maintenance","Time Management","Communication","Safety"]},
];

// ─── RESUME TEMPLATES

// ─── RESUME TEMPLATES ─────────────────────────────────────
// Layout types: "classic" = full header | "sidebar" = left sidebar | "split" = two-column | "modern" = top banner | "elegant" = centered
const TEMPLATES = [
  // ── Classic layouts (full-width header) ──────────────────
  {id:"navy",    name:"Navy Pro",    layout:"classic",  headerBg:"#1e3a5f", headerText:"#ffffff", accent:"#3b82f6", body:"#ffffff", bodyText:"#1e293b", muted:"#64748b"},
  {id:"slate",   name:"Slate",       layout:"classic",  headerBg:"#1e293b", headerText:"#ffffff", accent:"#94a3b8", body:"#f8fafc", bodyText:"#1e293b", muted:"#64748b"},
  {id:"crimson", name:"Crimson",     layout:"classic",  headerBg:"#7f1d1d", headerText:"#ffffff", accent:"#dc2626", body:"#fff5f5", bodyText:"#1c1917", muted:"#b91c1c"},
  {id:"forest",  name:"Forest",      layout:"classic",  headerBg:"#14532d", headerText:"#ffffff", accent:"#16a34a", body:"#f0fdf4", bodyText:"#14532d", muted:"#15803d"},
  {id:"ocean",   name:"Ocean",       layout:"classic",  headerBg:"#0c4a6e", headerText:"#ffffff", accent:"#0284c7", body:"#f0f9ff", bodyText:"#0f172a", muted:"#0369a1"},
  {id:"gold",    name:"Executive",   layout:"classic",  headerBg:"#78350f", headerText:"#ffffff", accent:"#d97706", body:"#fffbeb", bodyText:"#1c1917", muted:"#92400e"},
  {id:"rose",    name:"Rose",        layout:"classic",  headerBg:"#881337", headerText:"#ffffff", accent:"#e11d48", body:"#fff1f2", bodyText:"#1c1917", muted:"#be123c"},
  {id:"dark",    name:"Dark Mode",   layout:"classic",  headerBg:"#0f172a", headerText:"#e2e8f0", accent:"#6366f1", body:"#1e293b", bodyText:"#e2e8f0", muted:"#94a3b8"},
  {id:"mono",    name:"Minimal",     layout:"classic",  headerBg:"#171717", headerText:"#ffffff", accent:"#404040", body:"#ffffff", bodyText:"#171717", muted:"#525252"},
  {id:"violet",  name:"Violet",      layout:"classic",  headerBg:"#4c1d95", headerText:"#ffffff", accent:"#7c3aed", body:"#faf5ff", bodyText:"#1e1b4b", muted:"#6d28d9"},
  // ── Sidebar layouts (left column for contact/skills) ─────
  {id:"sidebar-navy",   name:"Sidebar Navy",   layout:"sidebar", sidebarBg:"#1e3a5f", sidebarText:"#ffffff", accent:"#3b82f6",  body:"#ffffff",  bodyText:"#1e293b", muted:"#94a3b8"},
  {id:"sidebar-violet", name:"Sidebar Violet", layout:"sidebar", sidebarBg:"#4c1d95", sidebarText:"#ffffff", accent:"#7c3aed",  body:"#faf5ff",  bodyText:"#2e1065", muted:"#a78bfa"},
  {id:"sidebar-forest", name:"Sidebar Forest", layout:"sidebar", sidebarBg:"#14532d", sidebarText:"#ffffff", accent:"#16a34a",  body:"#f0fdf4",  bodyText:"#14532d", muted:"#4ade80"},
  {id:"sidebar-dark",   name:"Sidebar Dark",   layout:"sidebar", sidebarBg:"#0f172a", sidebarText:"#e2e8f0", accent:"#6366f1",  body:"#1e293b",  bodyText:"#e2e8f0", muted:"#94a3b8"},
  {id:"sidebar-slate",  name:"Sidebar Slate",  layout:"sidebar", sidebarBg:"#334155", sidebarText:"#f1f5f9", accent:"#38bdf8",  body:"#f8fafc",  bodyText:"#1e293b", muted:"#64748b"},
  // ── Modern layouts (accent bar + clean) ──────────────────
  {id:"modern-blue",   name:"Modern Blue",   layout:"modern", accent:"#3b82f6", accentDark:"#1d4ed8", body:"#ffffff", bodyText:"#1e293b", muted:"#64748b"},
  {id:"modern-purple", name:"Modern Purple", layout:"modern", accent:"#7c3aed", accentDark:"#5b21b6", body:"#ffffff", bodyText:"#1e1b4b", muted:"#6d28d9"},
  {id:"modern-green",  name:"Modern Green",  layout:"modern", accent:"#059669", accentDark:"#065f46", body:"#ffffff", bodyText:"#052e16", muted:"#047857"},
  {id:"modern-orange", name:"Modern Orange", layout:"modern", accent:"#ea580c", accentDark:"#9a3412", body:"#ffffff", bodyText:"#1c1917", muted:"#c2410c"},
  // ── Elegant layouts (centered name, refined) ─────────────
  {id:"elegant-cream", name:"Elegant Cream", layout:"elegant", accent:"#92400e", divider:"#d97706", body:"#fffdf7", bodyText:"#1c1917", muted:"#78716c"},
  {id:"elegant-black", name:"Elegant Black", layout:"elegant", accent:"#000000", divider:"#000000", body:"#ffffff", bodyText:"#000000", muted:"#404040"},
  {id:"elegant-navy",  name:"Elegant Navy",  layout:"elegant", accent:"#1e3a5f", divider:"#3b82f6", body:"#ffffff", bodyText:"#1e293b", muted:"#64748b"},
];

// ─── SHARED UI ─────────────────────────────────────────────
const css = `
  @import url('https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600;700;800&family=Sora:wght@700;800&display=swap');
  *{box-sizing:border-box;margin:0;padding:0}
  @keyframes spin{to{transform:rotate(360deg)}}
  @keyframes fadeUp{from{opacity:0;transform:translateY(16px)}to{opacity:1;transform:translateY(0)}}
  @keyframes popIn{from{opacity:0;transform:scale(0.85)}to{opacity:1;transform:scale(1)}}
  @keyframes progress{from{width:0}to{width:100%}}
  @keyframes float{0%,100%{transform:translateY(0)}50%{transform:translateY(-8px)}}
  body{background:${T.bg};font-family:'Inter',sans-serif}
  ::-webkit-scrollbar{width:4px}
  ::-webkit-scrollbar-thumb{background:${T.border};border-radius:2px}
`;

function Spin({size=20}){return <div style={{width:size,height:size,border:`2px solid ${T.border}`,borderTopColor:T.accent,borderRadius:"50%",animation:"spin 0.7s linear infinite",flexShrink:0,display:"inline-block"}}/>}

function Btn({children,onClick,variant="primary",size="md",loading=false,disabled=false,full=false,style={}}){
  const pad={sm:"7px 16px",md:"10px 22px",lg:"14px 32px"}[size];
  const fs={sm:12,md:14,lg:16}[size];
  const vs={
    primary:{background:`linear-gradient(135deg,${T.accent},${T.accent2})`,color:"#fff",border:"none",boxShadow:`0 0 20px ${T.accentGlow}`},
    ghost:{background:"transparent",color:T.text,border:`1px solid ${T.border}`},
    gold:{background:`linear-gradient(135deg,#f59e0b,#d97706)`,color:"#000",border:"none"},
    danger:{background:T.red,color:"#fff",border:"none"},
    green:{background:T.green,color:"#fff",border:"none"},
  }[variant]||{};
  return <button onClick={onClick} disabled={loading||disabled} style={{...vs,padding:pad,fontSize:fs,borderRadius:10,cursor:(loading||disabled)?"not-allowed":"pointer",fontFamily:"inherit",fontWeight:700,display:"inline-flex",alignItems:"center",justifyContent:"center",gap:8,transition:"all 0.2s",opacity:disabled&&!loading?0.5:1,width:full?"100%":undefined,...style}}>
    {loading?<Spin size={fs}/>:children}
  </button>;
}

function Input({label,value,onChange,placeholder,type="text",multi=false,rows=4,required=false}){
  const s={width:"100%",background:T.surface,border:`1px solid ${T.border}`,borderRadius:10,padding:"10px 14px",color:T.text,fontSize:14,outline:"none",fontFamily:"inherit",resize:multi?"vertical":"none",minHeight:multi?rows*26:undefined};
  return <div style={{marginBottom:16}}>
    {label&&<label style={{display:"block",fontSize:12,color:T.muted,marginBottom:5,fontWeight:600}}>{label}{required&&<span style={{color:T.red}}> *</span>}</label>}
    {multi?<textarea value={value} onChange={e=>onChange(e.target.value)} placeholder={placeholder} style={s} rows={rows}/>
          :<input type={type} value={value} onChange={e=>onChange(e.target.value)} placeholder={placeholder} style={s}/>}
  </div>;
}

function Select({label,value,onChange,options}){
  return <div style={{marginBottom:16}}>
    {label&&<label style={{display:"block",fontSize:12,color:T.muted,marginBottom:5,fontWeight:600}}>{label}</label>}
    <select value={value} onChange={e=>onChange(e.target.value)} style={{width:"100%",background:T.surface,border:`1px solid ${T.border}`,borderRadius:10,padding:"10px 14px",color:T.text,fontSize:14,fontFamily:"inherit",outline:"none"}}>
      {options.map(o=><option key={o.value} value={o.value}>{o.label}</option>)}
    </select>
  </div>;
}

function Card({children,style={},onClick,hover=false}){
  const [h,setH]=useState(false);
  return <div onClick={onClick} onMouseEnter={()=>hover&&setH(true)} onMouseLeave={()=>hover&&setH(false)}
    style={{background:`${T.card}ee`,border:`1px solid ${h?T.accent:T.border}`,borderRadius:16,padding:24,backdropFilter:"blur(8px)",transition:"all 0.2s",transform:h?"translateY(-2px)":"none",cursor:onClick?"pointer":"default",...style}}>
    {children}
  </div>;
}

function Badge({children,color="blue"}){
  const map={blue:[T.accent,`${T.accent}22`],green:[T.green,`${T.green}22`],gold:[T.gold,`${T.gold}22`],red:[T.red,`${T.red}22`]};
  const[fg,bg]=map[color]||map.blue;
  return <span style={{background:bg,color:fg,padding:"2px 10px",borderRadius:99,fontSize:11,fontWeight:700,display:"inline-block"}}>{children}</span>;
}

function Toast({msg,type="ok",onClose}){
  useEffect(()=>{if(!msg)return;const t=setTimeout(onClose,4000);return()=>clearTimeout(t)},[msg,onClose]);
  if(!msg)return null;
  const color=type==="err"?T.red:T.green;
  return <div style={{position:"fixed",bottom:24,right:24,background:T.card,border:`1px solid ${color}`,color:T.text,padding:"12px 20px",borderRadius:12,zIndex:9999,fontSize:14,maxWidth:360,boxShadow:`0 4px 24px ${color}44`}}>
    {type==="err"?"✗ ":"✓ "}{msg}
  </div>;
}

function ErrBox({msg}){if(!msg)return null;return <div style={{background:`${T.red}18`,border:`1px solid ${T.red}44`,color:T.red,padding:"10px 14px",borderRadius:10,fontSize:13,marginBottom:14,lineHeight:1.5}}>⚠ {msg}</div>}

function PointsBadge({pts,onClick}){
  return <button onClick={onClick} style={{background:`${T.gold}22`,border:`1px solid ${T.gold}44`,color:T.gold,borderRadius:20,padding:"5px 14px",cursor:"pointer",fontFamily:"inherit",fontSize:13,fontWeight:800,display:"flex",alignItems:"center",gap:6}}>
    ✦ {pts||0}
  </button>;
}

function MeshCode(){
  return <div style={{textAlign:"center",paddingTop:20,marginTop:20,borderTop:`1px solid ${T.border}`}}>
    <div style={{display:"inline-flex",alignItems:"center",gap:8,padding:"7px 18px",background:T.surface,borderRadius:99,border:`1px solid ${T.border}`}}>
      <svg width={18} height={18} viewBox="0 0 24 24" fill="none">
        <defs><linearGradient id="mg" x1="0" y1="0" x2="24" y2="24"><stop stopColor="#6366f1"/><stop offset="100%" stopColor="#8b5cf6"/></linearGradient></defs>
        <rect x="2" y="2" width="9" height="9" rx="2" fill="url(#mg)" opacity="0.9"/>
        <rect x="13" y="2" width="9" height="9" rx="2" fill="url(#mg)" opacity="0.6"/>
        <rect x="2" y="13" width="9" height="9" rx="2" fill="url(#mg)" opacity="0.6"/>
        <rect x="13" y="13" width="9" height="9" rx="2" fill="url(#mg)" opacity="0.9"/>
        <circle cx="12" cy="12" r="2.5" fill="white" opacity="0.9"/>
      </svg>
      <span style={{fontSize:12,color:T.muted}}>Built by <a href="https://x.com/meshcode2" target="_blank" rel="noopener noreferrer" style={{fontWeight:800,background:"linear-gradient(135deg,#6366f1,#8b5cf6)",WebkitBackgroundClip:"text",WebkitTextFillColor:"transparent",textDecoration:"none"}}>MeshCode</a></span>
    </div>
  </div>;
}

function Logo({size=36}){
  // Logo is 1280x853 — ratio 1.5:1 (landscape)
  // We control HEIGHT and let width be automatic
  const height = size;
  const width  = Math.round(size * 1.5);
  return (
    <div style={{display:"flex",alignItems:"center",flexShrink:0}}>
      <img
        src="/logo.png"
        alt="Career Pilot"
        style={{
          height: height,
          width:  width,
          objectFit:"contain",
          objectPosition:"left center",
          display:"block",
          flexShrink:0,
        }}
      />
    </div>
  );
}

// ─── RESUME PARSER ────────────────────────────────────────
function parseResume(text){
  const s={contact:[],summary:[],experience:[],education:[],skills:[]};
  let cur=null;
  text.split("\n").forEach(line=>{
    const t=line.trim();
    if(!t)return;
    if(t==="[CONTACT]"){cur="contact";return;}
    if(t==="[SUMMARY]"){cur="summary";return;}
    if(t==="[EXPERIENCE]"){cur="experience";return;}
    if(t==="[EDUCATION]"){cur="education";return;}
    if(t==="[SKILLS]"){cur="skills";return;}
    if(cur)s[cur].push(t);
  });
  return s;
}

function parseJobs(expLines){
  const jobs=[];let cur=null;
  expLines.forEach(line=>{
    if(line.includes("|")){
      if(cur)jobs.push(cur);
      const p=line.split("|").map(x=>x.trim());
      cur={title:p[0]||"",company:p[1]||"",date:p[2]||"",bullets:[]};
    } else if(line.match(/^[•\-]/)){
      if(!cur)cur={title:"",company:"",date:"",bullets:[]};
      cur.bullets.push(line.replace(/^[•\-]\s*/,""));
    } else {
      if(cur)jobs.push(cur);
      cur={title:line,company:"",date:"",bullets:[]};
    }
  });
  if(cur)jobs.push(cur);
  return jobs;
}

// ─── BUILD PDF HTML ────────────────────────────────────────
function buildPDF(text, form, tid, photoDataUrl){
  const tpl = TEMPLATES.find(x=>x.id===tid)||TEMPLATES[0];
  const s   = parseResume(text);
  const jobs= parseJobs(s.experience);
  const name= form.name||s.contact[0]||"Your Name";
  const contact = s.contact.length>1
    ? s.contact.slice(1)
    : [form.email,form.phone,form.location,form.linkedin].filter(Boolean);
  const skills  = s.skills.join(",").split(/[,·]/).map(k=>k.trim()).filter(Boolean);
  const layout  = tpl.layout||"classic";

  const font = `@import url('https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600;700;800&display=swap');`;
  const base = `*{box-sizing:border-box;margin:0;padding:0} body{font-family:'Inter',Arial,sans-serif;-webkit-print-color-adjust:exact;print-color-adjust:exact} @page{margin:0}`;

  const photoHTML = photoDataUrl
    ? `<img src="${photoDataUrl}" style="width:90px;height:90px;border-radius:50%;object-fit:cover;border:3px solid rgba(255,255,255,0.3);display:block;flex-shrink:0"/>`
    : "";

  const expHTML=(color)=>jobs.map(j=>`
    <div style="margin-bottom:16px">
      <div style="display:flex;justify-content:space-between;align-items:baseline;flex-wrap:wrap;gap:4px;margin-bottom:4px">
        <span style="font-size:13.5px;font-weight:700;color:${color}">${j.title}${j.company?` <span style="font-weight:500;color:#64748b">· ${j.company}</span>`:""}</span>
        ${j.date?`<span style="font-size:12px;color:#64748b;white-space:nowrap">${j.date}</span>`:""}
      </div>
      ${j.bullets.map(b=>`<div style="font-size:13px;line-height:1.7;padding-left:16px;position:relative;color:#374151;margin-top:4px"><span style="position:absolute;left:0;color:${color}">▸</span>${b}</div>`).join("")}
    </div>`).join("");

  const eduHTML=(color)=>s.education.map(line=>{
    if(line.includes("|")){
      const p=line.split("|").map(x=>x.trim());
      return`<div style="margin-bottom:10px"><div style="font-size:13.5px;font-weight:700;color:${color}">${p[0]}</div><div style="font-size:12px;color:#64748b;margin-top:2px">${p.slice(1).join(" · ")}</div></div>`;
    }
    return`<div style="font-size:${line.match(/\d{4}/)?"12":"13.5"}px;font-weight:${line.match(/\d{4}/)?"400":"700"};color:${line.match(/\d{4}/)?"#64748b":color};margin-bottom:4px">${line}</div>`;
  }).join("");

  const skillsHTML=(bg,color)=>skills.map(k=>`<span style="background:${bg};color:${color};padding:3px 12px;border-radius:99px;font-size:11px;font-weight:600;display:inline-block;margin:3px">${k}</span>`).join("");

  const secTitle=(label,color,border)=>`<div style="font-size:10px;font-weight:800;letter-spacing:2.5px;text-transform:uppercase;color:${color};margin-bottom:12px;margin-top:20px;padding-bottom:5px;border-bottom:1px solid ${border||color+"33"}">${label}</div>`;

  let html="";

  if(layout==="classic"){
    const hBg=tpl.headerBg; const hTx=tpl.headerText; const acc=tpl.accent;
    html=`<!DOCTYPE html><html><head><meta charset="utf-8"><style>${font}${base}
      .wrap{max-width:820px;margin:0 auto;background:${tpl.body};min-height:100vh}
      .hdr{background:${hBg};padding:32px 48px;display:flex;gap:24px;align-items:center;border-bottom:4px solid ${acc}}
      .hdr-info{flex:1}
      .nm{font-size:28px;font-weight:800;color:${hTx};margin-bottom:6px}
      .ct{display:flex;flex-wrap:wrap;gap:4px 16px;font-size:12px;color:${hTx}99}
      .bdy{padding:28px 48px}
      @media print{.wrap{max-width:100%}}
    </style></head><body><div class="wrap">
    <div class="hdr">
      ${photoHTML?`<div>${photoHTML}</div>`:""}
      <div class="hdr-info">
        <div class="nm">${name}</div>
        <div class="ct">${contact.map(c=>`<span>${c}</span>`).join("")}</div>
      </div>
    </div>
    <div class="bdy">
      ${s.summary.length?secTitle("Professional Summary",acc)+"<p style='font-size:13.5px;line-height:1.85;color:"+tpl.bodyText+"'>"+s.summary.join(" ")+"</p>":""}
      ${s.experience.length?secTitle("Work Experience",acc)+expHTML(acc):""}
      ${s.education.length?secTitle("Education",acc)+eduHTML(acc):""}
      ${skills.length?secTitle("Skills",acc)+"<div>"+skillsHTML(acc+"18",acc)+"</div>":""}
    </div></div></body></html>`;
  }

  else if(layout==="sidebar"){
    const sBg=tpl.sidebarBg; const sTx=tpl.sidebarText; const acc=tpl.accent;
    html=`<!DOCTYPE html><html><head><meta charset="utf-8"><style>${font}${base}
      .wrap{max-width:820px;margin:0 auto;background:${tpl.body};min-height:100vh;display:flex}
      .side{width:260px;background:${sBg};padding:32px 24px;flex-shrink:0;min-height:100vh}
      .main{flex:1;padding:32px 36px}
      .photo{width:100px;height:100px;border-radius:50%;object-fit:cover;border:3px solid ${acc};margin:0 auto 16px;display:block}
      .nm{font-size:20px;font-weight:800;color:${sTx};text-align:center;margin-bottom:6px}
      .stitle{font-size:9px;font-weight:800;letter-spacing:2px;text-transform:uppercase;color:${acc};margin-bottom:10px;margin-top:20px;padding-bottom:4px;border-bottom:1px solid ${acc}44}
      .ct-item{font-size:12px;color:${sTx}cc;margin-bottom:6px;word-break:break-all}
      .sk{background:${acc}33;color:${acc};padding:3px 10px;border-radius:99px;font-size:11px;font-weight:600;display:inline-block;margin:2px}
      .stitle2{font-size:10px;font-weight:800;letter-spacing:2px;text-transform:uppercase;color:${acc};margin-bottom:10px;margin-top:20px;padding-bottom:5px;border-bottom:1px solid ${acc}33}
      @media print{.wrap{max-width:100%;display:flex!important}}
    </style></head><body><div class="wrap">
    <div class="side">
      ${photoDataUrl?`<img src="${photoDataUrl}" class="photo"/>`:""}
      <div class="nm">${name}</div>
      <div class="stitle">Contact</div>
      ${contact.map(c=>`<div class="ct-item">${c}</div>`).join("")}
      ${skills.length?`<div class="stitle">Skills</div><div>${skills.map(k=>`<span class="sk">${k}</span>`).join("")}</div>`:""}
      ${s.education.length?`<div class="stitle">Education</div>${s.education.map(l=>`<div style="font-size:12px;color:${sTx}cc;margin-bottom:6px">${l}</div>`).join("")}`:""}
    </div>
    <div class="main">
      ${s.summary.length?`<div class="stitle2">Professional Summary</div><p style="font-size:13.5px;line-height:1.85;color:${tpl.bodyText}">${s.summary.join(" ")}</p>`:""}
      ${s.experience.length?`<div class="stitle2">Work Experience</div>${expHTML(acc)}`:""}
    </div>
    </div></body></html>`;
  }

  else if(layout==="modern"){
    const acc=tpl.accent; const aDk=tpl.accentDark||acc;
    html=`<!DOCTYPE html><html><head><meta charset="utf-8"><style>${font}${base}
      .wrap{max-width:820px;margin:0 auto;background:${tpl.body};min-height:100vh}
      .topbar{background:linear-gradient(135deg,${aDk},${acc});height:8px}
      .hdr{padding:36px 48px 24px;display:flex;gap:24px;align-items:flex-start;border-bottom:1px solid ${acc}22}
      .nm{font-size:32px;font-weight:800;color:${aDk};letter-spacing:-0.5px}
      .ct{display:flex;flex-wrap:wrap;gap:4px 20px;font-size:12.5px;color:${tpl.muted};margin-top:10px}
      .bdy{padding:24px 48px}
      .stitle{font-size:10px;font-weight:800;letter-spacing:2.5px;text-transform:uppercase;color:${acc};margin-bottom:12px;margin-top:22px;display:flex;align-items:center;gap:10px}
      .stitle::after{content:'';flex:1;height:2px;background:linear-gradient(90deg,${acc}33,transparent)}
      .sk{background:${acc}15;color:${acc};padding:4px 14px;border-radius:99px;font-size:12px;font-weight:600;border:1px solid ${acc}33;display:inline-block;margin:3px}
      @media print{.wrap{max-width:100%}}
    </style></head><body><div class="wrap">
    <div class="topbar"></div>
    <div class="hdr">
      ${photoDataUrl?`<img src="${photoDataUrl}" style="width:90px;height:90px;border-radius:12px;object-fit:cover;border:2px solid ${acc}33;flex-shrink:0"/>`:""}
      <div>
        <div class="nm">${name}</div>
        <div class="ct">${contact.map(c=>`<span>${c}</span>`).join("")}</div>
      </div>
    </div>
    <div class="bdy">
      ${s.summary.length?`<div class="stitle">Summary</div><p style="font-size:13.5px;line-height:1.85;color:${tpl.bodyText}">${s.summary.join(" ")}</p>`:""}
      ${s.experience.length?`<div class="stitle">Experience</div>${expHTML(acc)}`:""}
      ${s.education.length?`<div class="stitle">Education</div>${eduHTML(acc)}`:""}
      ${skills.length?`<div class="stitle">Skills</div><div>${skills.map(k=>`<span class="sk">${k}</span>`).join("")}</div>`:""}
    </div></div></body></html>`;
  }

  else if(layout==="elegant"){
    const acc=tpl.accent; const div=tpl.divider||acc;
    html=`<!DOCTYPE html><html><head><meta charset="utf-8"><style>${font}${base}
      .wrap{max-width:820px;margin:0 auto;background:${tpl.body};min-height:100vh;padding:48px 56px}
      .hdr{text-align:center;margin-bottom:28px;padding-bottom:24px;border-bottom:2px solid ${div}}
      .photo{width:96px;height:96px;border-radius:50%;object-fit:cover;border:2px solid ${acc};margin:0 auto 16px;display:block}
      .nm{font-size:34px;font-weight:800;color:${acc};letter-spacing:-1px;margin-bottom:8px}
      .ct{display:flex;flex-wrap:wrap;gap:4px 20px;font-size:12px;color:${tpl.muted};justify-content:center}
      .stitle{font-size:10px;font-weight:800;letter-spacing:3px;text-transform:uppercase;color:${acc};text-align:center;margin-bottom:14px;margin-top:24px}
      .divline{width:60px;height:2px;background:${div};margin:0 auto 14px}
      .sk{background:${acc}12;color:${acc};padding:3px 14px;border-radius:99px;font-size:11px;font-weight:600;border:1px solid ${acc}22;display:inline-block;margin:3px}
      @media print{.wrap{padding:32px 40px;max-width:100%}}
    </style></head><body><div class="wrap">
    <div class="hdr">
      ${photoDataUrl?`<img src="${photoDataUrl}" class="photo"/>`:""}
      <div class="nm">${name}</div>
      <div class="ct">${contact.map(c=>`<span>${c}</span>`).join("")}</div>
    </div>
    ${s.summary.length?`<div class="stitle">Professional Summary</div><div class="divline"></div><p style="font-size:13.5px;line-height:1.9;color:${tpl.bodyText};text-align:center;margin-bottom:8px">${s.summary.join(" ")}</p>`:""}
    ${s.experience.length?`<div class="stitle">Work Experience</div><div class="divline"></div>${expHTML(acc)}`:""}
    ${s.education.length?`<div class="stitle">Education</div><div class="divline"></div>${eduHTML(acc)}`:""}
    ${skills.length?`<div class="stitle">Skills</div><div class="divline"></div><div style="text-align:center">${skills.map(k=>`<span class="sk">${k}</span>`).join("")}</div>`:""}
    </div></body></html>`;
  }

  return html||"<html><body><p>Template not found</p></body></html>";
}

// ─── RESUME CARD (in-app preview) ─────────────────────────
function ResumeCard({text, form, tid, photo}){
  const tpl = TEMPLATES.find(x=>x.id===tid)||TEMPLATES[0];
  const s   = parseResume(text);
  const jobs= parseJobs(s.experience);
  const name= form.name||s.contact[0]||"Your Name";
  const contact = s.contact.length>1
    ? s.contact.slice(1)
    : [form.email,form.phone,form.location].filter(Boolean);
  const skills  = s.skills.join(",").split(/[,·]/).map(k=>k.trim()).filter(Boolean);
  const layout  = tpl.layout||"classic";
  const hasData = Object.values(s).some(a=>a.length>0);

  const ST=({children,color})=><div style={{fontSize:10,fontWeight:800,letterSpacing:"2.5px",textTransform:"uppercase",color:color||tpl.accent,display:"flex",alignItems:"center",gap:10,marginBottom:10,marginTop:18}}>
    {children}<div style={{flex:1,height:1,background:`${color||tpl.accent}33`}}/>
  </div>;

  const ExpBlock=({color})=>jobs.map((j,i)=><div key={i} style={{marginBottom:14}}>
    <div style={{display:"flex",justifyContent:"space-between",flexWrap:"wrap",gap:4,marginBottom:4}}>
      <div>
        <span style={{fontSize:13,fontWeight:700,color}}>{j.title}</span>
        {j.company&&<span style={{fontSize:12,color:tpl.muted,fontWeight:500}}> · {j.company}</span>}
      </div>
      {j.date&&<span style={{fontSize:11,color:tpl.muted}}>{j.date}</span>}
    </div>
    {j.bullets.map((b,k)=><div key={k} style={{fontSize:12,lineHeight:1.7,paddingLeft:14,position:"relative",color:tpl.bodyText||"#1e293b",marginTop:3}}>
      <span style={{position:"absolute",left:0,color,fontSize:10}}>▸</span>{b}
    </div>)}
  </div>);

  const EduBlock=({color})=>s.education.map((line,i)=>{
    if(line.includes("|")){const p=line.split("|").map(x=>x.trim());return<div key={i} style={{marginBottom:8}}><div style={{fontSize:13,fontWeight:700,color}}>{p[0]}</div><div style={{fontSize:11,color:tpl.muted,marginTop:1}}>{p.slice(1).join(" · ")}</div></div>;}
    return<div key={i} style={{fontSize:line.match(/\d{4}/)?11:13,fontWeight:line.match(/\d{4}/)?400:700,color:line.match(/\d{4}/)?tpl.muted:color,marginBottom:3}}>{line}</div>;
  });

  const SkillChips=({bg,color})=><div style={{display:"flex",flexWrap:"wrap",gap:5}}>
    {skills.map((k,i)=><span key={i} style={{background:bg,color,padding:"3px 10px",borderRadius:99,fontSize:11,fontWeight:600,border:`1px solid ${color}33`}}>{k}</span>)}
  </div>;

  const PhotoImg=({size=80,radius="50%",border})=>photo?<img src={photo} alt="Profile" style={{width:size,height:size,borderRadius:radius,objectFit:"cover",border:border||`3px solid rgba(255,255,255,0.3)`,flexShrink:0}}/>:null;

  // ── Classic ──────────────────────────────────────────────
  if(layout==="classic") return <div style={{background:tpl.body,borderRadius:12,overflow:"hidden",border:`1px solid ${T.border}`,maxHeight:600,overflowY:"auto",fontFamily:"'Inter',sans-serif"}}>
    <div style={{background:tpl.headerBg,padding:"24px 32px",display:"flex",gap:20,alignItems:"center",borderBottom:`4px solid ${tpl.accent}`}}>
      <PhotoImg/>
      <div>
        <div style={{fontSize:"clamp(18px,3vw,24px)",fontWeight:800,color:tpl.headerText,marginBottom:6}}>{name}</div>
        <div style={{display:"flex",flexWrap:"wrap",gap:"3px 14px",fontSize:11,color:`${tpl.headerText}99`}}>{contact.map((c,i)=><span key={i}>{c}</span>)}</div>
      </div>
    </div>
    <div style={{padding:"18px 32px 24px",background:tpl.body,color:tpl.bodyText}}>
      {!hasData&&<pre style={{whiteSpace:"pre-wrap",fontSize:12,lineHeight:1.9,color:tpl.bodyText,fontFamily:"inherit"}}>{text}</pre>}
      {s.summary.length>0&&<><ST color={tpl.accent}>Professional Summary</ST><p style={{fontSize:13,lineHeight:1.8,color:tpl.bodyText}}>{s.summary.join(" ")}</p></>}
      {s.experience.length>0&&<><ST color={tpl.accent}>Work Experience</ST><ExpBlock color={tpl.accent}/></>}
      {s.education.length>0&&<><ST color={tpl.accent}>Education</ST><EduBlock color={tpl.accent}/></>}
      {skills.length>0&&<><ST color={tpl.accent}>Skills</ST><SkillChips bg={`${tpl.accent}18`} color={tpl.accent}/></>}
    </div>
  </div>;

  // ── Sidebar ──────────────────────────────────────────────
  if(layout==="sidebar") return <div style={{background:tpl.body,borderRadius:12,overflow:"hidden",border:`1px solid ${T.border}`,maxHeight:600,overflowY:"auto",fontFamily:"'Inter',sans-serif",display:"flex"}}>
    <div style={{width:200,background:tpl.sidebarBg,padding:"24px 18px",flexShrink:0}}>
      {photo&&<img src={photo} alt="Profile" style={{width:80,height:80,borderRadius:"50%",objectFit:"cover",border:`3px solid ${tpl.accent}`,display:"block",margin:"0 auto 14px"}}/>}
      <div style={{fontSize:14,fontWeight:800,color:tpl.sidebarText,textAlign:"center",marginBottom:14}}>{name}</div>
      <div style={{fontSize:9,fontWeight:800,letterSpacing:2,textTransform:"uppercase",color:tpl.accent,marginBottom:8}}>CONTACT</div>
      {contact.map((c,i)=><div key={i} style={{fontSize:11,color:`${tpl.sidebarText}cc`,marginBottom:5,wordBreak:"break-all"}}>{c}</div>)}
      {skills.length>0&&<><div style={{fontSize:9,fontWeight:800,letterSpacing:2,textTransform:"uppercase",color:tpl.accent,marginTop:14,marginBottom:8}}>SKILLS</div>
        <div style={{display:"flex",flexWrap:"wrap",gap:4}}>{skills.map((k,i)=><span key={i} style={{background:`${tpl.accent}33`,color:tpl.accent,padding:"2px 8px",borderRadius:99,fontSize:10,fontWeight:600}}>{k}</span>)}</div></>}
      {s.education.length>0&&<><div style={{fontSize:9,fontWeight:800,letterSpacing:2,textTransform:"uppercase",color:tpl.accent,marginTop:14,marginBottom:8}}>EDUCATION</div>
        {s.education.map((l,i)=><div key={i} style={{fontSize:10,color:`${tpl.sidebarText}cc`,marginBottom:4}}>{l}</div>)}</>}
    </div>
    <div style={{flex:1,padding:"20px 24px",background:tpl.body,overflowY:"auto"}}>
      {s.summary.length>0&&<><div style={{fontSize:9,fontWeight:800,letterSpacing:2,textTransform:"uppercase",color:tpl.accent,marginBottom:8}}>PROFESSIONAL SUMMARY</div><p style={{fontSize:12,lineHeight:1.8,color:tpl.bodyText,marginBottom:4}}>{s.summary.join(" ")}</p></>}
      {s.experience.length>0&&<><div style={{fontSize:9,fontWeight:800,letterSpacing:2,textTransform:"uppercase",color:tpl.accent,marginTop:16,marginBottom:8}}>WORK EXPERIENCE</div><ExpBlock color={tpl.accent}/></>}
    </div>
  </div>;

  // ── Modern ───────────────────────────────────────────────
  if(layout==="modern") return <div style={{background:tpl.body,borderRadius:12,overflow:"hidden",border:`1px solid ${T.border}`,maxHeight:600,overflowY:"auto",fontFamily:"'Inter',sans-serif"}}>
    <div style={{height:6,background:`linear-gradient(135deg,${tpl.accentDark||tpl.accent},${tpl.accent})`}}/>
    <div style={{padding:"24px 32px 18px",display:"flex",gap:20,alignItems:"flex-start",borderBottom:`1px solid ${tpl.accent}22`}}>
      {photo&&<img src={photo} alt="Profile" style={{width:72,height:72,borderRadius:10,objectFit:"cover",border:`2px solid ${tpl.accent}33`,flexShrink:0}}/>}
      <div>
        <div style={{fontSize:"clamp(18px,3vw,26px)",fontWeight:800,color:tpl.accentDark||tpl.accent,letterSpacing:-0.5,marginBottom:6}}>{name}</div>
        <div style={{display:"flex",flexWrap:"wrap",gap:"3px 16px",fontSize:11,color:tpl.muted}}>{contact.map((c,i)=><span key={i}>{c}</span>)}</div>
      </div>
    </div>
    <div style={{padding:"16px 32px 24px"}}>
      {s.summary.length>0&&<><div style={{fontSize:9,fontWeight:800,letterSpacing:2,textTransform:"uppercase",color:tpl.accent,marginBottom:8,marginTop:8,display:"flex",alignItems:"center",gap:8}}>Summary<div style={{flex:1,height:2,background:`linear-gradient(90deg,${tpl.accent}33,transparent)`}}/></div><p style={{fontSize:12,lineHeight:1.8,color:tpl.bodyText}}>{s.summary.join(" ")}</p></>}
      {s.experience.length>0&&<><div style={{fontSize:9,fontWeight:800,letterSpacing:2,textTransform:"uppercase",color:tpl.accent,marginBottom:8,marginTop:16,display:"flex",alignItems:"center",gap:8}}>Experience<div style={{flex:1,height:2,background:`linear-gradient(90deg,${tpl.accent}33,transparent)`}}/></div><ExpBlock color={tpl.accent}/></>}
      {s.education.length>0&&<><div style={{fontSize:9,fontWeight:800,letterSpacing:2,textTransform:"uppercase",color:tpl.accent,marginBottom:8,marginTop:16,display:"flex",alignItems:"center",gap:8}}>Education<div style={{flex:1,height:2,background:`linear-gradient(90deg,${tpl.accent}33,transparent)`}}/></div><EduBlock color={tpl.accent}/></>}
      {skills.length>0&&<><div style={{fontSize:9,fontWeight:800,letterSpacing:2,textTransform:"uppercase",color:tpl.accent,marginBottom:8,marginTop:16,display:"flex",alignItems:"center",gap:8}}>Skills<div style={{flex:1,height:2,background:`linear-gradient(90deg,${tpl.accent}33,transparent)`}}/></div><SkillChips bg={`${tpl.accent}15`} color={tpl.accent}/></>}
    </div>
  </div>;

  // ── Elegant ──────────────────────────────────────────────
  if(layout==="elegant") return <div style={{background:tpl.body,borderRadius:12,overflow:"hidden",border:`1px solid ${T.border}`,maxHeight:600,overflowY:"auto",fontFamily:"'Inter',sans-serif",padding:"28px 36px"}}>
    <div style={{textAlign:"center",borderBottom:`2px solid ${tpl.divider||tpl.accent}`,paddingBottom:20,marginBottom:4}}>
      {photo&&<img src={photo} alt="Profile" style={{width:80,height:80,borderRadius:"50%",objectFit:"cover",border:`2px solid ${tpl.accent}`,display:"block",margin:"0 auto 12px"}}/>}
      <div style={{fontSize:"clamp(20px,3vw,28px)",fontWeight:800,color:tpl.accent,letterSpacing:-1,marginBottom:8}}>{name}</div>
      <div style={{display:"flex",flexWrap:"wrap",gap:"3px 16px",fontSize:11,color:tpl.muted,justifyContent:"center"}}>{contact.map((c,i)=><span key={i}>{c}</span>)}</div>
    </div>
    {s.summary.length>0&&<><div style={{fontSize:9,fontWeight:800,letterSpacing:3,textTransform:"uppercase",color:tpl.accent,textAlign:"center",marginTop:18,marginBottom:6}}>Professional Summary</div><div style={{width:48,height:2,background:tpl.divider||tpl.accent,margin:"0 auto 12px"}}/><p style={{fontSize:12,lineHeight:1.9,color:tpl.bodyText,textAlign:"center"}}>{s.summary.join(" ")}</p></>}
    {s.experience.length>0&&<><div style={{fontSize:9,fontWeight:800,letterSpacing:3,textTransform:"uppercase",color:tpl.accent,textAlign:"center",marginTop:18,marginBottom:6}}>Work Experience</div><div style={{width:48,height:2,background:tpl.divider||tpl.accent,margin:"0 auto 12px"}}/><ExpBlock color={tpl.accent}/></>}
    {s.education.length>0&&<><div style={{fontSize:9,fontWeight:800,letterSpacing:3,textTransform:"uppercase",color:tpl.accent,textAlign:"center",marginTop:18,marginBottom:6}}>Education</div><div style={{width:48,height:2,background:tpl.divider||tpl.accent,margin:"0 auto 12px"}}/><EduBlock color={tpl.accent}/></>}
    {skills.length>0&&<><div style={{fontSize:9,fontWeight:800,letterSpacing:3,textTransform:"uppercase",color:tpl.accent,textAlign:"center",marginTop:18,marginBottom:6}}>Skills</div><div style={{width:48,height:2,background:tpl.divider||tpl.accent,margin:"0 auto 12px"}}/><div style={{textAlign:"center"}}><SkillChips bg={`${tpl.accent}12`} color={tpl.accent}/></div></>}
  </div>;

  return <div style={{padding:20,color:T.text}}>Unknown layout</div>;
}


// ─── AUTH PAGE ─────────────────────────────────────────────
function AuthPage({onLogin, startMode="login", refCode=""}){ 
  const [mode, setMode] = useState(startMode);
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [pass, setPass]   = useState("");
  const [newPass, setNewPass] = useState("");
  const [loading, setLoading] = useState(false);
  const [err, setErr]     = useState("");
  const [ok, setOk]       = useState("");
  const [popup, setPopup] = useState(false);
  const [pName, setPName] = useState("");
  const [resetToken, setResetToken] = useState("");
  const [resetLink, setResetLink] = useState("");

  // Read URL token on load
  useEffect(()=>{
    const p=new URLSearchParams(window.location.search);
    const tok=p.get("token");
    const type=p.get("type");
    if(!tok) return;
    if(type==="reset"){setResetToken(tok);setMode("reset");}
    else{doActivate(tok);}
  // eslint-disable-next-line
  },[]);

  const doActivate=async(tok)=>{
    setMode("activating");
    try{
      const d=await apiFetch("/api/auth/activate","POST",{token:tok});
      onLogin(d.user,d.token);
    }catch(e){setErr(e.message);setMode("login");}
  };

  const submit=async()=>{
    setErr(""); setOk("");
    if(mode==="forgot"){
      if(!email){setErr("Enter your email");return;}
      setLoading(true);
      try{
        const d=await apiFetch("/api/auth/forgot-password","POST",{email});
        setOk(d.message);
        if(d.resetLink){setResetLink(d.resetLink);}
      }catch(e){setErr(e.message);}
      setLoading(false);return;
    }
    if(mode==="reset"){
      if(newPass.length<6){setErr("Min 6 characters");return;}
      setLoading(true);
      try{
        const d=await apiFetch("/api/auth/reset-password","POST",{token:resetToken,password:newPass});
        setOk(d.message);
        setTimeout(()=>{setMode("login");setOk("");},2000);
      }catch(e){setErr(e.message);}
      setLoading(false);return;
    }
    if(!email||!pass){setErr("Fill in all fields");return;}
    if(mode==="signup"&&!name){setErr("Enter your name");return;}
    if(pass.length<6){setErr("Password min 6 characters");return;}
    setLoading(true);
    try{
      if(mode==="signup"){
        // Browser fingerprint to detect duplicate device signups
        const fp=btoa([
          navigator.userAgent,navigator.language,
          screen.width+"x"+screen.height,
          Intl.DateTimeFormat().resolvedOptions().timeZone,
          navigator.hardwareConcurrency||"",
          navigator.platform||"",
        ].join("|")).slice(0,32);
        const savedRef = refCode || sessionStorage.getItem("cp_ref") || "";
        const d=await apiFetch("/api/auth/signup","POST",{name,email,password:pass,fingerprint:fp,referralCode:savedRef});
        if(d.autoActivated){ sessionStorage.removeItem("cp_ref"); }
        if(d.token){
          // Auto-activated — show welcome popup then login
          setPName(d.user.name);
          setLoading(false);
          setPopup(true);
          setTimeout(()=>{setPopup(false);onLogin(d.user,d.token);},3500);
        }
      }else{
        const d=await apiFetch("/api/auth/login","POST",{email,password:pass});
        onLogin(d.user,d.token);
      }
    }catch(e){setErr(e.message);}
    setLoading(false);
  };

  return <div style={{minHeight:"100vh",background:T.bg,display:"flex",alignItems:"center",justifyContent:"center",padding:20,fontFamily:"'Inter',sans-serif",position:"relative"}}>
    <style>{css}</style>

    {/* Welcome popup */}
    {popup&&<div style={{position:"fixed",inset:0,zIndex:9999,background:"rgba(0,0,0,0.85)",display:"flex",alignItems:"center",justifyContent:"center",padding:20}}>
      <div style={{background:T.card,border:`2px solid ${T.green}`,borderRadius:20,padding:"40px 32px",maxWidth:400,width:"100%",textAlign:"center",animation:"popIn 0.4s ease",boxShadow:`0 0 60px ${T.green}44`}}>
        <div style={{fontSize:64,marginBottom:12,lineHeight:1}}>🎉</div>
        <h2 style={{fontFamily:"'Sora',sans-serif",fontWeight:800,fontSize:22,color:T.text,marginBottom:10}}>Welcome, {pName}!</h2>
        <p style={{color:T.muted,fontSize:14,lineHeight:1.7,marginBottom:16}}>Your account is ready. You've received</p>
        <div style={{background:`${T.gold}22`,border:`1px solid ${T.gold}44`,borderRadius:12,padding:"14px 20px",marginBottom:20}}>
          <div style={{fontSize:32,fontWeight:900,color:T.gold}}>✦ 10 Points</div>
          <div style={{fontSize:13,color:T.muted,marginTop:4}}>Free welcome bonus — use them now!</div>
        </div>
        <div style={{height:4,background:T.border,borderRadius:2,overflow:"hidden"}}>
          <div style={{height:"100%",background:`linear-gradient(90deg,${T.accent},${T.green})`,animation:"progress 3.5s linear forwards"}}/>
        </div>
        <p style={{color:T.muted,fontSize:12,marginTop:10}}>Taking you to your dashboard...</p>
      </div>
    </div>}

    <div style={{maxWidth:440,width:"100%"}}>
      <div style={{textAlign:"center",marginBottom:24,animation:"float 3s ease-in-out infinite"}}>
        <Logo size={120}/>
      </div>

      {mode==="activating"&&<Card style={{textAlign:"center",padding:40}}>
        <Spin size={40}/><p style={{color:T.muted,marginTop:16}}>Activating your account...</p>
        {err&&<><ErrBox msg={err}/><Btn onClick={()=>setMode("login")} style={{marginTop:8}}>Go to Login</Btn></>}
      </Card>}

      {/* Forgot password - proper email form */}
      {mode==="forgot"&&<div style={{position:"fixed",inset:0,zIndex:9999,background:"rgba(0,0,0,0.80)",display:"flex",alignItems:"center",justifyContent:"center",padding:20}}>
        <div style={{background:T.card,border:`1px solid ${T.border}`,borderRadius:20,padding:"40px 32px",maxWidth:420,width:"100%",textAlign:"center",animation:"popIn 0.3s ease",boxShadow:`0 0 40px ${T.accentGlow}`}}>
          <div style={{fontSize:56,marginBottom:16,lineHeight:1}}>🔒</div>
          <h2 style={{fontFamily:"'Sora',sans-serif",fontWeight:800,fontSize:22,color:T.text,marginBottom:8}}>Reset Password</h2>
          <p style={{color:T.muted,fontSize:14,lineHeight:1.7,marginBottom:20}}>Enter your email and we'll send you a reset link instantly.</p>
          {ok?<div style={{background:`${T.green}18`,border:`1px solid ${T.green}44`,color:T.green,padding:"14px 18px",borderRadius:12,fontSize:14,marginBottom:16,lineHeight:1.6}}>
            ✓ {ok}<br/><span style={{fontSize:12,opacity:0.8}}>Check your spam folder too.</span>
          </div>:<>
            {resetLink&&<div style={{background:`${T.accent}15`,border:`1px solid ${T.accent}44`,borderRadius:10,padding:14,marginBottom:14,textAlign:"left"}}>
              <p style={{fontSize:12,color:T.muted,marginBottom:6}}>Click this link to reset:</p>
              <a href={resetLink} style={{color:T.accent,fontSize:12,fontWeight:700,wordBreak:"break-all"}}>{resetLink}</a>
            </div>}
            <ErrBox msg={err}/>
            <Input label="Your Email Address" value={email} onChange={setEmail} placeholder="you@example.com" type="email"/>
            <Btn onClick={submit} loading={loading} full size="lg">📧 Send Reset Link</Btn>
          </>}
          <button onClick={()=>{setMode("login");setErr("");setOk("");setResetLink("");}} style={{background:"none",border:"none",color:T.muted,cursor:"pointer",fontFamily:"inherit",fontSize:13,marginTop:16,textDecoration:"underline"}}>← Back to Login</button>
        </div>
      </div>}

      {(mode==="login"||mode==="signup"||mode==="reset")&&<Card>
        <h2 style={{fontWeight:800,fontSize:20,marginBottom:4,color:T.text}}>
          {mode==="login"&&"Welcome Back ✈️"}
          {mode==="signup"&&"Create Free Account 🚀"}
          {mode==="reset"&&"Set New Password 🔑"}
        </h2>
        {(mode==="signup"&&(refCode||sessionStorage.getItem("cp_ref")))&&(
          <div style={{background:`${T.green}15`,border:`1px solid ${T.green}44`,borderRadius:10,padding:"10px 14px",marginBottom:12,display:"flex",alignItems:"center",gap:8}}>
            <span style={{fontSize:18}}>🎁</span>
            <div>
              <div style={{fontSize:13,fontWeight:700,color:T.green}}>Referral code applied!</div>
              <div style={{fontSize:12,color:T.muted}}>You'll get extra bonus points on signup.</div>
            </div>
          </div>
        )}
        <p style={{color:T.muted,fontSize:13,marginBottom:20}}>
          {mode==="signup"&&"Get 10 free points on signup. No credit card needed."}
          {mode==="login"&&"Sign in to your Career Pilot account."}
          {mode==="reset"&&"Choose a new secure password."}
        </p>

        {ok&&<div style={{background:`${T.green}18`,border:`1px solid ${T.green}44`,color:T.green,padding:"10px 14px",borderRadius:10,fontSize:13,marginBottom:14}}>✓ {ok}</div>}
        <ErrBox msg={err}/>

        {mode==="signup"&&<Input label="Full Name" value={name} onChange={setName} placeholder="John Doe" required/>}
        {(mode==="login"||mode==="signup")&&<Input label="Email" value={email} onChange={setEmail} placeholder="you@example.com" type="email" required/>}
        {(mode==="login"||mode==="signup")&&<Input label="Password" value={pass} onChange={setPass} placeholder="Min 6 characters" type="password" required/>}
        {mode==="reset"&&<Input label="New Password" value={newPass} onChange={setNewPass} placeholder="Min 6 characters" type="password" required/>}

        {mode==="login"&&<div style={{textAlign:"right",marginTop:-8,marginBottom:14}}>
          <button onClick={()=>{setMode("forgot");setErr("");setOk("");}} style={{background:"none",border:"none",color:T.accent,fontSize:12,cursor:"pointer",fontFamily:"inherit",fontWeight:600}}>Forgot password?</button>
        </div>}

        <Btn onClick={submit} loading={loading} full>
          {mode==="login"&&"✈️ Sign In"}
          {mode==="signup"&&"🚀 Create My Account"}
          {mode==="reset"&&"🔑 Set New Password"}
        </Btn>

        {(mode==="login"||mode==="signup")&&<p style={{textAlign:"center",color:T.muted,fontSize:13,marginTop:16}}>
          {mode==="login"?"No account? ":"Have an account? "}
          <button onClick={()=>{setMode(mode==="login"?"signup":"login");setErr("");setOk("");}} style={{background:"none",border:"none",color:T.accent,cursor:"pointer",fontWeight:700,fontFamily:"inherit",fontSize:13}}>
            {mode==="login"?"Sign up free →":"Sign in →"}
          </button>
        </p>}
        {mode==="reset"&&<p style={{textAlign:"center",marginTop:14}}>
          <button onClick={()=>{setMode("login");setErr("");setOk("");}} style={{background:"none",border:"none",color:T.accent,cursor:"pointer",fontFamily:"inherit",fontSize:13}}>← Back to login</button>
        </p>}
      </Card>}
      <MeshCode/>
    </div>
  </div>;
}

// ─── LANDING PAGE ─────────────────────────────────────────
// ── Shared currency detection hook ────────────────────────
function useCurrency(){
  const [currency, setCurrency] = useState({symbol:"₦", code:"NGN", name:"Nigerian Naira"});
  const [localPkgs, setLocalPkgs] = useState(PACKAGES);

  useEffect(()=>{
    fetch(`${process.env.REACT_APP_API_URL||""}/api/payment/currency`)
      .then(r=>r.json())
      .then(d=>{
        const cur = d.currency||{};
        if(cur.code && cur.code !== "USD" && d.packages?.length>0){
          setCurrency(cur);
          setLocalPkgs(d.packages.map(p=>({...p, price:p.displayPrice})));
        }
      })
      .catch(()=>{});
  },[]);

  return { currency, localPkgs };
}

// ── Live stats from backend ───────────────────────────────
function LiveStats() {
  const [count, setCount] = useState(null);
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    const API = process.env.REACT_APP_API_URL || "";
    fetch(`${API}/api/stats/public`)
      .then(r => r.json())
      .then(d => {
        setCount(d.userCount || 0);
        setLoaded(true);
      })
      .catch(() => {
        setCount(0);
        setLoaded(true);
      });
  }, []);

  // Show real count if > 0, else show a compelling minimum
  const displayCount = (loaded && count > 10)
    ? count.toLocaleString() + "+"
    : loaded ? "Growing fast 🚀" : "...";

  const stats = [
    { n: displayCount, l: "Africans Using Career Pilot", highlight: true, big: true },
    { n: "30+",  l: "African Countries" },
    { n: "23",   l: "Resume Templates" },
    { n: "10M+", l: "Job Listings" },
  ];

  return (
    <div style={{display:"flex",justifyContent:"center",gap:clamp(16,32),marginTop:36,flexWrap:"wrap"}}>
      {stats.map((s,i) => (
        <div key={i} style={{textAlign:"center",minWidth:80}}>
          <div style={{
            fontSize: s.big ? "clamp(22px,4vw,36px)" : "clamp(20px,3vw,28px)",
            fontWeight:900,
            color:s.highlight?T.gold:T.accent,
            lineHeight:1,
            transition:"all 0.5s ease"
          }}>
            {s.n}
          </div>
          <div style={{fontSize:12,color:s.highlight?T.gold:T.muted,marginTop:4,fontWeight:s.highlight?700:400}}>
            {s.l}
          </div>
        </div>
      ))}
    </div>
  );
}

function clamp(min, max) { return `clamp(${min}px,3vw,${max}px)`; }

// ── Testimonials — 3 real starters + user submissions ─────
const STARTER_TESTIMONIALS = [
  {
    name: "Adaeze Okonkwo", role: "Graduate Engineer", company: "Dangote Group",
    country: "🇳🇬 Lagos, Nigeria",
    quote: "I had been job hunting for 6 months with zero callbacks. Career Pilot rebuilt my CV in 3 minutes and I got an interview at Dangote Group the following week. I couldn't believe it.",
    avatar: "A", color: "#6366f1", verified: true,
  },
  {
    name: "Kofi Mensah", role: "Frontend Developer", company: "Andela",
    country: "🇬🇭 Accra, Ghana",
    quote: "The ATS optimizer is what got me the job. It told me I was missing 11 keywords. I added them, reapplied, and heard back in 48 hours. Career Pilot is genuinely different.",
    avatar: "K", color: "#10b981", verified: true,
  },
  {
    name: "Ngozi Adeyemi", role: "HR Manager", company: "GTBank",
    country: "🇳🇬 Abuja, Nigeria",
    quote: "Even as someone in HR who reviews CVs daily, Career Pilot showed me things I was doing wrong on my own CV. The cover letter tool alone is worth every kobo.",
    avatar: "N", color: "#f59e0b", verified: true,
  },
];

function TestimonialsSection() {
  const [userStories, setUserStories] = useState([]);

  useEffect(() => {
    fetch(`${process.env.REACT_APP_API_URL||""}/api/stories/approved`)
      .then(r => r.json())
      .then(d => setUserStories(d.stories || []))
      .catch(() => {});
  }, []);

  const all = [...STARTER_TESTIMONIALS, ...userStories];

  return (
    <div>
      <div style={{display:"grid",gridTemplateColumns:"repeat(auto-fit,minmax(280px,1fr))",gap:20,textAlign:"left",marginBottom:24}}>
        {all.map((t,i) => (
          <Card key={i} style={{padding:22,background:T.card,border:`1px solid ${t.color}22`}}>
            <div style={{display:"flex",gap:12,alignItems:"flex-start",marginBottom:14}}>
              <div style={{width:44,height:44,borderRadius:"50%",background:`linear-gradient(135deg,${t.color},${t.color}88)`,display:"flex",alignItems:"center",justifyContent:"center",fontWeight:800,fontSize:18,color:"#fff",flexShrink:0}}>{t.avatar}</div>
              <div style={{flex:1,minWidth:0}}>
                <div style={{display:"flex",alignItems:"center",gap:6,flexWrap:"wrap"}}>
                  <span style={{fontWeight:700,fontSize:14,color:T.text}}>{t.name}</span>
                  {t.verified&&<span style={{background:`${T.green}22`,color:T.green,fontSize:9,fontWeight:800,padding:"1px 6px",borderRadius:99}}>✓ VERIFIED</span>}
                </div>
                <div style={{fontSize:12,color:t.color,fontWeight:600,marginTop:1}}>{t.role} · {t.company}</div>
                <div style={{fontSize:11,color:T.muted,marginTop:1}}>{t.country}</div>
              </div>
            </div>
            <div style={{fontSize:13,color:T.muted,lineHeight:1.8,fontStyle:"italic"}}>"{t.quote}"</div>
            <div style={{marginTop:12,display:"flex",gap:2}}>
              {"★★★★★".split("").map((s,i) => <span key={i} style={{color:T.gold,fontSize:13}}>{s}</span>)}
            </div>
          </Card>
        ))}
      </div>
      {userStories.length > 0 && (
        <p style={{textAlign:"center",fontSize:13,color:T.muted}}>
          ✓ {userStories.length} verified user stor{userStories.length===1?"y":"ies"} · <span style={{color:T.accent}}>Real people, real results</span>
        </p>
      )}
    </div>
  );
}


function Landing({onGetStarted}){
  const { currency, localPkgs } = useCurrency();
  const sym = currency.symbol||"₦";
  const [faq,setFaq]=useState(null);
  const [search,setSearch]=useState("");
  const cats=[...new Set(CAREERS.map(c=>c.cat))];
  const [cat,setCat]=useState("All");
  const shown=CAREERS.filter(c=>{
    const ms=c.label.toLowerCase().includes(search.toLowerCase());
    const mc=cat==="All"||c.cat===cat;
    return ms&&mc;
  }).slice(0,48);

  const features=[
    {icon:"🌍",t:"Africa Job Board",d:"Search real jobs across 30+ African countries. Filter by state and city. 24 hours free trial, then ₦2,000 lifetime.",badge:"NEW",c:T.gold},
    {icon:"🤖",t:"AI Resume Builder",d:"Paste any job description and get a powerful, ATS-optimized resume tailored to that exact role in seconds.",badge:"HOT",c:T.accent},
    {icon:"📊",t:"ATS Score Analyzer",d:"Score your CV against any job posting. See exactly which keywords are missing and fix them before you apply.",c:T.green},
    {icon:"✉️",t:"Cover Letter AI",d:"Personalized, professional cover letters for any company in seconds. Never send a generic letter again.",c:"#818cf8"},
    {icon:"🎙️",t:"Interview Prep",d:"Real technical and behavioral questions with model answers — generated for your specific career and level.",c:T.gold},
    {icon:"🎨",t:"23 Pro Templates",d:"Beautiful resume designs in 4 layouts. Add your photo. Download as PDF. Ready for any employer.",c:T.accent2},
  ];
  const faqs=[
    {q:"Is Career Pilot free to use?",a:"Yes! You get 10 free points on signup — no credit card needed. Use them to build your first resume or try the ATS optimizer. Buy more points anytime in Naira (₦)."},
    {q:"How does the Africa Job Board work?",a:"Search real jobs across all African countries. Select your country and state, enter a job title, and see live listings with salaries. You get 24 hours free trial. After that, unlock forever for just ₦2,000 one-time payment."},
    {q:"How does the referral system work?",a:"Every user gets a unique referral link. Share it on WhatsApp, Instagram or TikTok. When a friend signs up using your link, you both earn 3 free points instantly. No limit — keep referring and keep earning."},
    {q:"How much do points cost?",a:"₦500 = 20pts · ₦1,000 = 55pts · ₦2,000 = 110pts · ₦3,000 = 170pts. Resume costs 4pts, ATS 4pts, Cover Letter 4pts, Interview Prep 2pts, PDF 2pts, Apply to Job 5pts."},
    {q:"What African countries does the Job Board cover?",a:"Nigeria, Ghana, Kenya, South Africa, Egypt, Tanzania, Uganda, Cameroon, Senegal, Ivory Coast, Rwanda, Zimbabwe, Zambia, Morocco, Algeria, Angola, Mozambique, Benin, Togo, Mali, Burkina Faso, Sudan, Malawi, Botswana, Namibia, Liberia, Madagascar and more — with state and region filters for each country."},
    {q:"How does AI build my resume?",a:"Tell it your career, experience and skills. Paste the job description for extra precision. The AI writes powerful bullet points with action verbs, numbers and ATS keywords tailored to that exact role — it reads like a human wrote it."},
    {q:"Can I add my photo to my resume?",a:"Yes! In Step 2 of the Resume Builder, you can upload a profile photo. It appears on the resume output and in your PDF download. Works with all 23 templates."},
  ];

  return <div style={{background:T.bg,color:T.text,fontFamily:"'Inter',sans-serif",minHeight:"100vh"}}>
    <style>{css}</style>
    {/* NAV */}
    <nav style={{position:"sticky",top:0,zIndex:100,background:`${T.bg}ee`,backdropFilter:"blur(20px)",borderBottom:`1px solid ${T.border}`,padding:"0 5%",display:"flex",alignItems:"center",justifyContent:"space-between",height:64}}>
      <Logo size={56}/>
      <div style={{display:"flex",gap:8}}>
        <Btn variant="ghost" size="sm" onClick={()=>onGetStarted("login")}>Sign In</Btn>
        <Btn size="sm" onClick={()=>onGetStarted("signup")}>Get Started Free →</Btn>
      </div>
    </nav>

    {/* HERO */}
    <section style={{padding:"80px 5% 60px",textAlign:"center",position:"relative",overflow:"hidden",animation:"fadeUp 0.8s ease"}}>
      <div style={{position:"absolute",inset:0,background:`radial-gradient(ellipse 80% 50% at 50% -10%,${T.accentGlow},transparent)`,pointerEvents:"none"}}/>
      <div style={{display:"inline-flex",alignItems:"center",gap:8,background:`${T.gold}22`,border:`1px solid ${T.gold}44`,borderRadius:99,padding:"6px 16px",marginBottom:20}}><span>🌍</span><span style={{fontSize:12,fontWeight:700,color:T.gold,letterSpacing:0.5}}>Africa's #1 AI Career Platform</span></div>
      <h1 style={{fontFamily:"'Sora',sans-serif",fontSize:"clamp(32px,6vw,64px)",fontWeight:800,lineHeight:1.06,margin:"0 auto 20px",maxWidth:900,letterSpacing:-2}}>
        Find a Job in Africa.<br/>
        <span style={{background:"linear-gradient(135deg,#6366f1,#8b5cf6,#f59e0b)",WebkitBackgroundClip:"text",WebkitTextFillColor:"transparent"}}>Build a Resume That Gets You Hired.</span>
      </h1>
      <p style={{color:T.muted,fontSize:"clamp(15px,2vw,18px)",maxWidth:560,margin:"0 auto 14px",lineHeight:1.7}}>
        Search <strong style={{color:T.text}}>real jobs across every African country</strong>. Build an AI-powered resume tailored to that exact job. Get called back. Get hired.
      </p>
      <p style={{color:T.green,fontSize:14,fontWeight:700,marginBottom:32}}>✓ 10 free points on signup &nbsp;·&nbsp; ✓ No credit card &nbsp;·&nbsp; ✓ 24hr Job Board trial free</p>
      <div style={{display:"flex",gap:12,justifyContent:"center",flexWrap:"wrap",marginBottom:14}}>
        <Btn size="lg" onClick={()=>onGetStarted("signup")}>🚀 Start Free — Get 10 Points</Btn>
        <Btn size="lg" variant="gold" onClick={()=>onGetStarted("signup")}>🌍 Try Job Board</Btn>
      </div>
      <p style={{color:T.muted,fontSize:12}}>Join thousands of Africans landing jobs with Career Pilot</p>
      <LiveStats/>
    </section>

    {/* PAIN POINT */}
    <section style={{padding:"60px 5%",background:T.surface}}>
      <div style={{maxWidth:960,margin:"0 auto",textAlign:"center"}}>
        <h2 style={{fontFamily:"'Sora',sans-serif",fontSize:"clamp(22px,4vw,36px)",fontWeight:800,letterSpacing:-1,marginBottom:12}}>Tired of Sending CVs and Hearing Nothing Back? 😩</h2>
        <p style={{color:T.muted,fontSize:15,lineHeight:1.8,maxWidth:600,margin:"0 auto 28px"}}>Most job seekers send the same generic CV to 50 companies and wonder why nobody calls back. Your CV is being <strong style={{color:T.red}}>rejected by software before a human even sees it.</strong> Career Pilot fixes that.</p>
        <div style={{display:"grid",gridTemplateColumns:"repeat(auto-fit,minmax(220px,1fr))",gap:12,textAlign:"left"}}>
          {[{bad:"❌ Generic CVs get ignored",good:"✅ AI tailors your CV to each job"},
            {bad:"❌ ATS software rejects you",good:"✅ ATS scorer shows what to fix"},
            {bad:"❌ Don't know what to write",good:"✅ AI writes powerful bullet points"},
            {bad:"❌ Can't find good African jobs",good:"✅ Real jobs in your state & country"},
            {bad:"❌ Cover letters sound generic",good:"✅ AI personalizes every letter"},
            {bad:"❌ Unprepared for interviews",good:"✅ Real questions with model answers"},
          ].map((item,i)=><Card key={i} style={{padding:14}}>
            <div style={{fontSize:13,color:T.red,marginBottom:6,fontWeight:600}}>{item.bad}</div>
            <div style={{fontSize:13,color:T.green,fontWeight:700}}>{item.good}</div>
          </Card>)}
        </div>
      </div>
    </section>

    {/* JOB BOARD HERO */}
    <section style={{padding:"80px 5%",background:T.bg,position:"relative",overflow:"hidden"}}>
      <div style={{position:"absolute",inset:0,background:`radial-gradient(ellipse 50% 60% at 90% 50%,${T.gold}15,transparent)`,pointerEvents:"none"}}/>
      <div style={{maxWidth:1100,margin:"0 auto",display:"grid",gridTemplateColumns:"repeat(auto-fit,minmax(300px,1fr))",gap:48,alignItems:"center"}}>
        <div>
          <div style={{display:"inline-flex",alignItems:"center",gap:8,background:`${T.gold}22`,border:`1px solid ${T.gold}44`,borderRadius:99,padding:"5px 16px",marginBottom:16}}>
            <span>🌍</span><span style={{fontSize:12,fontWeight:700,color:T.gold}}>NEW — AFRICA JOB BOARD</span>
          </div>
          <h2 style={{fontFamily:"'Sora',sans-serif",fontSize:"clamp(24px,4vw,44px)",fontWeight:800,letterSpacing:-1,marginBottom:14,lineHeight:1.1}}>
            Real Jobs.<br/><span style={{background:`linear-gradient(135deg,${T.gold},${T.accent})`,WebkitBackgroundClip:"text",WebkitTextFillColor:"transparent"}}>Your State. Your City.</span>
          </h2>
          <p style={{color:T.muted,fontSize:14,lineHeight:1.8,marginBottom:20}}>Search millions of real job listings across every African country. Filter by state and city. See salary ranges. Apply directly. Then build a tailored resume — all in one place.</p>
          <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:10,marginBottom:22}}>
            {[{icon:"📍",t:"Filter by State",d:"Lagos, Nairobi, Accra..."},
              {icon:"💰",t:"See Salaries",d:"Know your worth before applying"},
              {icon:"✦",t:"1-Click Resume",d:"Tailor your CV to any job"},
              {icon:"🆓",t:"24 hours Free",d:"Then ₦2,000 lifetime access"},
            ].map((f,i)=><div key={i} style={{background:T.card,borderRadius:10,padding:12,border:`1px solid ${T.border}`}}>
              <div style={{fontSize:18,marginBottom:3}}>{f.icon}</div>
              <div style={{fontWeight:700,fontSize:12,color:T.text}}>{f.t}</div>
              <div style={{fontSize:11,color:T.muted}}>{f.d}</div>
            </div>)}
          </div>
          <div style={{display:"flex",gap:10,flexWrap:"wrap",alignItems:"center"}}>
            <Btn variant="gold" size="lg" onClick={()=>onGetStarted("signup")}>🌍 Try Job Board Free</Btn>
            <div><div style={{fontSize:13,color:T.muted}}>24 hours free</div><div style={{fontSize:12,color:T.gold,fontWeight:700}}>Then ₦2,000 lifetime</div></div>
          </div>
        </div>
        <Card style={{padding:20,background:T.card}}>
          <div style={{fontSize:12,fontWeight:700,color:T.muted,marginBottom:12,letterSpacing:1}}>LIVE JOB SEARCH</div>
          <div style={{background:T.surface,borderRadius:10,padding:"9px 14px",marginBottom:8,fontSize:13,color:T.muted,border:`1px solid ${T.accent}44`}}>🔍 Software Engineer</div>
          <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:8,marginBottom:12}}>
            <div style={{background:T.surface,borderRadius:8,padding:"8px 10px",fontSize:12,color:T.muted}}>🇳🇬 Nigeria</div>
            <div style={{background:T.surface,borderRadius:8,padding:"8px 10px",fontSize:12,color:T.muted}}>Lagos State</div>
          </div>
          {[{t:"Senior Software Engineer",c:"Flutterwave",l:"Lagos, Nigeria",s:"₦800K–₦1.5M/yr",d:"2 days ago"},
            {t:"Frontend Developer",c:"Andela",l:"Remote, Africa",s:"₦450K/mo",d:"1 day ago"},
            {t:"Data Analyst",c:"MTN Nigeria",l:"Abuja",s:"₦500K–₦900K/yr",d:"3 days ago"},
          ].map((j,i)=><div key={i} style={{borderTop:`1px solid ${T.border}`,paddingTop:9,marginTop:9}}>
            <div style={{fontWeight:700,fontSize:13,color:T.text,marginBottom:2}}>{j.t}</div>
            <div style={{fontSize:12,color:T.accent,marginBottom:3}}>{j.c} · {j.l}</div>
            <div style={{display:"flex",justifyContent:"space-between"}}>
              <span style={{fontSize:11,color:T.green,fontWeight:700}}>{j.s}</span>
              <span style={{fontSize:10,color:T.muted}}>{j.d}</span>
            </div>
          </div>)}
          <div style={{marginTop:14}}><Btn full onClick={()=>onGetStarted("signup")}>View All Jobs →</Btn></div>
        </Card>
      </div>
      <div style={{maxWidth:1100,margin:"36px auto 0",textAlign:"center"}}>
        <p style={{fontSize:11,color:T.muted,marginBottom:10,fontWeight:700,letterSpacing:1}}>AVAILABLE IN ALL AFRICAN COUNTRIES</p>
        <div style={{display:"flex",flexWrap:"wrap",gap:6,justifyContent:"center"}}>
          {["🇳🇬 Nigeria","🇬🇭 Ghana","🇰🇪 Kenya","🇿🇦 S. Africa","🇪🇬 Egypt","🇹🇿 Tanzania","🇺🇬 Uganda","🇨🇲 Cameroon","🇸🇳 Senegal","🇨🇮 Ivory Coast","🇷🇼 Rwanda","🇿🇼 Zimbabwe","🇲🇦 Morocco","🇩🇿 Algeria","🇦🇴 Angola","🇧🇯 Benin","🇹🇬 Togo","🇲🇱 Mali","🇸🇩 Sudan","🇿🇲 Zambia","+ All 54 Countries"].map((c,i)=>(
            <span key={i} style={{background:T.card,border:`1px solid ${T.border}`,borderRadius:99,padding:"3px 10px",fontSize:12}}>{c}</span>
          ))}
        </div>
      </div>
    </section>


    {/* FEATURES */}
    <section style={{padding:"70px 5%",maxWidth:1200,margin:"0 auto"}}>
      <div style={{textAlign:"center",marginBottom:48}}>
        <Badge color="blue">FEATURES</Badge>
        <h2 style={{fontFamily:"'Sora',sans-serif",fontSize:"clamp(24px,4vw,42px)",fontWeight:800,marginTop:12,letterSpacing:-1}}>Everything You Need to Get Hired</h2>
        <p style={{color:T.muted,fontSize:15,marginTop:8,maxWidth:560,margin:"8px auto 0"}}>From finding the right job to landing the interview — Career Pilot has every tool you need.</p>
      </div>
      <div style={{display:"grid",gridTemplateColumns:"repeat(auto-fit,minmax(260px,1fr))",gap:18}}>
        {features.map((f,i)=><Card key={i} hover style={{padding:22,position:"relative",border:f.badge?`1px solid ${T.gold}44`:`1px solid ${T.border}`}}>
          {f.badge&&<div style={{position:"absolute",top:-10,right:14,background:`linear-gradient(135deg,${T.gold},#f97316)`,color:"#000",fontSize:9,fontWeight:800,padding:"2px 10px",borderRadius:99,letterSpacing:1}}>{f.badge}</div>}
          <div style={{fontSize:30,marginBottom:10}}>{f.icon}</div>
          <h3 style={{fontWeight:700,fontSize:15,marginBottom:6}}>{f.t}</h3>
          <p style={{color:T.muted,fontSize:13,lineHeight:1.6}}>{f.d}</p>
        </Card>)}
      </div>
    </section>

    {/* BEFORE/AFTER SECTION */}
    <section style={{padding:"80px 5%",background:T.surface}}>
      <div style={{maxWidth:1000,margin:"0 auto"}}>
        <div style={{textAlign:"center",marginBottom:48}}>
          <Badge color="blue">THE DIFFERENCE</Badge>
          <h2 style={{fontFamily:"'Sora',sans-serif",fontSize:"clamp(24px,4vw,40px)",fontWeight:800,margin:"12px 0 12px",letterSpacing:-1}}>Before Career Pilot vs After</h2>
          <p style={{color:T.muted,fontSize:15,maxWidth:520,margin:"0 auto"}}>This is the gap between getting ignored and getting hired.</p>
        </div>
        <div style={{display:"grid",gridTemplateColumns:"repeat(auto-fit,minmax(280px,1fr))",gap:20}}>
          {/* Before */}
          <div>
            <div style={{background:`${T.red}15`,border:`2px solid ${T.red}44`,borderRadius:16,padding:24,marginBottom:8}}>
              <div style={{fontSize:14,fontWeight:800,color:T.red,marginBottom:16,display:"flex",alignItems:"center",gap:8}}>❌ Without Career Pilot</div>
              {[
                "Generic CV sent to 50+ companies",
                "No idea why you're not getting callbacks",
                "Same cover letter copy-pasted everywhere",
                "Applying blindly with no ATS knowledge",
                "Hours spent searching job sites manually",
                "Unprepared for interviews, guessing questions",
              ].map((t,i)=><div key={i} style={{display:"flex",gap:10,marginBottom:10,fontSize:13,color:T.muted,lineHeight:1.5}}>
                <span style={{color:T.red,flexShrink:0,fontSize:16}}>✗</span>{t}
              </div>)}
            </div>
          </div>
          {/* After */}
          <div>
            <div style={{background:`${T.green}12`,border:`2px solid ${T.green}44`,borderRadius:16,padding:24,marginBottom:8}}>
              <div style={{fontSize:14,fontWeight:800,color:T.green,marginBottom:16,display:"flex",alignItems:"center",gap:8}}>✅ With Career Pilot</div>
              {[
                "CV tailored to each specific job in seconds",
                "ATS score shows exactly what to fix before applying",
                "Personalized cover letter for every application",
                "Know your keyword gaps before submitting",
                "Real jobs in Nigeria & Africa filtered by state",
                "Interview questions + model answers for your career",
              ].map((t,i)=><div key={i} style={{display:"flex",gap:10,marginBottom:10,fontSize:13,color:T.muted,lineHeight:1.5}}>
                <span style={{color:T.green,flexShrink:0,fontSize:16}}>✓</span>{t}
              </div>)}
            </div>
          </div>
        </div>
        <div style={{textAlign:"center",marginTop:32}}>
          <Btn size="lg" onClick={()=>onGetStarted("signup")}>🚀 Start Free — Get 10 Points</Btn>
          <p style={{color:T.muted,fontSize:12,marginTop:10}}>No credit card · Pay in Naira · 10 free points on signup</p>
        </div>
      </div>
    </section>

    {/* JOB BOARD HIGHLIGHT */}
    <section style={{padding:"80px 5%",background:T.bg,position:"relative",overflow:"hidden"}}>
      <div style={{position:"absolute",inset:0,background:`radial-gradient(ellipse 60% 60% at 80% 50%,${T.accentGlow},transparent)`,pointerEvents:"none"}}/>
      <div style={{maxWidth:1100,margin:"0 auto",display:"grid",gridTemplateColumns:"repeat(auto-fit,minmax(300px,1fr))",gap:48,alignItems:"center"}}>
        {/* Left — text */}
        <div>
          <div style={{display:"inline-flex",alignItems:"center",gap:8,background:`${T.gold}22`,border:`1px solid ${T.gold}44`,borderRadius:99,padding:"5px 14px",marginBottom:16}}>
            <span style={{fontSize:14}}>🌍</span>
            <span style={{fontSize:12,fontWeight:700,color:T.gold,letterSpacing:1}}>NEW — GLOBAL JOB BOARD</span>
          </div>
          <h2 style={{fontFamily:"'Sora',sans-serif",fontSize:"clamp(26px,4vw,44px)",fontWeight:800,letterSpacing:-1,marginBottom:16,lineHeight:1.1}}>
            Find Jobs From<br/><span style={{background:`linear-gradient(135deg,${T.gold},${T.accent})`,WebkitBackgroundClip:"text",WebkitTextFillColor:"transparent"}}>Anywhere in the World</span>
          </h2>
          <p style={{color:T.muted,fontSize:16,lineHeight:1.8,marginBottom:24}}>
            Search millions of real job listings from top employers across african countries. See salaries, apply instantly, and build a tailored resume for any job — all in one place.
          </p>
          {/* Stats */}
          <div style={{display:"flex",gap:24,marginBottom:28,flexWrap:"wrap"}}>
            {[
              {num:"10M+",label:"Job listings"},
              {num:"30+",label:"Countries"},
              {num:"1-click",label:"Resume build"},
            ].map((s,i)=><div key={i}>
              <div style={{fontSize:24,fontWeight:900,color:T.gold}}>{s.num}</div>
              <div style={{fontSize:12,color:T.muted}}>{s.label}</div>
            </div>)}
          </div>
          <div style={{display:"flex",gap:10,flexWrap:"wrap",alignItems:"center"}}>
            <Btn size="lg" variant="gold" onClick={()=>onGetStarted("signup")}>
              🌍 Get Job Board Access — ₦2,000
            </Btn>
            <span style={{fontSize:13,color:T.muted}}>Lifetime · ₦2,000 one-time</span>
          </div>
        </div>

        {/* Right — feature cards */}
        <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:12}}>
          {[
            {icon:"🔍",t:"Smart Search",d:"Search by title, skills or company name"},
            {icon:"📍",t:"Location Filter",d:"Filter by city, remote or country"},
            {icon:"💰",t:"Salary Ranges",d:"See exactly what each job pays"},
            {icon:"✦",t:"1-Click Resume",d:"Build a tailored resume for any job"},
            {icon:"✉️",t:"Cover Letter",d:"Generate a cover letter in seconds"},
            {icon:"🔗",t:"Direct Apply",d:"Apply directly on the company site"},
          ].map((f,i)=><div key={i} style={{background:`${T.card}ee`,border:`1px solid ${T.border}`,borderRadius:12,padding:14,backdropFilter:"blur(8px)"}}>
            <div style={{fontSize:22,marginBottom:6}}>{f.icon}</div>
            <div style={{fontWeight:700,fontSize:13,marginBottom:3,color:T.text}}>{f.t}</div>
            <div style={{fontSize:12,color:T.muted,lineHeight:1.5}}>{f.d}</div>
          </div>)}
        </div>
      </div>

      {/* Country flags row */}
      
    </section>

    {/* CAREERS SEARCH */}
    <section style={{padding:"70px 5%",background:T.surface}}>
      <div style={{maxWidth:1100,margin:"0 auto",textAlign:"center"}}>
        <Badge color="gold">50+ CAREERS</Badge>
        <h2 style={{fontFamily:"'Sora',sans-serif",fontSize:"clamp(24px,4vw,42px)",fontWeight:800,margin:"12px 0 8px",letterSpacing:-1}}>Built for Every Career in the World</h2>
        <p style={{color:T.muted,marginBottom:24,fontSize:15}}>From Software Engineers to Doctors, Designers to Lawyers.</p>
        <div style={{position:"relative",maxWidth:480,margin:"0 auto 20px"}}>
          <span style={{position:"absolute",left:16,top:"50%",transform:"translateY(-50%)",color:T.muted}}>🔍</span>
          <input value={search} onChange={e=>setSearch(e.target.value)} placeholder="Search any career..."
            style={{width:"100%",background:T.card,border:`1px solid ${T.accent}`,borderRadius:99,padding:"12px 20px 12px 46px",color:T.text,fontSize:15,outline:"none",fontFamily:"inherit"}}/>
        </div>
        <div style={{display:"flex",gap:6,flexWrap:"wrap",justifyContent:"center",marginBottom:20}}>
          {["All",...cats].map(c=><button key={c} onClick={()=>setCat(c)} style={{padding:"4px 14px",borderRadius:99,border:`1px solid ${cat===c?T.accent:T.border}`,background:cat===c?`${T.accent}22`:T.card,color:cat===c?T.accent:T.muted,cursor:"pointer",fontFamily:"inherit",fontSize:12,fontWeight:600}}>{c}</button>)}
        </div>
        <div style={{display:"flex",flexWrap:"wrap",gap:8,justifyContent:"center"}}>
          {shown.map(c=><button key={c.id} onClick={()=>onGetStarted("signup")} style={{background:T.card,border:`1px solid ${T.border}`,borderRadius:12,padding:"8px 16px",color:T.text,cursor:"pointer",fontSize:13,fontWeight:600,display:"flex",alignItems:"center",gap:7,transition:"all 0.15s",fontFamily:"inherit"}}
            onMouseEnter={e=>{e.currentTarget.style.borderColor=T.accent;e.currentTarget.style.color=T.accent;}}
            onMouseLeave={e=>{e.currentTarget.style.borderColor=T.border;e.currentTarget.style.color=T.text;}}>
            {c.icon} {c.label}
          </button>)}
        </div>
      </div>
    </section>

    {/* TEMPLATES PREVIEW */}
    <section style={{padding:"70px 5%",maxWidth:1100,margin:"0 auto",textAlign:"center"}}>
      <Badge color="blue">TEMPLATES</Badge>
      <h2 style={{fontFamily:"'Sora',sans-serif",fontSize:"clamp(24px,4vw,42px)",fontWeight:800,margin:"12px 0 40px",letterSpacing:-1}}>10 Beautiful Resume Designs</h2>
      <div style={{display:"flex",gap:12,overflowX:"auto",paddingBottom:8,justifyContent:"center",flexWrap:"wrap"}}>
        {TEMPLATES.map(t=><div key={t.id} style={{flexShrink:0,cursor:"pointer",borderRadius:10,overflow:"hidden",border:`2px solid ${T.border}`,width:120,transition:"all 0.2s"}}
          onMouseEnter={e=>{e.currentTarget.style.borderColor=T.accent;e.currentTarget.style.transform="translateY(-4px)";}}
          onMouseLeave={e=>{e.currentTarget.style.borderColor=T.border;e.currentTarget.style.transform="none";}}>
          <div style={{background:t.headerBg,padding:"10px 14px"}}>
            <div style={{width:"60%",height:7,background:t.headerText,borderRadius:3,opacity:0.85,marginBottom:5}}/>
            <div style={{width:"40%",height:4,background:t.headerText,borderRadius:3,opacity:0.5}}/>
          </div>
          <div style={{background:t.body,padding:"8px 10px"}}>
            {[70,90,55,80].map((w,i)=><div key={i} style={{height:3,background:t.accent,borderRadius:2,marginBottom:4,width:`${w}%`,opacity:i===0?1:0.3}}/>)}
          </div>
          <div style={{background:t.body,padding:"4px 10px 8px",textAlign:"left"}}>
            <span style={{fontSize:9,color:t.accent,fontWeight:700}}>{t.name}</span>
          </div>
        </div>)}
      </div>
    </section>

    {/* TESTIMONIALS */}
    <section style={{padding:"70px 5%",background:T.surface}}>
      <div style={{maxWidth:1100,margin:"0 auto",textAlign:"center"}}>
        <Badge color="green">SUCCESS STORIES</Badge>
        <h2 style={{fontFamily:"'Sora',sans-serif",fontSize:"clamp(24px,4vw,40px)",fontWeight:800,margin:"12px 0 8px",letterSpacing:-1}}>Real People. Real Results.</h2>
        <p style={{color:T.muted,fontSize:15,marginBottom:36}}>Verified stories from Career Pilot users across Africa.</p>
        <TestimonialsSection/>
      </div>
    </section>

    {/* FAQ */}
    <section style={{padding:"70px 5%",maxWidth:720,margin:"0 auto"}}>
      <div style={{textAlign:"center",marginBottom:40}}>
        <Badge color="blue">FAQ</Badge>
        <h2 style={{fontFamily:"'Sora',sans-serif",fontSize:"clamp(24px,4vw,42px)",fontWeight:800,marginTop:12,letterSpacing:-1}}>Common Questions</h2>
      </div>
      {faqs.map((f,i)=><Card key={i} style={{marginBottom:10,padding:18,cursor:"pointer"}} onClick={()=>setFaq(faq===i?null:i)}>
        <div style={{display:"flex",justifyContent:"space-between",gap:12}}>
          <span style={{fontWeight:600,fontSize:14}}>{f.q}</span>
          <span style={{color:T.accent,fontSize:20,flexShrink:0,transform:faq===i?"rotate(45deg)":"none",transition:"transform 0.2s"}}>+</span>
        </div>
        {faq===i&&<p style={{color:T.muted,fontSize:13,lineHeight:1.7,marginTop:12}}>{f.a}</p>}
      </Card>)}
    </section>

    {/* CTA */}
    <section style={{padding:"80px 5%",textAlign:"center",position:"relative",overflow:"hidden"}}>
      <div style={{position:"absolute",inset:0,background:`radial-gradient(ellipse 60% 60% at 50% 50%,${T.accentGlow},transparent)`}}/>
      <h2 style={{fontFamily:"'Sora',sans-serif",fontSize:"clamp(26px,5vw,52px)",fontWeight:800,letterSpacing:-2,marginBottom:16}}>Ready for Takeoff? ✈️</h2>
      <p style={{color:T.muted,fontSize:17,marginBottom:36,maxWidth:440,margin:"0 auto 36px"}}>Join thousands landing their dream jobs with Career Pilot.</p>
      <Btn size="lg" onClick={()=>onGetStarted("signup")}>Start Free — Get 10 Points →</Btn>
    </section>

    <footer style={{borderTop:`1px solid ${T.border}`,padding:"24px 5%",display:"flex",justifyContent:"space-between",alignItems:"center",flexWrap:"wrap",gap:12}}>
      <Logo size={56}/>
      <span style={{color:T.muted,fontSize:13}}>© 2025 Career Pilot. All rights reserved. Global AI Career Platform.</span>
      <MeshCode/>
    </footer>
  </div>;
}

// ── First-Time User Guide ─────────────────────────────────
function FirstTimeGuide({onDone}){
  const [step,setStep]=useState(0);
  const steps=[
    {icon:"🌍",title:"Find Your Job First",desc:"Start in the Job Board. Search for jobs in your country and state. Find a role you like — then use Career Pilot to apply for it perfectly.",action:"Got it!"},
    {icon:"✦",title:"Build a Tailored Resume",desc:"Copy the job description from any listing. Paste it into the AI Resume Builder. The AI will tailor your resume specifically for that job with the right keywords.",action:"Next →"},
    {icon:"📊",title:"Check Your ATS Score",desc:"Paste your resume and the job description into the ATS Optimizer. See your score (aim for 80%+) and fix the missing keywords before you apply.",action:"Next →"},
    {icon:"✉️",title:"Generate a Cover Letter",desc:"Enter the company name and role. The AI writes a personalized, professional cover letter. Takes 10 seconds. Stands out from generic applications.",action:"Next →"},
    {icon:"🎙️",title:"Prepare for Interviews",desc:"Once you get a callback, use Interview Prep to practice. Get real questions with model answers for your specific career and experience level.",action:"Next →"},
    {icon:"🎁",title:"Earn Free Points by Referring",desc:"Share your referral link with friends. When they sign up, you both get 3 free points. Find your link in the Refer & Earn tab in the sidebar.",action:"Start Using Career Pilot →"},
  ];
  const s=steps[step];
  return <div style={{position:"fixed",inset:0,zIndex:9999,background:"rgba(0,0,0,0.85)",display:"flex",alignItems:"center",justifyContent:"center",padding:20}}>
    <div style={{background:T.card,border:`1px solid ${T.border}`,borderRadius:20,padding:"36px 32px",maxWidth:480,width:"100%",animation:"popIn 0.3s ease"}}>
      <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:20}}>
        <span style={{fontSize:12,color:T.muted,fontWeight:700}}>QUICK START GUIDE</span>
        <button onClick={onDone} style={{background:"none",border:"none",color:T.muted,cursor:"pointer",fontSize:18}}>✕</button>
      </div>
      {/* Progress dots */}
      <div style={{display:"flex",gap:6,marginBottom:24,justifyContent:"center"}}>
        {steps.map((_,i)=><div key={i} style={{width:i===step?24:8,height:8,borderRadius:99,background:i<=step?T.accent:T.border,transition:"all 0.3s"}}/>)}
      </div>
      <div style={{textAlign:"center",marginBottom:24}}>
        <div style={{fontSize:56,marginBottom:12}}>{s.icon}</div>
        <h2 style={{fontFamily:"'Sora',sans-serif",fontWeight:800,fontSize:22,marginBottom:10,color:T.text}}>{s.title}</h2>
        <p style={{color:T.muted,fontSize:14,lineHeight:1.8}}>{s.desc}</p>
      </div>
      <div style={{display:"flex",gap:10}}>
        {step>0&&<Btn variant="ghost" onClick={()=>setStep(s=>s-1)} style={{flex:1,justifyContent:"center"}}>← Back</Btn>}
        <Btn onClick={()=>step<steps.length-1?setStep(s=>s+1):onDone()} style={{flex:2,justifyContent:"center"}}>{s.action}</Btn>
      </div>
      <p style={{textAlign:"center",fontSize:12,color:T.muted,marginTop:12,cursor:"pointer"}} onClick={onDone}>Skip guide</p>
    </div>
  </div>;
}


// ─── DASHBOARD SHELL ───────────────────────────────────────
function Dashboard(){
  const {user, logout, setPoints} = useAuth();
  const [tab, setTab]     = useState("home");
  const [menu, setMenu]   = useState(false);
  const [toast, setToast] = useState({msg:"",type:"ok"});
  const [showGuide, setShowGuide] = useState(()=>{
    // Show guide for first-time users (only once)
    const seen = localStorage.getItem("cp_guide_seen");
    return !seen;
  });
  const toast_ = (msg,type="ok")=>setToast({msg,type});

  const nav=[
    {id:"home",icon:"⊞",label:"Dashboard"},
    {id:"builder",icon:"✦",label:"Resume Builder"},
    {id:"ats",icon:"📊",label:"ATS Optimizer"},
    {id:"cover",icon:"✉️",label:"Cover Letter"},
    {id:"interview",icon:"🎙️",label:"Interview Prep"},
    {id:"templates",icon:"🎨",label:"Templates"},
    {id:"points",icon:"✦",label:"Buy Points"},
    {id:"myresumes",icon:"📄",label:"My Resumes"},
    {id:"jobs",icon:"🌍",label:"Job Board"},
    {id:"savedjobs",icon:"🔖",label:"Saved Jobs"},
    {id:"refer",icon:"🎁",label:"Refer & Earn"},
    {id:"feedback",icon:"💬",label:"Send Feedback"},
    {id:"story",   icon:"🌟",label:"Share Your Win"},
    {id:"profile",icon:"👤",label:"Profile"},
    ...(user?.isAdmin?[{id:"admin",icon:"🛡️",label:"Admin Panel"}]:[]),
  ];

  const go=(id)=>{setTab(id);setMenu(false);};

  return <div style={{minHeight:"100vh",background:T.bg,color:T.text,fontFamily:"'Inter',sans-serif"}}>
    <style>{css}</style>
    {/* Top bar */}
    <header style={{position:"sticky",top:0,zIndex:300,background:`${T.surface}f0`,backdropFilter:"blur(20px)",borderBottom:`1px solid ${T.border}`,display:"flex",alignItems:"center",justifyContent:"space-between",padding:"10px 16px",height:60}}>
      <div style={{display:"flex",alignItems:"center",gap:12}}>
        <button onClick={()=>setMenu(!menu)} style={{background:"none",border:`1px solid ${T.border}`,color:T.text,cursor:"pointer",padding:"6px 10px",borderRadius:8,fontSize:18,lineHeight:1}}>☰</button>
        <Logo size={56}/>
      </div>
      <div style={{display:"flex",alignItems:"center",gap:8}}>
        <PointsBadge pts={user?.points||0} onClick={()=>go("points")}/>
        {user?.isAdmin&&<button onClick={()=>go("admin")} style={{background:`${T.red}22`,border:`1px solid ${T.red}44`,color:T.red,borderRadius:8,padding:"5px 10px",cursor:"pointer",fontFamily:"inherit",fontSize:11,fontWeight:700}}>🛡️ ADMIN</button>}
        <button onClick={()=>{
          const isDark = document.body.style.background !== LIGHT_THEME.bg;
          const theme = isDark ? LIGHT_THEME : DARK_THEME;
          Object.assign(T, theme);
          document.body.style.background = theme.bg;
          document.body.style.color = theme.text;
          // Force re-render by toggling a class
          document.body.classList.toggle("light-mode");
          setMenu(m=>m); // trigger re-render
        }} style={{background:`${T.border}`,border:"none",color:T.muted,borderRadius:8,padding:"6px 10px",cursor:"pointer",fontFamily:"inherit",fontSize:16,lineHeight:1}} title="Toggle dark/light mode">
          {document.body.classList.contains("light-mode")?"☀️":"🌙"}
        </button>
        <div onClick={()=>go("profile")} style={{width:36,height:36,borderRadius:"50%",background:`linear-gradient(135deg,${T.accent},${T.accent2})`,display:"flex",alignItems:"center",justifyContent:"center",fontWeight:800,fontSize:15,cursor:"pointer",flexShrink:0}}>{user?.name?.[0]?.toUpperCase()||"U"}</div>
      </div>
    </header>

    <div style={{display:"flex",position:"relative"}}>
      {menu&&<div onClick={()=>setMenu(false)} style={{position:"fixed",inset:0,background:"rgba(0,0,0,0.55)",zIndex:198,top:60}}/>}
      {/* Sidebar */}
      <aside style={{position:"fixed",top:60,left:0,bottom:0,width:230,zIndex:199,background:T.surface,borderRight:`1px solid ${T.border}`,display:"flex",flexDirection:"column",transform:menu?"translateX(0)":"translateX(-100%)",transition:"transform 0.28s ease",overflowY:"auto"}}>
        <nav style={{flex:1,padding:"12px 8px"}}>
          {nav.map(n=><button key={n.id} onClick={()=>go(n.id)} style={{display:"flex",alignItems:"center",gap:10,width:"100%",padding:"11px 14px",borderRadius:10,border:"none",cursor:"pointer",marginBottom:3,background:tab===n.id?`${T.accent}22`:"transparent",color:tab===n.id?T.accent:T.muted,fontFamily:"inherit",fontSize:14,fontWeight:tab===n.id?700:500,transition:"all 0.15s",textAlign:"left"}}>
            <span style={{fontSize:16,flexShrink:0}}>{n.icon}</span>{n.label}
          </button>)}
        </nav>
        <div style={{padding:"12px 10px",borderTop:`1px solid ${T.border}`}}>
          <div style={{display:"flex",alignItems:"center",gap:10,padding:"8px 10px",marginBottom:8}}>
            <div style={{width:34,height:34,borderRadius:"50%",background:`linear-gradient(135deg,${T.accent},${T.accent2})`,display:"flex",alignItems:"center",justifyContent:"center",fontWeight:800,fontSize:14,flexShrink:0}}>{user?.name?.[0]?.toUpperCase()||"U"}</div>
            <div style={{minWidth:0}}>
              <div style={{fontSize:13,fontWeight:700,overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"}}>{user?.name}</div>
              <div style={{fontSize:11,color:T.gold,fontWeight:700}}>✦ {user?.points||0} pts</div>
            </div>
          </div>
          <button onClick={logout} style={{display:"flex",alignItems:"center",gap:8,width:"100%",padding:"9px 12px",border:`1px solid ${T.border}`,background:"transparent",color:T.muted,cursor:"pointer",fontFamily:"inherit",fontSize:13,borderRadius:8}}>← Sign Out</button>
        </div>
      </aside>

      {/* Main */}
      <main style={{flex:1,width:"100%",padding:"clamp(16px,4vw,28px)",minHeight:"calc(100vh - 60px)",overflowX:"hidden"}}>
        {tab==="home"      && <Home go={go} setPoints={setPoints}/>}
        {tab==="builder"   && <Builder toast_={toast_} setPoints={setPoints}/>}
        {tab==="ats"       && <ATS toast_={toast_} setPoints={setPoints}/>}
        {tab==="cover"     && <Cover toast_={toast_} setPoints={setPoints}/>}
        {tab==="interview" && <Interview toast_={toast_} setPoints={setPoints}/>}
        {tab==="templates" && <TemplatesPage/>}
        {tab==="points"    && <PointsPage toast_={toast_}/>}
      {tab==="myresumes" && <MyResumes toast_={toast_} setTab={go}/>}
      {tab==="jobs"      && <JobBoard toast_={toast_} setTab={go}/>}
      {tab==="savedjobs" && <SavedJobs toast_={toast_} setTab={go}/>}
      {tab==="refer"     && <ReferPage toast_={toast_}/>}
      {tab==="feedback"  && <FeedbackPage toast_={toast_}/>}
      {tab==="story"     && <SuccessStoryPage toast_={toast_}/>}
        {tab==="profile"   && <Profile go={go}/>}
        {tab==="admin"     && user?.isAdmin && <Admin toast_={toast_}/>}
      </main>
    </div>
    <Toast msg={toast.msg} type={toast.type} onClose={()=>setToast({msg:"",type:"ok"})}/>
    {showGuide&&<FirstTimeGuide onDone={()=>{setShowGuide(false);localStorage.setItem("cp_guide_seen","1");}}/>}

    {/* Mobile bottom navigation */}
    <div style={{position:"fixed",bottom:0,left:0,right:0,zIndex:400,background:T.surface,borderTop:`1px solid ${T.border}`,display:"flex",justifyContent:"space-around",padding:"8px 4px 12px",backdropFilter:"blur(20px)"}}>
      {[
        {id:"home",  icon:"⊞", label:"Home"},
        {id:"builder",icon:"✦",label:"Resume"},
        {id:"jobs",  icon:"🌍",label:"Jobs"},
        {id:"points",icon:"✦", label:"Points"},
        {id:"profile",icon:"👤",label:"Profile"},
      ].map(n=><button key={n.id} onClick={()=>go(n.id)} style={{display:"flex",flexDirection:"column",alignItems:"center",gap:3,background:"none",border:"none",cursor:"pointer",padding:"4px 8px",fontFamily:"inherit",flex:1,minWidth:0}}>
        <span style={{fontSize:20,lineHeight:1}}>{n.icon}</span>
        <span style={{fontSize:10,fontWeight:tab===n.id?700:500,color:tab===n.id?T.accent:T.muted,whiteSpace:"nowrap"}}>{n.label}</span>
        {tab===n.id&&<div style={{width:20,height:2,borderRadius:1,background:T.accent,marginTop:1}}/>}
      </button>)}
    </div>
    {/* Bottom nav spacer */}
    <div style={{height:64}}/>
  </div>;
}

// ─── HOME ─────────────────────────────────────────────────
function Home({go}){
  const {user}=useAuth();
  return <div>
    <div style={{marginBottom:22}}>
      <h1 style={{fontFamily:"'Sora',sans-serif",fontWeight:800,fontSize:"clamp(20px,4vw,28px)",letterSpacing:-1}}>Welcome back, {user?.name} ✈️</h1>
      <p style={{color:T.muted,marginTop:6,fontSize:14}}>Your AI career co-pilot is ready. What are we building today?</p>
    </div>
    {/* Points card */}
    <Card style={{marginBottom:18,background:`linear-gradient(135deg,${T.gold}15,${T.accent}15)`,border:`1px solid ${T.gold}44`,padding:20}}>
      <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",flexWrap:"wrap",gap:12}}>
        <div>
          <div style={{fontSize:11,color:T.muted,fontWeight:700,letterSpacing:1,marginBottom:4}}>YOUR BALANCE</div>
          <div style={{fontSize:42,fontWeight:900,color:T.gold,lineHeight:1}}>✦ {user?.points||0}</div>
          <div style={{fontSize:11,color:T.muted,marginTop:6,lineHeight:1.8}}>
            Resume {COSTS.RESUME}pts · ATS {COSTS.ATS}pts · Cover Letter {COSTS.COVER}pts · Interview {COSTS.INTERVIEW}pts · PDF {COSTS.PDF}pts · Apply {COSTS.APPLY}pts
          </div>
        </div>
        <Btn variant="gold" size="sm" onClick={()=>go("points")}>✦ Buy More Points</Btn>
      </div>
    </Card>
    {/* Stats */}
    <div style={{display:"grid",gridTemplateColumns:"repeat(auto-fit,minmax(120px,1fr))",gap:10,marginBottom:18}}>
      {[{icon:"📄",l:"Resumes",v:user?.resumes?.length||0,c:T.accent},{icon:"📊",l:"ATS Scans",v:user?.atsScans?.length||0,c:T.green},{icon:"✉️",l:"Cover Letters",v:user?.coverLetters?.length||0,c:"#818cf8"},{icon:"✦",l:"Points",v:user?.points||0,c:T.gold}]
        .map((s,i)=><Card key={i} style={{textAlign:"center",padding:14}}>
          <div style={{fontSize:20,marginBottom:4}}>{s.icon}</div>
          <div style={{fontSize:24,fontWeight:900,color:s.c}}>{s.v}</div>
          <div style={{fontSize:11,color:T.muted,marginTop:2}}>{s.l}</div>
        </Card>)}
    </div>

    {/* Resume Strength Score */}
    {(user?.resumes?.length||0)>0&&(()=>{
      const score = Math.min(100, 40
        + ((user?.atsScans?.length||0)>0?20:0)
        + ((user?.coverLetters?.length||0)>0?20:0)
        + ((user?.resumes?.length||0)>1?10:0)
        + ((user?.points||0)>5?10:0));
      const color = score>=80?T.green:score>=55?T.gold:T.accent;
      const label = score>=80?"Job-Ready 🔥":score>=55?"Getting There 💪":"Keep Building ✦";
      const scorePct = score+"%";
      return <Card style={{marginBottom:18,padding:20,background:`${color}10`,border:`1px solid ${color}33`}}>
        <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:10,flexWrap:"wrap",gap:8}}>
          <div>
            <div style={{fontSize:11,color:T.muted,fontWeight:700,letterSpacing:1,marginBottom:3}}>CAREER PROFILE STRENGTH</div>
            <div style={{fontSize:22,fontWeight:900,color}}>{label}</div>
          </div>
          <div style={{fontSize:42,fontWeight:900,color,lineHeight:1}}>{score}%</div>
        </div>
        <div style={{height:8,background:T.border,borderRadius:4,overflow:"hidden",marginBottom:10}}>
          <div style={{height:"100%",background:`linear-gradient(90deg,${T.accent},${color})`,borderRadius:4,width:scorePct,transition:"width 1.2s ease"}}/>
        </div>
        <div style={{display:"flex",gap:12,flexWrap:"wrap"}}>
          {[
            {done:true,label:"Resume created"},
            {done:(user?.atsScans?.length||0)>0,label:"ATS scored"},
            {done:(user?.coverLetters?.length||0)>0,label:"Cover letter"},
            {done:(user?.resumes?.length||0)>1,label:"2+ resumes"},
          ].map((item,i)=><span key={i} style={{fontSize:11,color:item.done?T.green:T.muted,display:"flex",alignItems:"center",gap:4}}>
            {item.done?"✓":"○"} {item.label}
          </span>)}
        </div>
      </Card>;
    })()}
    {/* Actions */}
    <h2 style={{fontWeight:700,fontSize:15,marginBottom:12}}>Quick Actions</h2>
    <div style={{display:"grid",gridTemplateColumns:"repeat(2,1fr)",gap:10,marginBottom:18}}>
      {[{icon:"✦",t:"Build Resume",d:`${COSTS.RESUME} pts`,tab:"builder",c:T.accent},{icon:"📊",t:"ATS Score",d:`${COSTS.ATS} pts`,tab:"ats",c:T.green},{icon:"✉️",t:"Cover Letter",d:`${COSTS.COVER} pts`,tab:"cover",c:"#818cf8"},{icon:"🎙️",t:"Interview Prep",d:`${COSTS.INTERVIEW} pts`,tab:"interview",c:T.gold}]
        .map((a,i)=><Card key={i} hover onClick={()=>go(a.tab)} style={{display:"flex",gap:12,alignItems:"center",padding:14}}>
          <div style={{width:36,height:36,borderRadius:9,background:`${a.c}22`,display:"flex",alignItems:"center",justifyContent:"center",fontSize:16,flexShrink:0,color:a.c}}>{a.icon}</div>
          <div><div style={{fontWeight:700,fontSize:13}}>{a.t}</div><div style={{color:T.gold,fontSize:11,marginTop:2,fontWeight:700}}>{a.d}</div></div>
        </Card>)}
    </div>
    {(user?.points||0)<10&&<Card style={{background:`${T.accent}12`,border:`1px solid ${T.accent}33`,padding:16,marginBottom:14}}>
      <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",flexWrap:"wrap",gap:10}}>
        <div><div style={{fontWeight:700,fontSize:14}}>⚡ Low on points</div><div style={{color:T.muted,fontSize:13,marginTop:3}}>Top up to keep building.</div></div>
        <Btn size="sm" onClick={()=>go("points")}>Buy Points →</Btn>
      </div>
    </Card>}

    {/* Onboarding checklist */}
    {(()=>{
      const steps=[
        {done:true,                              label:"Create your account",              tab:null},
        {done:(user?.resumes?.length||0)>0,      label:"Generate your first AI resume",   tab:"builder"},
        {done:(user?.atsScans?.length||0)>0,     label:"Check your ATS score",            tab:"ats"},
        {done:(user?.coverLetters?.length||0)>0, label:"Write a cover letter",            tab:"cover"},
        {done:false,                             label:"Browse jobs in your country",      tab:"jobs"},
        {done:(user?.referralCount||0)>0,        label:"Refer a friend and earn points",  tab:"refer"},
      ];
      const done = steps.filter(s=>s.done).length;
      const pct  = Math.round((done/6)*100);
      if(done===6) return null; // hide when complete
      return <Card style={{background:T.surface,border:`1px solid ${T.border}`,padding:20,marginBottom:14}}>
        <h3 style={{fontWeight:800,fontSize:15,marginBottom:14}}>🚀 Get Started — {done}/6 steps</h3>
        {steps.map((item,i)=><div key={i} onClick={()=>!item.done&&item.tab&&go(item.tab)}
          style={{display:"flex",alignItems:"center",gap:12,padding:"9px 0",borderBottom:i<5?`1px solid ${T.border}`:"none",cursor:!item.done&&item.tab?"pointer":"default",opacity:item.done?0.55:1}}>
          <div style={{width:26,height:26,borderRadius:"50%",background:item.done?`${T.green}22`:`${T.accent}15`,border:`2px solid ${item.done?T.green:T.border}`,display:"flex",alignItems:"center",justifyContent:"center",fontSize:12,flexShrink:0,color:item.done?T.green:T.muted,fontWeight:700}}>
            {item.done?"✓":i+1}
          </div>
          <span style={{fontSize:13,fontWeight:item.done?400:600,color:item.done?T.muted:T.text,flex:1}}>{item.label}</span>
          {!item.done&&item.tab&&<span style={{color:T.accent,fontSize:12,fontWeight:700}}>→</span>}
        </div>)}
        <div style={{marginTop:14}}>
          <div style={{height:5,background:T.border,borderRadius:3,overflow:"hidden"}}>
            <div style={{height:"100%",background:`linear-gradient(90deg,${T.accent},${T.green})`,borderRadius:3,width:pct+"%",transition:"width 1s ease"}}/>
          </div>
          <div style={{fontSize:12,color:T.muted,marginTop:5}}>{pct}% complete</div>
        </div>
      </Card>;
    })()}
  </div>;
}

// ─── RESUME BUILDER ────────────────────────────────────────
function Builder({toast_, setPoints}){
  const {token,user}=useAuth();
  const [step,setStep]=useState(0);
  const [career,setCareer]=useState(null);
  const [form,setForm]=useState({name:"",email:"",phone:"",location:"",linkedin:"",experience:"",education:"",skills:"",jobDesc:""});
  const [tplId,setTplId]=useState("navy");
  const [result,setResult]=useState("");
  const [loading,setLoading]=useState(false);
  const [pdfLoad,setPdfLoad]=useState(false);
  const [err,setErr]=useState("");
  const [photo,setPhoto]=useState(null); // base64 data URL
  const [search,setSearch]=useState("");
  const [cat,setCat]=useState("All");
  const [customCareer,setCustomCareer]=useState("");
  const upd=(k,v)=>setForm(f=>({...f,[k]:v}));
  const c=career==="custom"?{label:customCareer||"Professional",icon:"✏️",skills:[]}:CAREERS.find(x=>x.id===career);
  const cats=["All",...new Set(CAREERS.map(x=>x.cat))];
  const filtered=CAREERS.filter(x=>{
    const ms=x.label.toLowerCase().includes(search.toLowerCase());
    const mc=cat==="All"||x.cat===cat;
    return ms&&mc;
  });
  const steps=["Career","Personal Info","Experience","Education & Skills","Your Resume"];

  const generate=async()=>{
    setLoading(true);setResult("");setErr("");
    try{
      const d=await apiFetch("/api/ai/resume","POST",{career:c.label,form},token);
      setResult(d.text);
      setPoints(d.points);
      toast_(`Resume generated! ✦ ${d.points} points remaining`);
    }catch(e){setErr(e.message);toast_(e.message,"err");}
    setLoading(false);
  };

  const exportPDF=async()=>{
    if(!result)return;
    setPdfLoad(true);
    try{
      const d=await apiFetch("/api/ai/pdf-export","POST",{},token);
      setPoints(d.points);
      const w=window.open("","_blank");
      w.document.write(buildPDF(result,form,tplId,photo));
      w.document.close();
      setTimeout(()=>w.print(),600);
      toast_(`PDF ready! ✦ ${d.points} points remaining`);
    }catch(e){toast_(e.message,"err");}
    setPdfLoad(false);
  };

  return <div style={{maxWidth:820}}>
    <h1 style={{fontFamily:"'Sora',sans-serif",fontWeight:800,fontSize:26,marginBottom:6}}>AI Resume Builder</h1>
    <p style={{color:T.muted,marginBottom:24,fontSize:14}}>Costs <strong style={{color:T.gold}}>✦ {COSTS.RESUME} points</strong> · PDF export costs ✦ {COSTS.PDF} points</p>

    {/* Step bar */}
    <div style={{display:"flex",marginBottom:28,alignItems:"center"}}>
      {steps.map((s,i)=><div key={i} style={{flex:1,display:"flex",alignItems:"center"}}>
        <div style={{display:"flex",flexDirection:"column",alignItems:"center",flex:1}}>
          <div style={{width:26,height:26,borderRadius:"50%",background:i<=step?`linear-gradient(135deg,${T.accent},${T.accent2})`:T.border,color:i<=step?"#fff":T.muted,display:"flex",alignItems:"center",justifyContent:"center",fontSize:11,fontWeight:800,transition:"all 0.3s"}}>{i<step?"✓":i+1}</div>
          <div style={{fontSize:10,color:i===step?T.accent:T.muted,marginTop:3,textAlign:"center",maxWidth:64,lineHeight:1.2}}>{s}</div>
        </div>
        {i<steps.length-1&&<div style={{height:2,flex:1,background:i<step?T.accent:T.border,marginBottom:16,transition:"background 0.3s"}}/>}
      </div>)}
    </div>

    <Card>
      {/* STEP 0 — Career */}
      {step===0&&<>
        <h2 style={{fontWeight:700,marginBottom:14}}>Select Your Career</h2>
        <div style={{position:"relative",marginBottom:12}}>
          <span style={{position:"absolute",left:12,top:"50%",transform:"translateY(-50%)",color:T.muted}}>🔍</span>
          <input value={search} onChange={e=>setSearch(e.target.value)} placeholder="Search 50+ careers..."
            style={{width:"100%",background:T.surface,border:`1px solid ${T.accent}`,borderRadius:10,padding:"9px 14px 9px 38px",color:T.text,fontSize:13,outline:"none",fontFamily:"inherit"}}/>
        </div>
        <div style={{display:"flex",gap:5,flexWrap:"wrap",marginBottom:14}}>
          {cats.map(ct=><button key={ct} onClick={()=>setCat(ct)} style={{padding:"3px 12px",borderRadius:99,border:`1px solid ${cat===ct?T.accent:T.border}`,background:cat===ct?`${T.accent}22`:T.surface,color:cat===ct?T.accent:T.muted,cursor:"pointer",fontFamily:"inherit",fontSize:11,fontWeight:600}}>{ct}</button>)}
        </div>
        <div style={{maxHeight:320,overflowY:"auto"}}>
          <div style={{display:"grid",gridTemplateColumns:"repeat(auto-fill,minmax(140px,1fr))",gap:8}}>
            {filtered.map(ca=><button key={ca.id} onClick={()=>setCareer(ca.id)} style={{background:career===ca.id?`${T.accent}22`:T.surface,border:`2px solid ${career===ca.id?T.accent:T.border}`,borderRadius:12,padding:"12px 8px",cursor:"pointer",textAlign:"center",transition:"all 0.2s",fontFamily:"inherit"}}>
              <div style={{fontSize:22,marginBottom:5}}>{ca.icon}</div>
              <div style={{fontSize:11,fontWeight:600,color:career===ca.id?T.accent:T.text,lineHeight:1.3}}>{ca.label}</div>
            </button>)}
          </div>
        </div>
        {/* Custom career input */}
        {career==="custom"&&<div style={{marginTop:12,padding:12,background:`${T.gold}15`,borderRadius:10,border:`1px solid ${T.gold}44`}}>
          <label style={{display:"block",fontSize:12,color:T.gold,fontWeight:700,marginBottom:6}}>Enter your career title:</label>
          <input value={customCareer} onChange={e=>setCustomCareer(e.target.value)} placeholder="e.g. Marine Biologist, Tattoo Artist, Drone Pilot..."
            style={{width:"100%",background:T.surface,border:`1px solid ${T.border}`,borderRadius:8,padding:"9px 12px",color:T.text,fontSize:14,outline:"none",fontFamily:"inherit"}}/>
        </div>}
        <div style={{marginTop:16,display:"flex",justifyContent:"flex-end"}}>
          <Btn onClick={()=>{if(career==="custom"&&!customCareer.trim()){return;}career&&setStep(1);}} disabled={!career||(career==="custom"&&!customCareer.trim())}>Next: Personal Info →</Btn>
        </div>
      </>}

      {/* STEP 1 — Personal */}
      {step===1&&<>
        <h2 style={{fontWeight:700,marginBottom:16}}>Personal Information</h2>

        {/* Photo upload */}
        <div style={{marginBottom:20,padding:16,background:T.surface,borderRadius:12,border:`1px solid ${T.border}`}}>
          <label style={{display:"block",fontSize:12,color:T.muted,marginBottom:10,fontWeight:600}}>Profile Photo (optional — appears on resume)</label>
          <div style={{display:"flex",alignItems:"center",gap:16,flexWrap:"wrap"}}>
            {photo
              ? <div style={{position:"relative"}}>
                  <img src={photo} alt="Profile" style={{width:80,height:80,borderRadius:"50%",objectFit:"cover",border:`3px solid ${T.accent}`}}/>
                  <button onClick={()=>setPhoto(null)} style={{position:"absolute",top:-6,right:-6,width:22,height:22,borderRadius:"50%",background:T.red,border:"none",color:"#fff",cursor:"pointer",fontSize:12,display:"flex",alignItems:"center",justifyContent:"center"}}>✕</button>
                </div>
              : <div style={{width:80,height:80,borderRadius:"50%",background:T.card,border:`2px dashed ${T.border}`,display:"flex",alignItems:"center",justifyContent:"center",fontSize:28}}>👤</div>
            }
            <div>
              <label style={{display:"inline-block",cursor:"pointer"}}>
                <input type="file" accept="image/*" style={{display:"none"}} onChange={e=>{
                  const file=e.target.files[0];
                  if(!file)return;
                  const reader=new FileReader();
                  reader.onload=ev=>setPhoto(ev.target.result);
                  reader.readAsDataURL(file);
                }}/>
                <span style={{background:`${T.accent}22`,border:`1px solid ${T.accent}`,color:T.accent,borderRadius:8,padding:"8px 16px",fontSize:13,fontWeight:700,cursor:"pointer"}}>
                  📷 {photo?"Change Photo":"Upload Photo"}
                </span>
              </label>
              <p style={{fontSize:11,color:T.muted,marginTop:6}}>JPG, PNG or WEBP. Max 2MB. Square photo works best.</p>
            </div>
          </div>
        </div>

        <div style={{display:"grid",gridTemplateColumns:"repeat(auto-fit,minmax(200px,1fr))",gap:"0 16px"}}>
          <Input label="Full Name" value={form.name} onChange={v=>upd("name",v)} placeholder="John Doe" required/>
          <Input label="Email" value={form.email} onChange={v=>upd("email",v)} placeholder="john@email.com" type="email"/>
          <Input label="Phone" value={form.phone} onChange={v=>upd("phone",v)} placeholder="+1 555 000 0000"/>
          <Input label="Location" value={form.location} onChange={v=>upd("location",v)} placeholder="New York, NY"/>
          <Input label="LinkedIn (optional)" value={form.linkedin} onChange={v=>upd("linkedin",v)} placeholder="linkedin.com/in/johndoe"/>
        </div>
        <div style={{display:"flex",justifyContent:"space-between"}}><Btn variant="ghost" onClick={()=>setStep(0)}>← Back</Btn><Btn onClick={()=>setStep(2)}>Next: Experience →</Btn></div>
      </>}

      {/* STEP 2 — Experience */}
      {step===2&&<>
        <h2 style={{fontWeight:700,marginBottom:8}}>Work Experience</h2>
        <div style={{padding:12,background:`${T.gold}15`,borderRadius:10,border:`1px solid ${T.gold}33`,marginBottom:14}}>
          <p style={{fontSize:13,color:T.gold,margin:0}}>💡 Include numbers: "managed 5 people", "increased sales 30%", "$50K budget" — AI turns these into powerful bullet points.</p>
        </div>
        <Input label="Work Experience" value={form.experience} onChange={v=>upd("experience",v)} multi rows={6}
          placeholder={`Job Title at Company Name (2022–Present)\n- Managed team of 5\n- Built X that improved Y by 30%\n\nJob Title at Another Company (2020–2022)\n- Assisted with...`}/>
        <div style={{display:"flex",justifyContent:"space-between"}}><Btn variant="ghost" onClick={()=>setStep(1)}>← Back</Btn><Btn onClick={()=>setStep(3)}>Next: Education →</Btn></div>
      </>}

      {/* STEP 3 — Education & Skills */}
      {step===3&&<>
        <h2 style={{fontWeight:700,marginBottom:16}}>Education & Skills</h2>
        <Input label="Education" value={form.education} onChange={v=>upd("education",v)} multi rows={3} placeholder={`B.Sc. Computer Science | University of Lagos | 2020\nGPA: 4.2/5.0`}/>
        <div style={{marginBottom:12}}>
          <label style={{display:"block",fontSize:12,color:T.muted,marginBottom:5,fontWeight:600}}>Quick-add skills for {c?.label}:</label>
          <div style={{display:"flex",flexWrap:"wrap",gap:6,marginBottom:10}}>
            {c?.skills.map(sk=><button key={sk} onClick={()=>upd("skills",form.skills?form.skills+", "+sk:sk)} style={{background:T.surface,border:`1px solid ${T.border}`,borderRadius:20,padding:"3px 12px",fontSize:12,color:T.muted,cursor:"pointer",fontFamily:"inherit"}}>+ {sk}</button>)}
          </div>
        </div>
        <Input label="Skills (comma-separated)" value={form.skills} onChange={v=>upd("skills",v)} placeholder="React, Node.js, Python..."/>
        <Input label="Paste Job Description (optional — for precise tailoring)" value={form.jobDesc} onChange={v=>upd("jobDesc",v)} multi rows={4} placeholder="Paste the full job posting here..."/>
        <div style={{display:"flex",justifyContent:"space-between"}}><Btn variant="ghost" onClick={()=>setStep(2)}>← Back</Btn><Btn onClick={()=>{setStep(4);generate();}}>✦ Generate Resume ({COSTS.RESUME} pts) →</Btn></div>
      </>}

      {/* STEP 4 — Result */}
      {step===4&&<>
        <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:14,flexWrap:"wrap",gap:10}}>
          <h2 style={{fontWeight:700}}>Your AI Resume</h2>
          <div style={{display:"flex",gap:8,flexWrap:"wrap"}}>
            <Btn variant="ghost" size="sm" onClick={()=>{setStep(0);setResult("");setErr("");}}>Start Over</Btn>
            {result&&<><Btn variant="ghost" size="sm" onClick={generate} loading={loading}>↺ Regenerate</Btn>
              <Btn variant="ghost" size="sm" onClick={()=>{navigator.clipboard.writeText(result);toast_("Copied!");}}>Copy Text</Btn>
              <Btn variant="gold" size="sm" onClick={exportPDF} loading={pdfLoad}>⬇ Download PDF ({COSTS.PDF} pts)</Btn>
            </>}
          </div>
        </div>
        {/* Template picker */}
        {result&&<div style={{marginBottom:14}}>
          <p style={{fontSize:12,color:T.muted,marginBottom:8,fontWeight:600}}>Choose Layout Style & Color:</p>
          {[
            {label:"Classic",layouts:["classic"]},
            {label:"Sidebar",layouts:["sidebar"]},
            {label:"Modern",layouts:["modern"]},
            {label:"Elegant",layouts:["elegant"]},
          ].map(group=>{
            const groupTemplates=TEMPLATES.filter(t=>(t.layout||"classic")===group.layouts[0]);
            const isActive=groupTemplates.some(t=>t.id===tplId);
            return <div key={group.label} style={{marginBottom:8}}>
              <span style={{fontSize:10,color:T.muted,fontWeight:700,letterSpacing:1,display:"block",marginBottom:5}}>{group.label.toUpperCase()}</span>
              <div style={{display:"flex",gap:5,flexWrap:"wrap"}}>
                {groupTemplates.map(t=><button key={t.id} onClick={()=>setTplId(t.id)} style={{padding:"4px 12px",borderRadius:99,border:`1px solid ${tplId===t.id?T.accent:T.border}`,background:tplId===t.id?`${T.accent}22`:T.surface,color:tplId===t.id?T.accent:T.muted,cursor:"pointer",fontFamily:"inherit",fontSize:11,fontWeight:600,display:"flex",alignItems:"center",gap:5}}>
                  <span style={{width:10,height:10,borderRadius:"50%",background:t.headerBg||t.accent||T.accent,display:"inline-block",flexShrink:0}}/>
                  {t.name}
                </button>)}
              </div>
            </div>;
          })}
        </div>}
        <ErrBox msg={err}/>
        {loading?<div style={{textAlign:"center",padding:"60px 0"}}>
          <Spin size={44}/>
          <p style={{color:T.muted,marginTop:18,fontSize:14}}>Building your resume...</p>
          <p style={{color:T.muted,fontSize:12,marginTop:6}}>Adding action verbs · Optimizing for ATS · Tailoring to {c?.label}</p>
        </div>:result&&<ResumeCard text={result} form={form} tid={tplId} photo={photo}/>}
      </>}
    </Card>
  </div>;
}

// ─── ATS OPTIMIZER ─────────────────────────────────────────
function ATS({toast_, setPoints}){
  const {token}=useAuth();
  const [resume,setResume]=useState("");
  const [job,setJob]=useState("");
  const [loading,setLoading]=useState(false);
  const [result,setResult]=useState(null);
  const [err,setErr]=useState("");

  const analyze=async()=>{
    if(!resume.trim()||!job.trim()){toast_("Paste both resume and job description","err");return;}
    setLoading(true);setResult(null);setErr("");
    try{
      const d=await apiFetch("/api/ai/ats","POST",{resume,jobDesc:job},token);
      setResult(d);setPoints(d.points);
      toast_(`ATS analysis done! ✦ ${d.points} pts remaining`);
    }catch(e){setErr(e.message);toast_(e.message,"err");}
    setLoading(false);
  };

  const score=result?.score||0;
  const scoreColor=score>=80?T.green:score>=55?T.gold:T.red;

  return <div style={{maxWidth:920}}>
    <h1 style={{fontFamily:"'Sora',sans-serif",fontWeight:800,fontSize:26,marginBottom:6}}>ATS Score Analyzer</h1>
    <p style={{color:T.muted,marginBottom:24,fontSize:14}}>Costs <strong style={{color:T.gold}}>✦ {COSTS.ATS} points</strong></p>
    <div style={{display:"grid",gridTemplateColumns:"repeat(auto-fit,minmax(280px,1fr))",gap:14,marginBottom:14}}>
      <Card style={{padding:16}}><Input label="Your Resume" value={resume} onChange={setResume} multi rows={8} placeholder="Paste your full resume text..."/></Card>
      <Card style={{padding:16}}><Input label="Job Description" value={job} onChange={setJob} multi rows={8} placeholder="Paste the job description..."/></Card>
    </div>
    <ErrBox msg={err}/>
    <Btn onClick={analyze} loading={loading} size="lg">📊 Analyze ATS Score ({COSTS.ATS} pts) →</Btn>
    {result&&<div style={{marginTop:28}}>
      {/* Score meter */}
      <div style={{display:"grid",gridTemplateColumns:"auto 1fr",gap:18,marginBottom:16}}>
        <Card style={{textAlign:"center",padding:20,minWidth:160}}>
          <svg width={140} height={84} viewBox="0 0 140 84">
            <path d="M15 75 A55 55 0 0 1 125 75" fill="none" stroke={T.border} strokeWidth={10} strokeLinecap="round"/>
            <path d="M15 75 A55 55 0 0 1 125 75" fill="none" stroke={scoreColor} strokeWidth={10} strokeLinecap="round" strokeDasharray={`${(score/100)*172} 172`} style={{transition:"stroke-dasharray 1.2s ease"}}/>
            <text x={70} y={70} textAnchor="middle" fill={scoreColor} fontSize={26} fontWeight={900} fontFamily="sans-serif">{score}%</text>
          </svg>
          <div style={{fontSize:12,color:T.muted,marginTop:-4}}>ATS Score</div>
          <div style={{marginTop:6}}><Badge color={score>=80?"green":score>=55?"gold":"blue"}>{score>=80?"Excellent":score>=55?"Good":"Needs Work"}</Badge></div>
        </Card>
        <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:12}}>
          <Card style={{padding:14}}>
            <h3 style={{fontWeight:700,fontSize:12,marginBottom:10,color:T.green}}>✓ Matched Keywords</h3>
            <div style={{display:"flex",flexWrap:"wrap",gap:5}}>{result.matched_keywords?.map((k,i)=><span key={i} style={{background:`${T.green}22`,color:T.green,padding:"3px 9px",borderRadius:99,fontSize:11}}>{k}</span>)}</div>
          </Card>
          <Card style={{padding:14}}>
            <h3 style={{fontWeight:700,fontSize:12,marginBottom:10,color:T.red}}>✗ Missing Keywords</h3>
            <div style={{display:"flex",flexWrap:"wrap",gap:5}}>{result.missing_keywords?.map((k,i)=><span key={i} style={{background:`${T.red}22`,color:T.red,padding:"3px 9px",borderRadius:99,fontSize:11}}>{k}</span>)}</div>
          </Card>
        </div>
      </div>
      <div style={{display:"grid",gridTemplateColumns:"repeat(auto-fit,minmax(260px,1fr))",gap:12}}>
        <Card style={{padding:16}}>
          <h3 style={{fontWeight:700,fontSize:12,marginBottom:10,color:T.gold}}>⚡ Optimization Tips</h3>
          {result.suggestions?.map((s,i)=><div key={i} style={{display:"flex",gap:10,marginBottom:10,fontSize:13,color:T.muted,lineHeight:1.5}}><span style={{color:T.gold,flexShrink:0}}>→</span>{s}</div>)}
        </Card>
        <Card style={{padding:16}}>
          <h3 style={{fontWeight:700,fontSize:12,marginBottom:10,color:T.accent}}>💪 Strengths</h3>
          {result.strengths?.map((s,i)=><div key={i} style={{display:"flex",gap:10,marginBottom:10,fontSize:13,color:T.muted,lineHeight:1.5}}><span style={{color:T.accent,flexShrink:0}}>✓</span>{s}</div>)}
        </Card>
      </div>
    </div>}
  </div>;
}

// ─── COVER LETTER ──────────────────────────────────────────
function Cover({toast_, setPoints}){
  const {token}=useAuth();
  const [career,setCareer]=useState("");
  const [company,setCompany]=useState("");
  const [role,setRole]=useState("");
  const [name,setName]=useState("");
  const [bg,setBg]=useState("");
  const [job,setJob]=useState("");
  const [loading,setLoading]=useState(false);
  const [letter,setLetter]=useState("");
  const [err,setErr]=useState("");

  const generate=async()=>{
    if(!career||!company||!role){toast_("Fill in career, company and role","err");return;}
    setLoading(true);setErr("");
    try{
      const d=await apiFetch("/api/ai/cover","POST",{career,company,role,name,background:bg,jobDesc:job},token);
      setLetter(d.text);setPoints(d.points);
      toast_(`Cover letter ready! ✦ ${d.points} pts remaining`);
    }catch(e){setErr(e.message);toast_(e.message,"err");}
    setLoading(false);
  };

  return <div style={{maxWidth:820}}>
    <h1 style={{fontFamily:"'Sora',sans-serif",fontWeight:800,fontSize:26,marginBottom:6}}>Cover Letter Generator</h1>
    <p style={{color:T.muted,marginBottom:24,fontSize:14}}>Costs <strong style={{color:T.gold}}>✦ {COSTS.COVER} points</strong></p>
    <Card style={{marginBottom:16}}>
      <div style={{display:"grid",gridTemplateColumns:"repeat(auto-fit,minmax(200px,1fr))",gap:"0 16px"}}>
        <Select label="Your Career" value={career} onChange={setCareer} options={[{value:"",label:"Select career..."},...CAREERS.map(c=>({value:c.label,label:`${c.icon} ${c.label}`}))]}/>
        <Input label="Your Name" value={name} onChange={setName} placeholder="John Doe"/>
        <Input label="Company Name" value={company} onChange={setCompany} placeholder="Google"/>
        <Input label="Role Applying For" value={role} onChange={setRole} placeholder="Senior Software Engineer"/>
      </div>
      <Input label="Your Background" value={bg} onChange={setBg} multi rows={3} placeholder="5 years in React/Node.js, shipped products used by 50K+ users..."/>
      <Input label="Job Description (optional)" value={job} onChange={setJob} multi rows={3} placeholder="Paste job posting for a perfectly tailored letter..."/>
      <ErrBox msg={err}/>
      <Btn onClick={generate} loading={loading}>✉️ Generate Cover Letter ({COSTS.COVER} pts) →</Btn>
    </Card>
    {letter&&<Card>
      <div style={{display:"flex",justifyContent:"space-between",marginBottom:14,flexWrap:"wrap",gap:8}}>
        <h3 style={{fontWeight:700}}>Your Cover Letter</h3>
        <div style={{display:"flex",gap:8}}>
          <Btn size="sm" variant="ghost" onClick={generate} loading={loading}>↺ Regenerate</Btn>
          <Btn size="sm" onClick={()=>{navigator.clipboard.writeText(letter);toast_("Copied!");}}>Copy</Btn>
        </div>
      </div>
      <div style={{background:T.surface,borderRadius:10,padding:24,fontSize:14,lineHeight:1.9,color:T.text,whiteSpace:"pre-wrap",fontFamily:"Georgia,serif"}}>{letter}</div>
    </Card>}
  </div>;
}

// ─── INTERVIEW PREP ────────────────────────────────────────
function Interview({toast_, setPoints}){
  const {token}=useAuth();
  const [career,setCareer]=useState("");
  const [level,setLevel]=useState("mid");
  const [job,setJob]=useState("");
  const [loading,setLoading]=useState(false);
  const [qs,setQs]=useState(null);
  const [open,setOpen]=useState(null);
  const [err,setErr]=useState("");

  const generate=async()=>{
    if(!career){toast_("Select a career","err");return;}
    setLoading(true);setQs(null);setErr("");
    try{
      const d=await apiFetch("/api/ai/interview","POST",{career,level,jobDesc:job},token);
      setQs(d);setPoints(d.points);
      toast_(`Questions ready! ✦ ${d.points} pts remaining`);
    }catch(e){setErr(e.message);toast_(e.message,"err");}
    setLoading(false);
  };

  const Sec=({title,items,icon,color})=><div style={{marginBottom:22}}>
    <h3 style={{fontWeight:700,marginBottom:12,display:"flex",alignItems:"center",gap:8,fontSize:15}}>{icon} {title} <Badge color="blue">{items?.length||0}</Badge></h3>
    {items?.map((it,i)=>{const k=`${title}${i}`;return <Card key={i} style={{marginBottom:8,padding:16,cursor:"pointer"}} onClick={()=>setOpen(open===k?null:k)}>
      <div style={{display:"flex",justifyContent:"space-between",gap:12}}>
        <p style={{fontWeight:600,fontSize:13,flex:1,lineHeight:1.5,margin:0}}>{it.q}</p>
        <span style={{color,flexShrink:0,fontSize:12}}>{open===k?"▲":"▼"}</span>
      </div>
      {open===k&&<div style={{marginTop:10,padding:12,background:`${color}12`,borderRadius:8,border:`1px solid ${color}30`}}>
        <p style={{fontSize:11,color,fontWeight:700,marginBottom:5}}>💡 SUGGESTED ANSWER</p>
        <p style={{fontSize:13,color:T.muted,lineHeight:1.7,margin:0}}>{it.a}</p>
      </div>}
    </Card>;})}
  </div>;

  return <div style={{maxWidth:820}}>
    <h1 style={{fontFamily:"'Sora',sans-serif",fontWeight:800,fontSize:26,marginBottom:6}}>Interview Prep</h1>
    <p style={{color:T.muted,marginBottom:24,fontSize:14}}>Costs <strong style={{color:T.gold}}>✦ {COSTS.INTERVIEW} points</strong></p>
    <Card style={{marginBottom:22}}>
      <div style={{display:"grid",gridTemplateColumns:"repeat(auto-fit,minmax(200px,1fr))",gap:"0 16px"}}>
        <Select label="Career" value={career} onChange={setCareer} options={[{value:"",label:"Select career..."},...CAREERS.map(c=>({value:c.label,label:`${c.icon} ${c.label}`}))]}/>
        <Select label="Experience Level" value={level} onChange={setLevel} options={[{value:"entry",label:"Entry Level (0–2 yrs)"},{value:"mid",label:"Mid Level (2–5 yrs)"},{value:"senior",label:"Senior Level (5+ yrs)"}]}/>
      </div>
      <Input label="Job Description (optional)" value={job} onChange={setJob} multi rows={3} placeholder="Paste for targeted questions..."/>
      <ErrBox msg={err}/>
      <Btn onClick={generate} loading={loading}>🎙️ Generate Questions ({COSTS.INTERVIEW} pts) →</Btn>
    </Card>
    {qs&&<><Sec title="Technical" items={qs.technical} icon="💻" color={T.accent}/><Sec title="Behavioral" items={qs.behavioral} icon="🤝" color={T.green}/><Sec title="Situational" items={qs.situational} icon="💡" color={T.gold}/></>}
  </div>;
}

// ─── TEMPLATES PAGE ────────────────────────────────────────
function TemplatesPage(){
  const [sel,setSel]=useState("navy");
  const sampleForm={name:"Alex Johnson",email:"alex@email.com",phone:"+1 555 000 0000",location:"New York, NY",linkedin:"linkedin.com/in/alexjohnson"};
  const sampleText=`[CONTACT]\nAlex Johnson\nalex@email.com | +1 555 000 0000 | New York, NY\nlinkedin.com/in/alexjohnson\n\n[SUMMARY]\nResults-driven Software Engineer with 5+ years building scalable web applications. Delivered products serving 2M+ users and led teams of up to 8 engineers. Expert in React, Node.js, and cloud infrastructure.\n\n[EXPERIENCE]\nSenior Software Engineer | TechCorp | 2021–Present\n• Led migration to microservices architecture, reducing latency by 40%\n• Mentored team of 5 junior engineers, improving sprint velocity by 30%\n• Built real-time analytics dashboard used by 500+ enterprise clients\nSoftware Engineer | StartupXYZ | 2019–2021\n• Shipped 12 product features that increased user retention by 25%\n• Reduced API response time by 60% through Redis caching\n\n[EDUCATION]\nB.Sc. Computer Science | University of Lagos | 2019\nGPA: 4.5/5.0\n\n[SKILLS]\nReact, Node.js, TypeScript, Python, PostgreSQL, AWS, Docker, Git`;
  const layoutGroups=[
    {label:"Classic",desc:"Full-width colored header. Clean and professional.",ids:TEMPLATES.filter(t=>(t.layout||"classic")==="classic").map(t=>t.id)},
    {label:"Sidebar",desc:"Left sidebar for contact & skills. Body for experience.",ids:TEMPLATES.filter(t=>t.layout==="sidebar").map(t=>t.id)},
    {label:"Modern",desc:"Gradient accent bar. Bold name. Contemporary feel.",ids:TEMPLATES.filter(t=>t.layout==="modern").map(t=>t.id)},
    {label:"Elegant",desc:"Centered name. Refined dividers. Best for creative roles.",ids:TEMPLATES.filter(t=>t.layout==="elegant").map(t=>t.id)},
  ];

  return <div style={{maxWidth:960}}>
    <h1 style={{fontFamily:"'Sora',sans-serif",fontWeight:800,fontSize:26,marginBottom:6}}>Resume Templates</h1>
    <p style={{color:T.muted,marginBottom:24,fontSize:14}}>10 professional, ATS-friendly designs. Select one to preview.</p>
    {/* Layout group tabs */}
    <div style={{display:"flex",gap:8,marginBottom:16,flexWrap:"wrap"}}>
      {layoutGroups.map(g=><button key={g.label} onClick={()=>{setSel(TEMPLATES.find(t=>(t.layout||"classic")===g.label.toLowerCase())?.id||sel)}} style={{padding:"6px 16px",borderRadius:8,border:`1px solid ${g.ids.includes(sel)?T.accent:T.border}`,background:g.ids.includes(sel)?`${T.accent}22`:T.surface,color:g.ids.includes(sel)?T.accent:T.muted,cursor:"pointer",fontFamily:"inherit",fontSize:12,fontWeight:700}}>
        {g.label} <span style={{fontSize:10,opacity:0.7}}>({g.ids.length})</span>
      </button>)}
    </div>
    {layoutGroups.map(g=><div key={g.label} style={{marginBottom:24}}>
      <div style={{marginBottom:10}}>
        <span style={{fontWeight:700,fontSize:14,color:T.text}}>{g.label} Layout </span>
        <span style={{fontSize:12,color:T.muted}}>— {g.desc}</span>
      </div>
      <div style={{display:"flex",gap:10,flexWrap:"wrap"}}>
        {TEMPLATES.filter(t=>(t.layout||"classic")===g.label.toLowerCase()).map(t=><div key={t.id} onClick={()=>setSel(t.id)} style={{cursor:"pointer",borderRadius:10,overflow:"hidden",border:`2px solid ${sel===t.id?T.accent:T.border}`,transition:"all 0.2s",boxShadow:sel===t.id?`0 0 20px ${T.accentGlow}`:"none",transform:sel===t.id?"translateY(-3px)":"none",width:130}}>
          <div style={{background:t.headerBg||t.accent,padding:"10px 12px"}}>
            <div style={{width:"60%",height:6,background:t.headerText||"#fff",borderRadius:3,opacity:0.9,marginBottom:4}}/>
            <div style={{width:"40%",height:3,background:t.headerText||"#fff",borderRadius:3,opacity:0.5}}/>
          </div>
          <div style={{background:t.body||"#fff",padding:"7px 9px"}}>
            {[65,80,50].map((w,i)=><div key={i} style={{height:3,background:i===0?t.accent||"#6366f1":"#e2e8f0",borderRadius:2,marginBottom:3,width:`${w}%`}}/>)}
          </div>
          <div style={{background:t.body||"#fff",padding:"3px 9px 7px"}}>
            <span style={{fontSize:9,color:t.accent||"#6366f1",fontWeight:700}}>{t.name}</span>
          </div>
        </div>)}
      </div>
    </div>)}
    <Card style={{marginBottom:16,display:"flex",justifyContent:"space-between",alignItems:"center",flexWrap:"wrap",gap:12}}>
      <div>
        <h3 style={{fontWeight:700,fontSize:15}}>Preview: <span style={{color:T.accent}}>{TEMPLATES.find(t=>t.id===sel)?.name}</span></h3>
        <p style={{color:T.muted,fontSize:13,marginTop:3}}>This is a sample resume to show the template style.</p>
      </div>
      <Badge color="blue">Selected ✓</Badge>
    </Card>
    <ResumeCard text={sampleText} form={sampleForm} tid={sel} photo={null}/>
  </div>;
}

// ─── POINTS PAGE ───────────────────────────────────────────
function PointsPage({toast_}){
  const {user, token, setPoints} = useAuth();
  const { currency, localPkgs }  = useCurrency();
  const [pkgs, setPkgs]          = useState(PACKAGES);
  const [payLoading, setPayLoading] = useState(null);

  // Update pkgs when currency loads from API
  useEffect(()=>{
    if(localPkgs && localPkgs.length>0) setPkgs(localPkgs);
  },[localPkgs]);

  // Handle Paystack redirect back after payment
  useEffect(()=>{
    const params = new URLSearchParams(window.location.search);
    if(params.get("payment")==="success"){
      const ref    = params.get("ref");
      const points = parseInt(params.get("points")||0);
      if(ref && token){
        apiFetch("/api/payment/paystack/verify","POST",{reference:ref, points},token)
          .then(d=>{
            if(d.success && !d.alreadyProcessed){
              if(d.jobBoardUnlocked){
                toast_("🌍 Job Board unlocked! Lifetime access activated.");
                // Reload to refresh user state
                setTimeout(()=>window.location.reload(), 1500);
              } else if(points > 0){
                setPoints(d.newPoints);
                toast_(`✦ ${points} points added to your account!`);
              }
            }
          }).catch(()=>{});
      }
      window.history.replaceState({},document.title,window.location.pathname);
    }
  // eslint-disable-next-line
  },[token]);

  const handleBuyPoints = async(pkg) => {
    const PAYSTACK_PUBLIC = process.env.REACT_APP_PAYSTACK_PUBLIC_KEY;
    if(!PAYSTACK_PUBLIC){
      toast_(`Contact info.mycareerpilot@gmail.com to buy ${(pkg.points||0)+(pkg.bonus||0)} points for ${pkg.price}`);
      return;
    }
    setPayLoading(pkg.id);
    try{
      const totalPts = (pkg.points||0) + (pkg.bonus||0);
      const amount   = pkg.priceNum || parseFloat((pkg.price||"").replace(/[^0-9.]/g,"")) || 0;
      const d = await apiFetch("/api/payment/paystack/initialize","POST",{
        points:      totalPts,
        amount,
        currency:    pkg.currency || currency.code || "NGN",
        packageLabel:`${totalPts} Points — ${pkg.price}`,
      }, token);
      if(d.authorizationUrl) window.location.href = d.authorizationUrl;
    }catch(e){
      toast_(e.message||"Payment error. Try again.","err");
    }
    setPayLoading(null);
  };

  return <div style={{maxWidth:680}}>
    <h1 style={{fontFamily:"'Sora',sans-serif",fontWeight:800,fontSize:26,marginBottom:6}}>Buy Points ✦</h1>
    <p style={{color:T.muted,marginBottom:24,fontSize:14}}>
      Points power all AI features. New users get 10 free points on signup.{" "}
      Prices in <strong style={{color:T.gold}}>{currency.name||currency.code}</strong>.
    </p>

    {/* Balance */}
    <Card style={{marginBottom:24,background:`${T.gold}15`,border:`1px solid ${T.gold}44`,padding:20}}>
      <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",flexWrap:"wrap",gap:12}}>
        <div>
          <div style={{fontSize:11,color:T.muted,fontWeight:700,letterSpacing:1,marginBottom:4}}>CURRENT BALANCE</div>
          <div style={{fontSize:40,fontWeight:900,color:T.gold}}>✦ {user?.points||0}</div>
        </div>
        <div style={{fontSize:12,color:T.muted,lineHeight:2.2}}>
          Resume: <strong style={{color:T.text}}>✦{COSTS.RESUME}</strong>&nbsp;&nbsp;
          ATS: <strong style={{color:T.text}}>✦{COSTS.ATS}</strong>&nbsp;&nbsp;
          Cover: <strong style={{color:T.text}}>✦{COSTS.COVER}</strong><br/>
          Interview: <strong style={{color:T.text}}>✦{COSTS.INTERVIEW}</strong>&nbsp;&nbsp;
          PDF: <strong style={{color:T.text}}>✦{COSTS.PDF}</strong>&nbsp;&nbsp;
          Apply: <strong style={{color:T.text}}>✦{COSTS.APPLY}</strong>
        </div>
      </div>
    </Card>

    {/* Packages */}
    <div style={{display:"grid",gridTemplateColumns:"repeat(auto-fit,minmax(140px,1fr))",gap:14,marginBottom:24}}>
      {pkgs.map((p,i)=>{
        const totalPts=(p.points||0)+(p.bonus||0);
        const isPopular=p.label==="Popular"||p.label==="Most Popular";
        return <Card key={i} style={{textAlign:"center",padding:20,position:"relative",
          border:isPopular?`2px solid ${T.accent}`:`1px solid ${T.border}`,
          boxShadow:isPopular?`0 0 24px ${T.accentGlow}`:"none"}}>
          {p.label&&<div style={{position:"absolute",top:-11,left:"50%",transform:"translateX(-50%)",
            background:isPopular?`linear-gradient(135deg,${T.accent},${T.accent2})`:T.gold,
            color:isPopular?"#fff":"#000",padding:"2px 12px",borderRadius:99,
            fontSize:9,fontWeight:800,whiteSpace:"nowrap"}}>{p.label}</div>}
          <div style={{fontSize:28,fontWeight:900,color:T.gold,marginBottom:4}}>✦{p.points}</div>
          {p.bonus>0&&<div style={{fontSize:11,color:T.green,fontWeight:700,marginBottom:4}}>+{p.bonus} bonus</div>}
          <div style={{fontSize:11,color:T.muted,marginBottom:10}}>{p.bonus>0?`${totalPts} total`:"points"}</div>
          <div style={{fontSize:18,fontWeight:900,marginBottom:12,color:T.text}}>{p.price}</div>
          <Btn variant={isPopular?"primary":"ghost"} size="sm" full
            loading={payLoading===p.id}
            onClick={()=>handleBuyPoints(p)}>Buy Now</Btn>
        </Card>;
      })}
    </div>

    <Card style={{background:`${T.green}12`,border:`1px solid ${T.green}33`,padding:14,marginBottom:16}}>
      <p style={{fontSize:13,color:T.green,margin:0}}>🔒 Secure payments via Paystack. Points added instantly. Contact <a href="mailto:info.mycareerpilot@gmail.com" style={{color:T.green}}>info.mycareerpilot@gmail.com</a> for manual top-up.</p>
    </Card>

    {/* History */}
    {(user?.pointsHistory||[]).length>0&&<>
      <h3 style={{fontWeight:700,fontSize:15,marginBottom:12}}>Points History</h3>
      {(user.pointsHistory||[]).slice(0,10).map((h,i)=><div key={i} style={{display:"flex",justifyContent:"space-between",alignItems:"center",padding:"10px 14px",background:T.surface,borderRadius:8,marginBottom:6,border:`1px solid ${T.border}`}}>
        <div>
          <div style={{fontSize:13,fontWeight:600,color:T.text}}>
            {h.type==="bonus"?"🎁 Welcome Bonus":h.type==="referral_earned"?"🤝 Referral Earned":h.type==="referral_bonus"?"🎁 Referral Bonus":h.type==="admin_award"?"🛡️ Admin Award":h.type==="purchase"?"💳 Purchased":"⚡ Used"}
            {h.note?` — ${h.note}`:""}
          </div>
          <div style={{fontSize:11,color:T.muted,marginTop:2}}>{new Date(h.at).toLocaleString()}</div>
        </div>
        <div style={{fontSize:15,fontWeight:900,color:h.type==="deduct"?T.red:T.green}}>
          {h.type==="deduct"?"-":"+"}✦{h.amount}
        </div>
      </div>)}
    </>}
    <MeshCode/>
  </div>;
}



// ─── PROFILE ───────────────────────────────────────────────
function ReferPage({toast_}){
  const {user, token} = useAuth();
  const [stats, setStats] = useState(null);
  const [copied, setCopied] = useState(false);

  useEffect(()=>{
    apiFetch("/api/user/referral","GET",null,token)
      .then(d=>setStats(d))
      .catch(e=>toast_(e.message,"err"));
  },[token,toast_]);

  const link = stats?.referralLink || `${window.location.origin}?ref=${stats?.referralCode||""}`;
  const code = stats?.referralCode || "Loading...";

  const copyLink=()=>{
    navigator.clipboard.writeText(link);
    setCopied(true);
    toast_("Referral link copied!");
    setTimeout(()=>setCopied(false), 2500);
  };

  const shareText = `🚀 I've been using Career Pilot to build AI-powered resumes and it's amazing! Get your free points when you sign up: ${link}`;

  return <div style={{maxWidth:620}}>
    <h1 style={{fontFamily:"'Sora',sans-serif",fontWeight:800,fontSize:26,marginBottom:6}}>Refer & Earn 🎁</h1>
    <p style={{color:T.muted,marginBottom:24,fontSize:14}}>Earn <strong style={{color:T.gold}}>✦ 3 points</strong> for every friend who signs up using your link. They also get bonus points!</p>

    {/* Stats */}
    <div style={{display:"grid",gridTemplateColumns:"repeat(auto-fit,minmax(130px,1fr))",gap:12,marginBottom:24}}>
      {[
        {icon:"👥",label:"Friends Referred",val:stats?.referralCount||0,color:T.accent},
        {icon:"✦",label:"Points Earned",val:stats?.totalPointsEarned||0,color:T.gold},
        {icon:"🎁",label:"Per Referral",val:"3 pts",color:T.green},
        {icon:"✦",label:"Friend Gets",val:"3 pts",color:"#818cf8"},
      ].map((s,i)=><Card key={i} style={{textAlign:"center",padding:16}}>
        <div style={{fontSize:22,marginBottom:6}}>{s.icon}</div>
        <div style={{fontSize:24,fontWeight:900,color:s.color}}>{s.val}</div>
        <div style={{fontSize:11,color:T.muted,marginTop:3}}>{s.label}</div>
      </Card>)}
    </div>

    {/* Referral code */}
    <Card style={{marginBottom:16,background:`linear-gradient(135deg,${T.accent}15,${T.gold}10)`,border:`1px solid ${T.accent}44`}}>
      <h3 style={{fontWeight:800,fontSize:15,marginBottom:14}}>Your Referral Code</h3>
      <div style={{display:"flex",alignItems:"center",gap:10,flexWrap:"wrap",marginBottom:16}}>
        <div style={{flex:1,background:T.surface,borderRadius:10,padding:"12px 18px",fontFamily:"monospace",fontSize:20,fontWeight:900,color:T.gold,letterSpacing:3,textAlign:"center",border:`1px solid ${T.gold}44`}}>
          {code}
        </div>
        <Btn variant="gold" onClick={copyLink}>{copied?"✓ Copied!":"Copy Code"}</Btn>
      </div>

      <h3 style={{fontWeight:800,fontSize:15,marginBottom:10}}>Your Referral Link</h3>
      <div style={{background:T.surface,borderRadius:10,padding:"10px 14px",fontSize:12,color:T.muted,wordBreak:"break-all",marginBottom:12,border:`1px solid ${T.border}`}}>
        {link}
      </div>
      <div style={{display:"flex",gap:8,flexWrap:"wrap"}}>
        <Btn onClick={copyLink} style={{flex:1,justifyContent:"center"}}>{copied?"✓ Link Copied!":"📋 Copy Link"}</Btn>
        <Btn variant="ghost" onClick={()=>window.open(`https://wa.me/?text=${encodeURIComponent(shareText)}`,"_blank")} style={{flex:1,justifyContent:"center"}}>💬 Share on WhatsApp</Btn>
        <Btn variant="ghost" onClick={()=>window.open(`https://twitter.com/intent/tweet?text=${encodeURIComponent(shareText)}`,"_blank")} style={{flex:1,justifyContent:"center"}}>🐦 Share on X</Btn>
        <Btn variant="ghost" onClick={()=>window.open(`https://www.linkedin.com/sharing/share-offsite/?url=${encodeURIComponent(link)}`,"_blank")} style={{flex:1,justifyContent:"center"}}>💼 Share on LinkedIn</Btn>
      </div>
    </Card>

    {/* How it works */}
    <Card style={{marginBottom:16}}>
      <h3 style={{fontWeight:800,fontSize:15,marginBottom:14}}>How It Works</h3>
      {[
        {step:"1",text:"Share your unique referral link or code with friends",icon:"🔗"},
        {step:"2",text:"Friend signs up using your link or enters your code",icon:"✍️"},
        {step:"3",text:"You instantly earn ✦ 3 points — they get ✦ 3 bonus points too!",icon:"🎁"},
        {step:"4",text:"No limit — refer as many friends as you want",icon:"♾️"},
      ].map((s,i)=><div key={i} style={{display:"flex",gap:14,alignItems:"flex-start",marginBottom:i<3?14:0}}>
        <div style={{width:32,height:32,borderRadius:"50%",background:`linear-gradient(135deg,${T.accent},${T.accent2})`,display:"flex",alignItems:"center",justifyContent:"center",fontWeight:900,fontSize:13,flexShrink:0,color:"#fff"}}>{s.step}</div>
        <div style={{paddingTop:4}}>
          <span style={{fontSize:16,marginRight:8}}>{s.icon}</span>
          <span style={{fontSize:13,color:T.muted,lineHeight:1.6}}>{s.text}</span>
        </div>
      </div>)}
    </Card>

    {/* Referred users list */}
    {stats?.referredUsers?.length>0&&<Card>
      <h3 style={{fontWeight:700,fontSize:15,marginBottom:12}}>Friends You've Referred ({stats.referredUsers.length})</h3>
      {stats.referredUsers.map((u,i)=><div key={i} style={{display:"flex",justifyContent:"space-between",alignItems:"center",padding:"10px 0",borderBottom:i<stats.referredUsers.length-1?`1px solid ${T.border}`:"none"}}>
        <div style={{display:"flex",alignItems:"center",gap:10}}>
          <div style={{width:32,height:32,borderRadius:"50%",background:`linear-gradient(135deg,${T.accent},${T.accent2})`,display:"flex",alignItems:"center",justifyContent:"center",fontWeight:800,fontSize:13,color:"#fff"}}>{u.name[0]?.toUpperCase()}</div>
          <div>
            <div style={{fontSize:13,fontWeight:600,color:T.text}}>{u.name}</div>
            <div style={{fontSize:11,color:T.muted}}>{new Date(u.joinedAt).toLocaleDateString()}</div>
          </div>
        </div>
        <Badge color="green">+✦3 earned</Badge>
      </div>)}
    </Card>}

    <MeshCode/>
  </div>;
}

function Profile({go}){
  const {user,logout}=useAuth();
  return <div style={{maxWidth:560}}>
    <h1 style={{fontFamily:"'Sora',sans-serif",fontWeight:800,fontSize:26,marginBottom:24}}>My Profile</h1>
    <Card style={{marginBottom:16}}>
      <div style={{display:"flex",gap:16,alignItems:"center",marginBottom:20}}>
        <div style={{width:60,height:60,borderRadius:"50%",background:`linear-gradient(135deg,${T.accent},${T.accent2})`,display:"flex",alignItems:"center",justifyContent:"center",fontSize:26,fontWeight:800,flexShrink:0}}>{user?.name?.[0]?.toUpperCase()||"U"}</div>
        <div><h2 style={{fontWeight:800,fontSize:18}}>{user?.name}</h2><p style={{color:T.muted,fontSize:13,margin:"2px 0 6px"}}>{user?.email}</p><Badge color="gold">✦ {user?.points||0} points</Badge></div>
      </div>
      <div style={{display:"grid",gridTemplateColumns:"repeat(auto-fit,minmax(110px,1fr))",gap:10}}>
        {[{l:"Points",v:`✦${user?.points||0}`,c:T.gold,i:"✦"},{l:"Resumes",v:user?.resumes?.length||0,c:T.accent,i:"📄"},{l:"ATS Scans",v:user?.atsScans?.length||0,c:T.green,i:"📊"},{l:"Cover Letters",v:user?.coverLetters?.length||0,c:"#818cf8",i:"✉️"}]
          .map((s,i)=><div key={i} style={{padding:12,background:T.surface,borderRadius:10,textAlign:"center"}}>
            <div style={{fontSize:18,marginBottom:3}}>{s.i}</div>
            <div style={{fontSize:20,fontWeight:900,color:s.c}}>{s.v}</div>
            <div style={{fontSize:11,color:T.muted}}>{s.l}</div>
          </div>)}
      </div>
    </Card>
    <Card style={{marginBottom:16,background:`${T.gold}12`,border:`1px solid ${T.gold}44`}}>
      <h3 style={{fontWeight:800,fontSize:16,marginBottom:8}}>✦ Need More Points?</h3>
      <p style={{color:T.muted,fontSize:13,marginBottom:14,lineHeight:1.6}}>Resume {COSTS.RESUME}pts · ATS {COSTS.ATS}pts · Cover Letter {COSTS.COVER}pts · Interview {COSTS.INTERVIEW}pts · PDF {COSTS.PDF}pts · Apply {COSTS.APPLY}pts</p>
      <Btn variant="gold" onClick={()=>go("points")}>✦ Buy Points →</Btn>
    </Card>

    {/* Career Card - Shareable */}
    <Card style={{marginBottom:16,background:`linear-gradient(135deg,${T.accent}18,${T.accent2}10)`,border:`1px solid ${T.accent}44`}}>
      <h3 style={{fontWeight:800,fontSize:15,marginBottom:4}}>🪪 Your Career Card</h3>
      <p style={{color:T.muted,fontSize:13,marginBottom:14}}>Share this on LinkedIn, WhatsApp or Instagram.</p>
      <div style={{background:T.card,borderRadius:12,padding:20,border:`1px solid ${T.border}`,marginBottom:14}}>
        <div style={{display:"flex",gap:14,alignItems:"center",marginBottom:12}}>
          <div style={{width:56,height:56,borderRadius:"50%",background:`linear-gradient(135deg,${T.accent},${T.accent2})`,display:"flex",alignItems:"center",justifyContent:"center",fontWeight:900,fontSize:24,color:"#fff",flexShrink:0}}>{user?.name?.[0]?.toUpperCase()}</div>
          <div>
            <div style={{fontWeight:800,fontSize:16,color:T.text}}>{user?.name}</div>
            <div style={{fontSize:13,color:T.accent,fontWeight:600}}>Career Pilot Member</div>
            <div style={{fontSize:12,color:T.muted,marginTop:2}}>✦ {user?.points||0} pts · {user?.resumes?.length||0} resumes built</div>
          </div>
        </div>
        <div style={{display:"flex",gap:8,flexWrap:"wrap"}}>
          <Badge color="blue">AI Resume Builder</Badge>
          <Badge color="green">ATS Optimized</Badge>
          <Badge color="gold">Career Pilot</Badge>
        </div>
      </div>
      <div style={{display:"flex",gap:8,flexWrap:"wrap"}}>
        <Btn size="sm" variant="ghost" onClick={()=>{
          const text=`🚀 I'm using Career Pilot to build AI-powered resumes and find jobs across Africa!

✦ Built ${user?.resumes?.length||0} resumes
📊 ATS optimized
🌍 Job searching across Africa

Try it free → mycareerpilot.netlify.app`;
          navigator.clipboard.writeText(text);
          alert("Career card copied! Paste it on LinkedIn or WhatsApp.");
        }}>📋 Copy Card Text</Btn>
        <Btn size="sm" variant="ghost" onClick={()=>window.open(`https://wa.me/?text=${encodeURIComponent(`🚀 I'm using Career Pilot to build AI-powered resumes! Join me → ${window.location.origin}`)}`,"_blank")}>💬 Share on WhatsApp</Btn>
        <Btn size="sm" variant="ghost" onClick={()=>window.open(`https://www.linkedin.com/sharing/share-offsite/?url=${encodeURIComponent(window.location.origin)}`,"_blank")}>💼 Share on LinkedIn</Btn>
      </div>
    </Card>
    <Card style={{marginBottom:16}}>
      <h3 style={{fontWeight:700,fontSize:14,marginBottom:14}}>Account</h3>
      <Btn variant="danger" size="sm" onClick={logout}>← Sign Out</Btn>
    </Card>

    <ChangePassword/>
    <MeshCode/>
  </div>;
}

function ChangePassword(){
  const {token}=useAuth();
  const [open,setOpen]=useState(false);
  const [cur,setCur]=useState("");
  const [newP,setNewP]=useState("");
  const [conf,setConf]=useState("");
  const [loading,setLoading]=useState(false);
  const [err,setErr]=useState("");
  const [ok,setOk]=useState("");

  const submit=async()=>{
    setErr("");setOk("");
    if(!cur){setErr("Enter your current password");return;}
    if(newP.length<6){setErr("New password must be at least 6 characters");return;}
    if(newP!==conf){setErr("Passwords do not match");return;}
    setLoading(true);
    try{
      const d=await apiFetch("/api/auth/change-password","POST",{currentPassword:cur,newPassword:newP},token);
      setOk(d.message);
      setCur("");setNewP("");setConf("");
      setTimeout(()=>setOpen(false),2000);
    }catch(e){setErr(e.message);}
    setLoading(false);
  };

  return <Card style={{marginBottom:16}}>
    <div style={{display:"flex",justifyContent:"space-between",alignItems:"center"}}>
      <div>
        <h3 style={{fontWeight:700,fontSize:14,marginBottom:2}}>🔑 Change Password</h3>
        <p style={{color:T.muted,fontSize:12}}>Update your login password</p>
      </div>
      <Btn variant="ghost" size="sm" onClick={()=>{setOpen(!open);setErr("");setOk("");}}>
        {open?"Cancel":"Change →"}
      </Btn>
    </div>
    {open&&<div style={{marginTop:16,borderTop:`1px solid ${T.border}`,paddingTop:16}}>
      {ok&&<div style={{background:`${T.green}18`,border:`1px solid ${T.green}44`,color:T.green,padding:"10px 14px",borderRadius:10,fontSize:13,marginBottom:14}}>✓ {ok}</div>}
      <ErrBox msg={err}/>
      <Input label="Current Password" value={cur} onChange={setCur} type="password" placeholder="Your current or temporary password"/>
      <Input label="New Password" value={newP} onChange={setNewP} type="password" placeholder="Min 6 characters"/>
      <Input label="Confirm New Password" value={conf} onChange={setConf} type="password" placeholder="Repeat new password"/>
      <Btn onClick={submit} loading={loading}>🔑 Update Password</Btn>
    </div>}
  </Card>;
}

// ─── ADMIN PANEL ───────────────────────────────────────────
function Admin({toast_}){
  const {token}=useAuth();
  const [view,setView]=useState("stats");
  const [stats,setStats]=useState(null);
  const [users,setUsers]=useState([]);
  const [total,setTotal]=useState(0);
  const [pages,setPages]=useState(1);
  const [page,setPage]=useState(1);
  const [search,setSearch]=useState("");
  const [loading,setLoading]=useState(false);
  const [sel,setSel]=useState(null);
  const [awardAmt,setAwardAmt]=useState("");
  const [awardNote,setAwardNote]=useState("");
  const [dupes,setDupes]=useState(null);
  const [feedbacks,setFeedbacks]=useState([]);
  const [stories,setStories]=useState([]);

  const loadStories=useCallback(async()=>{
    try{const d=await apiFetch("/api/admin/stories","GET",null,token);setStories(d.stories||[]);}
    catch(e){toast_(e.message,"err");}
  },[token,toast_]);

  const approveStory=async(id)=>{
    try{
      await apiFetch(`/api/admin/stories/${id}/approve`,"PATCH",{},token);
      setStories(s=>s.map(x=>x.id===id?{...x,status:"approved"}:x));
      toast_("Story approved and published! ✅");
    }catch(e){toast_(e.message,"err");}
  };

  const rejectStory=async(id)=>{
    try{
      await apiFetch(`/api/admin/stories/${id}/reject`,"PATCH",{},token);
      setStories(s=>s.map(x=>x.id===id?{...x,status:"rejected"}:x));
      toast_("Story rejected");
    }catch(e){toast_(e.message,"err");}
  };

  const loadFeedback=useCallback(async()=>{
    try{const d=await apiFetch("/api/admin/feedback","GET",null,token);setFeedbacks(d.feedback||[]);}
    catch(e){toast_(e.message,"err");}
  },[token,toast_]);

  const resolveFeedback=async(id,note)=>{
    try{
      await apiFetch(`/api/admin/feedback/${id}`,"PATCH",{status:"resolved",adminNote:note},token);
      setFeedbacks(f=>f.map(x=>x.id===id?{...x,status:"resolved",adminNote:note}:x));
      toast_("Marked as resolved ✓");
    }catch(e){toast_(e.message,"err");}
  };

  const loadDupes=useCallback(async()=>{
    try{const d=await apiFetch("/api/admin/duplicates","GET",null,token);setDupes(d);}
    catch(e){toast_(e.message,"err");}
  },[token,toast_]);

  const loadStats=useCallback(async()=>{
    try{const d=await apiFetch("/api/admin/stats","GET",null,token);setStats(d);}
    catch(e){toast_(e.message,"err");}
  },[token,toast_]);

  const loadUsers=useCallback(async()=>{
    setLoading(true);
    try{
      const q=new URLSearchParams({page,limit:15});
      if(search)q.set("search",search);
      const d=await apiFetch(`/api/admin/users?${q}`,"GET",null,token);
      setUsers(d.users);setTotal(d.total);setPages(d.pages);
    }catch(e){toast_(e.message,"err");}
    setLoading(false);
  },[token,page,search,toast_]);

  useEffect(()=>{loadStats();},[loadStats]);
  useEffect(()=>{if(view==="users")loadUsers();},[view,loadUsers]);

  const awardPoints=async(uid,uname)=>{
    const pts=parseInt(awardAmt);
    if(!pts||pts<=0){toast_("Enter valid points amount","err");return;}
    try{
      const d=await apiFetch(`/api/admin/users/${uid}/award-points`,"POST",{points:pts,note:awardNote||"Admin award"},token);
      toast_(d.message);setSel(null);setAwardAmt("");setAwardNote("");loadUsers();
    }catch(e){toast_(e.message,"err");}
  };

  const toggleSuspend=async(uid,suspended)=>{
    try{await apiFetch(`/api/admin/users/${uid}/suspend`,"PATCH",{},token);toast_(suspended?"User unsuspended ✓":"User suspended ⏸");loadUsers();}
    catch(e){toast_(e.message,"err");}
  };

  const toggleBan=async(uid,banned)=>{
    if(!banned&&!window.confirm("Are you sure you want to BAN this user? They will not be able to log in."))return;
    try{await apiFetch(`/api/admin/users/${uid}/ban`,"PATCH",{},token);toast_(banned?"User unbanned ✓":"User permanently banned 🚫");loadUsers();}
    catch(e){toast_(e.message,"err");}
  };

  const deleteUser=async(uid)=>{
    if(!window.confirm("Delete this user permanently?"))return;
    try{await apiFetch(`/api/admin/users/${uid}`,"DELETE",null,token);toast_("User deleted");loadUsers();}
    catch(e){toast_(e.message,"err");}
  };

  const activate=async(uid)=>{
    try{await apiFetch(`/api/admin/users/${uid}/activate`,"PATCH",{},token);toast_("User activated + 10 pts awarded");loadUsers();}
    catch(e){toast_(e.message,"err");}
  };

  const unlockJobs=async(uid,uname)=>{
    try{
      await apiFetch(`/api/admin/users/${uid}/unlock-jobs`,"PATCH",{},token);
      toast_(`Job Board unlocked for ${uname} ✓`);
      loadUsers();
    }catch(e){toast_(e.message,"err");}
  };

  const resetPassword=async(uid,uname,uemail)=>{
    if(!window.confirm(`Reset password for ${uname}?\nA temporary password will be set and shown to you.`))return;
    try{
      const d=await apiFetch(`/api/admin/users/${uid}/reset-password`,"PATCH",{},token);
      window.alert(`✅ Password reset for ${uname}\n\nTemporary password:\n${d.tempPassword}\n\nPlease send this to ${uemail}\nUser should change it after login.`);
      toast_(`Password reset for ${uname}`);
    }catch(e){toast_(e.message,"err");}
  };

  return <div style={{maxWidth:1100}}>
    <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:24,flexWrap:"wrap",gap:12}}>
      <div>
        <h1 style={{fontFamily:"'Sora',sans-serif",fontWeight:800,fontSize:26,marginBottom:4}}>🛡️ Admin Panel</h1>
        <p style={{color:T.muted,fontSize:14}}>Manage users, stats, and points</p>
      </div>
      <div style={{display:"flex",gap:8}}>
        <Btn variant={view==="stats"?"primary":"ghost"} size="sm" onClick={()=>setView("stats")}>📊 Stats</Btn>
        <Btn variant={view==="users"?"primary":"ghost"} size="sm" onClick={()=>setView("users")}>👥 Users</Btn>
        <Btn variant={view==="dupes"?"primary":"ghost"} size="sm" onClick={()=>{setView("dupes");loadDupes();}} style={{background:view==="dupes"?`${T.red}22`:undefined,color:view==="dupes"?T.red:undefined,borderColor:view==="dupes"?T.red:undefined}}>🔍 Duplicates</Btn>
        <Btn variant={view==="stories"?"primary":"ghost"} size="sm" onClick={()=>{setView("stories");loadStories();}} style={{background:view==="stories"?`${T.accent}22`:undefined,color:view==="stories"?T.accent:undefined,borderColor:view==="stories"?T.accent:undefined}}>🌟 Stories</Btn>
        <Btn variant={view==="feedback"?"primary":"ghost"} size="sm" onClick={()=>{setView("feedback");loadFeedback();}} style={{background:view==="feedback"?`${T.gold}22`:undefined,color:view==="feedback"?T.gold:undefined,borderColor:view==="feedback"?T.gold:undefined}}>💬 Feedback</Btn>
        <Btn variant="ghost" size="sm" onClick={()=>{loadStats();if(view==="users")loadUsers();toast_("Refreshed");}}>↺</Btn>
      </div>
    </div>

    {/* STATS */}
    {view==="stats"&&stats&&<>
      <div style={{display:"grid",gridTemplateColumns:"repeat(auto-fit,minmax(130px,1fr))",gap:12,marginBottom:20}}>
        {[{i:"👥",l:"Total Users",v:stats.totalUsers,c:T.accent,s:`+${stats.newToday} today`},
          {i:"✅",l:"Activated",v:stats.activatedUsers,c:T.green},
          {i:"⏳",l:"Pending",v:stats.pendingActivation,c:T.gold},
          {i:"🚫",l:"Banned",v:stats.bannedUsers,c:T.red},
          {i:"📄",l:"Resumes",v:stats.totalResumes,c:T.accent},
          {i:"📊",l:"ATS Scans",v:stats.totalATS,c:T.green},
          {i:"✉️",l:"Cover Letters",v:stats.totalCovers,c:"#818cf8"},
          {i:"🕐",l:"Active/Week",v:stats.activeThisWeek,c:T.accent2},
        ].map((s,i)=><Card key={i} style={{textAlign:"center",padding:16}}>
          <div style={{fontSize:22,marginBottom:4}}>{s.i}</div>
          <div style={{fontSize:26,fontWeight:900,color:s.c}}>{s.v}</div>
          <div style={{fontSize:11,color:T.muted,marginTop:2}}>{s.l}</div>
          {s.s&&<div style={{fontSize:10,color:T.green,marginTop:2,fontWeight:700}}>{s.s}</div>}
        </Card>)}
      </div>
    </>}

    {/* DUPLICATES */}
    {view==="dupes"&&<div>
      <div style={{marginBottom:16,padding:14,background:`${T.red}12`,border:`1px solid ${T.red}33`,borderRadius:10}}>
        <p style={{fontSize:13,color:T.muted,margin:0}}>🔍 Shows IP addresses with <strong style={{color:T.text}}>2+ accounts</strong>. These may be users trying to get free points multiple times. You can ban or delete the duplicate accounts.</p>
      </div>
      {!dupes&&<div style={{textAlign:"center",padding:40,color:T.muted}}><Spin/><p style={{marginTop:12}}>Loading...</p></div>}
      {dupes?.totalSuspiciousIPs===0&&<Card style={{textAlign:"center",padding:40}}><div style={{fontSize:40,marginBottom:12}}>✅</div><p style={{color:T.muted}}>No duplicate IPs detected. Your platform looks clean!</p></Card>}
      {dupes?.duplicateIPs?.map((group,i)=><Card key={i} style={{marginBottom:12,border:`1px solid ${T.red}33`}}>
        <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:12,flexWrap:"wrap",gap:8}}>
          <div>
            <span style={{fontWeight:700,fontSize:14,color:T.red}}>🔴 IP: {group.ip}</span>
            <Badge color="red" style={{marginLeft:8}}>{group.count} accounts</Badge>
          </div>
          <span style={{fontSize:12,color:T.muted}}>Suspicious — same device created multiple accounts</span>
        </div>
        {group.users.map((u,j)=><div key={j} style={{display:"flex",justifyContent:"space-between",alignItems:"center",padding:"8px 12px",background:T.surface,borderRadius:8,marginBottom:6}}>
          <div>
            <div style={{fontSize:13,fontWeight:600,color:T.text}}>{u.name}</div>
            <div style={{fontSize:11,color:T.muted}}>{u.email}</div>
          </div>
          <div style={{display:"flex",gap:8,alignItems:"center"}}>
            <span style={{color:T.gold,fontWeight:700,fontSize:13}}>✦{u.points}</span>
            <span style={{fontSize:11,color:T.muted}}>{u.createdAt?new Date(u.createdAt).toLocaleDateString():"—"}</span>
          </div>
        </div>)}
      </Card>)}
    </div>}

    {/* FEEDBACK */}
    {view==="feedback"&&<div>
      <div style={{marginBottom:16,padding:14,background:`${T.gold}12`,border:`1px solid ${T.gold}33`,borderRadius:10}}>
        <p style={{fontSize:13,color:T.muted,margin:0}}>💬 All feedback submitted by users. Click <strong style={{color:T.text}}>Resolve</strong> to mark as handled.</p>
      </div>
      {feedbacks.length===0&&<Card style={{textAlign:"center",padding:40}}><div style={{fontSize:40,marginBottom:12}}>💬</div><p style={{color:T.muted}}>No feedback yet.</p></Card>}
      {feedbacks.map((f,i)=>{
        const typeColor={complaint:T.red,bug:T.gold,suggestion:T.accent,question:T.green,other:T.muted}[f.type]||T.muted;
        return <Card key={i} style={{marginBottom:12,border:`1px solid ${f.status==="resolved"?T.green:typeColor}44`,opacity:f.status==="resolved"?0.7:1}}>
          <div style={{display:"flex",justifyContent:"space-between",alignItems:"flex-start",flexWrap:"wrap",gap:10,marginBottom:10}}>
            <div>
              <div style={{display:"flex",gap:8,alignItems:"center",flexWrap:"wrap",marginBottom:4}}>
                <Badge color={f.type==="complaint"?"red":f.type==="bug"?"gold":f.type==="suggestion"?"blue":"green"}>{f.type?.toUpperCase()}</Badge>
                {f.status==="resolved"&&<Badge color="green">✓ RESOLVED</Badge>}
                <span style={{fontSize:13,fontWeight:700,color:T.text}}>{f.subject}</span>
              </div>
              <div style={{fontSize:12,color:T.muted}}>{f.userName} · {f.userEmail} · {new Date(f.createdAt).toLocaleString()}</div>
            </div>
            {f.status!=="resolved"&&<Btn size="sm" variant="green" onClick={()=>{
              const note=window.prompt("Add a note (optional):","")||"";
              resolveFeedback(f.id,note);
            }}>✓ Resolve</Btn>}
          </div>
          <div style={{background:T.surface,borderRadius:10,padding:"12px 14px",fontSize:13,color:T.text,lineHeight:1.7,whiteSpace:"pre-wrap"}}>{f.message}</div>
          {f.adminNote&&<div style={{marginTop:8,padding:"8px 12px",background:`${T.green}15`,borderRadius:8,fontSize:12,color:T.green}}>📝 Note: {f.adminNote}</div>}
        </Card>;
      })}
    </div>}

    {/* STORIES */}
    {view==="stories"&&<div>
      <div style={{marginBottom:16,padding:14,background:`${T.accent}12`,border:`1px solid ${T.accent}33`,borderRadius:10}}>
        <p style={{fontSize:13,color:T.muted,margin:0}}>🌟 User success stories. <strong style={{color:T.text}}>Approve</strong> to publish on landing page · <strong style={{color:T.text}}>Reject</strong> to remove. Approved stories earn the user 5 bonus points.</p>
      </div>
      {stories.length===0&&<Card style={{textAlign:"center",padding:40}}><div style={{fontSize:40,marginBottom:12}}>🌟</div><p style={{color:T.muted}}>No stories submitted yet.</p></Card>}
      {stories.map((s,i)=><Card key={i} style={{marginBottom:12,border:`1px solid ${s.status==="approved"?T.green:s.status==="rejected"?T.red:T.gold}44`}}>
        <div style={{display:"flex",justifyContent:"space-between",alignItems:"flex-start",flexWrap:"wrap",gap:10,marginBottom:10}}>
          <div>
            <div style={{display:"flex",gap:8,alignItems:"center",flexWrap:"wrap",marginBottom:4}}>
              <Badge color={s.status==="approved"?"green":s.status==="rejected"?"red":"gold"}>{(s.status||"pending").toUpperCase()}</Badge>
              <span style={{fontSize:13,fontWeight:700,color:T.text}}>{s.userName}</span>
              <span style={{fontSize:12,color:T.muted}}>→ {s.role} at {s.company}</span>
            </div>
            <div style={{fontSize:12,color:T.muted}}>{s.country} · {new Date(s.createdAt).toLocaleDateString()}</div>
          </div>
          <div style={{display:"flex",gap:8}}>
            {s.status!=="approved"&&<Btn size="sm" variant="green" onClick={()=>approveStory(s.id)}>✓ Approve</Btn>}
            {s.status!=="rejected"&&<Btn size="sm" variant="danger" onClick={()=>rejectStory(s.id)}>✗ Reject</Btn>}
          </div>
        </div>
        <div style={{background:T.surface,borderRadius:10,padding:"12px 14px",fontSize:13,color:T.text,lineHeight:1.7,fontStyle:"italic"}}>"{s.quote}"</div>
      </Card>)}
    </div>}

    {/* USERS */}
    {view==="users"&&<>
      <div style={{display:"flex",gap:10,marginBottom:14,flexWrap:"wrap",alignItems:"center"}}>
        <div style={{flex:1,minWidth:200,position:"relative"}}>
          <span style={{position:"absolute",left:12,top:"50%",transform:"translateY(-50%)",color:T.muted}}>🔍</span>
          <input value={search} onChange={e=>{setSearch(e.target.value);setPage(1);}} placeholder="Search by name or email..."
            style={{width:"100%",background:T.surface,border:`1px solid ${T.border}`,borderRadius:10,padding:"9px 12px 9px 36px",color:T.text,fontSize:13,outline:"none",fontFamily:"inherit",boxSizing:"border-box"}}/>
        </div>
        <Btn size="sm" onClick={loadUsers} loading={loading}>Search</Btn>
      </div>
      <p style={{fontSize:13,color:T.muted,marginBottom:12}}>{total} user{total!==1?"s":""}</p>
      <div style={{overflowX:"auto"}}>
        <table style={{width:"100%",borderCollapse:"collapse",minWidth:600}}>
          <thead><tr style={{background:T.surface}}>
            {["User","Points","Resumes","Status","Joined","Actions"].map(h=><th key={h} style={{padding:"9px 12px",textAlign:"left",fontSize:11,fontWeight:700,color:T.muted,letterSpacing:0.5,borderBottom:`1px solid ${T.border}`,whiteSpace:"nowrap"}}>{h}</th>)}
          </tr></thead>
          <tbody>
            {loading?<tr><td colSpan={6} style={{padding:40,textAlign:"center",color:T.muted}}><Spin/></td></tr>
            :users.length===0?<tr><td colSpan={6} style={{padding:40,textAlign:"center",color:T.muted}}>No users found</td></tr>
            :users.map(u=><tr key={u.id} style={{borderBottom:`1px solid ${T.border}`,opacity:u.banned?0.5:1}}
              onMouseEnter={e=>e.currentTarget.style.background=T.surface}
              onMouseLeave={e=>e.currentTarget.style.background="transparent"}>
              <td style={{padding:"12px 12px"}}>
                <div style={{display:"flex",alignItems:"center",gap:10}}>
                  <div style={{width:30,height:30,borderRadius:"50%",background:`linear-gradient(135deg,${T.accent},${T.accent2})`,display:"flex",alignItems:"center",justifyContent:"center",fontSize:12,fontWeight:800,flexShrink:0}}>{u.name?.[0]?.toUpperCase()}</div>
                  <div>
                    <div style={{fontSize:13,fontWeight:600,color:T.text}}>{u.name}{u.banned&&<span style={{color:T.red,fontSize:10,marginLeft:6}}>BANNED</span>}</div>
                    <div style={{fontSize:11,color:T.muted}}>{u.email}</div>
                  </div>
                </div>
              </td>
              <td style={{padding:"12px 12px"}}><span style={{color:T.gold,fontWeight:800,fontSize:13}}>✦{u.points||0}</span></td>
              <td style={{padding:"12px 12px",fontSize:13,color:T.text,textAlign:"center"}}>{u.resumes||0}</td>
              <td style={{padding:"12px 12px"}}>{u.banned?<Badge color="red">Banned</Badge>:u.suspended?<Badge color="gold">Suspended</Badge>:u.activated?<Badge color="green">Active</Badge>:<Badge color="blue">Pending</Badge>}</td>
              <td style={{padding:"12px 12px",fontSize:11,color:T.muted,whiteSpace:"nowrap"}}>
  <div>{u.createdAt?new Date(u.createdAt).toLocaleDateString():"—"}</div>
  {u.signupIp&&<div style={{fontSize:10,color:T.muted,marginTop:2}}>{u.signupIp}</div>}
  {u.bonusAwarded===false&&<div style={{fontSize:10,color:T.red,marginTop:2,fontWeight:700}}>⚠ Dup device</div>}
</td>
              <td style={{padding:"12px 12px"}}>
                <div style={{display:"flex",gap:4,flexWrap:"wrap"}}>
                  <button onClick={()=>setSel(sel?.id===u.id?null:u)} style={{padding:"4px 10px",borderRadius:6,border:`1px solid ${T.accent}`,background:"transparent",color:T.accent,cursor:"pointer",fontSize:11,fontFamily:"inherit",fontWeight:600}}>✦ Points</button>
                  {!u.activated&&<button onClick={()=>activate(u.id)} style={{padding:"4px 10px",borderRadius:6,border:"none",background:`${T.green}22`,color:T.green,cursor:"pointer",fontSize:11,fontFamily:"inherit",fontWeight:600}}>✓ Activate</button>}
                  <button onClick={()=>resetPassword(u.id,u.name,u.email)} style={{padding:"4px 10px",borderRadius:6,border:"none",background:`${T.accent}22`,color:T.accent,cursor:"pointer",fontSize:11,fontFamily:"inherit",fontWeight:600}}>🔑 Reset Pwd</button>
                  <button onClick={()=>unlockJobs(u.id,u.name)} style={{padding:"4px 10px",borderRadius:6,border:"none",background:u.jobBoardAccess?`${T.green}22`:`${T.gold}22`,color:u.jobBoardAccess?T.green:T.gold,cursor:"pointer",fontSize:11,fontFamily:"inherit",fontWeight:600}}>{u.jobBoardAccess?"🌍 Jobs ✓":"🌍 Unlock Jobs"}</button>
                  <button onClick={()=>toggleSuspend(u.id,u.suspended)} style={{padding:"4px 10px",borderRadius:6,border:"none",background:u.suspended?`${T.red}22`:`${T.green}22`,color:u.suspended?T.red:T.green,cursor:"pointer",fontSize:11,fontFamily:"inherit",fontWeight:700}}>
                    {u.suspended?"🔴 Suspended":"🟢 Active"}
                  </button>
                  <button onClick={()=>toggleBan(u.id,u.banned)} style={{padding:"4px 10px",borderRadius:6,border:"none",background:u.banned?`${T.green}22`:`${T.red}22`,color:u.banned?T.green:T.red,cursor:"pointer",fontSize:11,fontFamily:"inherit",fontWeight:600}}>{u.banned?"Unban":"🚫 Ban"}</button>
                  <button onClick={()=>deleteUser(u.id)} style={{padding:"4px 10px",borderRadius:6,border:"none",background:`${T.red}22`,color:T.red,cursor:"pointer",fontSize:11,fontFamily:"inherit",fontWeight:600}}>🗑 Delete</button>
                </div>
                {/* Award points inline */}
                {sel?.id===u.id&&<div style={{marginTop:8,padding:12,background:T.surface,borderRadius:8,border:`1px solid ${T.gold}44`}}>
                  <p style={{fontSize:12,color:T.gold,fontWeight:700,marginBottom:8}}>✦ Award Points to {u.name}</p>
                  <div style={{display:"flex",gap:6,marginBottom:6}}>
                    <input value={awardAmt} onChange={e=>setAwardAmt(e.target.value)} placeholder="Points" type="number" style={{width:80,background:T.card,border:`1px solid ${T.border}`,borderRadius:6,padding:"5px 8px",color:T.text,fontSize:12,fontFamily:"inherit",outline:"none"}}/>
                    <input value={awardNote} onChange={e=>setAwardNote(e.target.value)} placeholder="Note (optional)" style={{flex:1,background:T.card,border:`1px solid ${T.border}`,borderRadius:6,padding:"5px 8px",color:T.text,fontSize:12,fontFamily:"inherit",outline:"none"}}/>
                  </div>
                  <div style={{display:"flex",gap:6}}>
                    <Btn size="sm" variant="gold" onClick={()=>awardPoints(u.id,u.name)}>Award</Btn>
                    <Btn size="sm" variant="ghost" onClick={()=>setSel(null)}>Cancel</Btn>
                  </div>
                </div>}
              </td>
            </tr>)}
          </tbody>
        </table>
      </div>
      {pages>1&&<div style={{display:"flex",justifyContent:"center",gap:8,marginTop:20,flexWrap:"wrap"}}>
        <Btn variant="ghost" size="sm" disabled={page===1} onClick={()=>setPage(p=>p-1)}>← Prev</Btn>
        {Array.from({length:Math.min(pages,7)},(_,i)=>i+1).map(p=><button key={p} onClick={()=>setPage(p)} style={{width:34,height:34,borderRadius:8,border:`1px solid ${page===p?T.accent:T.border}`,background:page===p?`${T.accent}22`:"transparent",color:page===p?T.accent:T.muted,cursor:"pointer",fontFamily:"inherit",fontWeight:700,fontSize:13}}>{p}</button>)}
        <Btn variant="ghost" size="sm" disabled={page===pages} onClick={()=>setPage(p=>p+1)}>Next →</Btn>
      </div>}
    </>}
  </div>;
}

// ─── APP ROOT ──────────────────────────────────────────────
function AppInner(){
  const [authMode, setAuthMode] = useState("login");
  const [view, setView]         = useState("landing");
  const [refCode, setRefCode]   = useState("");
  const {user, login}           = useAuth();

  useEffect(()=>{
    const p   = new URLSearchParams(window.location.search);
    const tok = p.get("token");
    const ref = p.get("ref");

    // Save referral code from URL
    if(ref){
      sessionStorage.setItem("cp_ref", ref.toUpperCase());
      setRefCode(ref.toUpperCase());
    } else {
      const saved = sessionStorage.getItem("cp_ref");
      if(saved) setRefCode(saved);
    }

    // Handle activation / reset password links
    if(tok){
      setAuthMode(p.get("type")==="reset" ? "reset" : "activating");
      setView("auth");
    }
  // eslint-disable-next-line
  },[]);

  const goAuth = (mode) => { setAuthMode(mode); setView("auth"); };
  if(user) return <Dashboard/>;
  if(view==="auth") return <AuthPage onLogin={login} startMode={authMode} refCode={refCode}/>;
  return <Landing onGetStarted={goAuth}/>;
}

export default function App(){
  return <AuthProvider><AppInner/></AuthProvider>;
}


// ── Job Board Unlock via Paystack ─────────────────────────
function UnlockJobBoardBtn({ toast_, setPoints }) {
  const { user, token } = useAuth();
  const [loading, setLoading] = useState(false);

  const handleUnlock = async () => {
    const PAYSTACK_PUBLIC = process.env.REACT_APP_PAYSTACK_PUBLIC_KEY;

    if (!PAYSTACK_PUBLIC) {
      toast_("Contact info.mycareerpilot@gmail.com to unlock — ₦2,000 one-time payment.");
      return;
    }

    setLoading(true);
    try {
      const d = await apiFetch("/api/payment/paystack/initialize", "POST", {
        points:       0,
        amount:       2000,
        currency:     "NGN",
        packageLabel: "Job Board Lifetime Access — ₦2,000",
        type:         "job_board_unlock",  // tells backend this is a job board payment
      }, token);

      if (d.authorizationUrl) {
        window.location.href = d.authorizationUrl;
      }
    } catch(e) {
      toast_(e.message || "Payment error. Try again.", "err");
    }
    setLoading(false);
  };

  return (
    <Btn size="lg" style={{width:"100%",justifyContent:"center"}}
      loading={loading}
      onClick={handleUnlock}>
      🌍 Unlock Job Board — ₦2,000
    </Btn>
  );
}


// ── Live 24-hour trial countdown ─────────────────────────
function TrialCountdown({ trialStart, onExpire, style }) {
  const calc = () => {
    const start     = new Date(trialStart || Date.now()).getTime();
    const elapsed   = Date.now() - start;
    const remaining = Math.max(0, 24 * 60 * 60 * 1000 - elapsed);
    return {
      hours:     Math.floor(remaining / 3600000),
      mins:      Math.floor((remaining % 3600000) / 60000),
      secs:      Math.floor((remaining % 60000) / 1000),
      remaining,
    };
  };
  const [time, setTime] = useState(calc);
  useEffect(() => {
    const t = setInterval(() => {
      const next = calc();
      setTime(next);
      if (next.remaining === 0 && onExpire) { clearInterval(t); onExpire(); }
    }, 1000);
    return () => clearInterval(t);
  // eslint-disable-next-line
  }, [trialStart]);

  const pad   = n => String(n).padStart(2, "0");
  const urgent = time.hours === 0 && time.mins < 30;
  const color  = urgent ? T.red : T.gold;
  if (time.remaining === 0) return null;

  return (
    <div style={{background:`${color}18`,border:`1px solid ${color}44`,borderRadius:12,padding:"12px 16px",display:"flex",alignItems:"center",justifyContent:"space-between",flexWrap:"wrap",gap:10,...(style||{})}}>
      <div style={{display:"flex",alignItems:"center",gap:10}}>
        <span style={{fontSize:20}}>{urgent?"🚨":"⏱"}</span>
        <div>
          <div style={{fontSize:10,color:T.muted,fontWeight:700,letterSpacing:1,marginBottom:2}}>FREE TRIAL EXPIRES IN</div>
          <div style={{fontSize:24,fontWeight:900,color,fontFamily:"monospace",letterSpacing:3,lineHeight:1}}>
            {pad(time.hours)}:{pad(time.mins)}:{pad(time.secs)}
          </div>
        </div>
      </div>
      <div style={{textAlign:"right"}}>
        <div style={{fontSize:11,color:T.muted,marginBottom:2}}>Unlock forever after trial</div>
        <div style={{fontSize:13,fontWeight:800,color:T.gold}}>₦2,000 lifetime access</div>
      </div>
    </div>
  );
}

// ══════════════════════════════════════════════════════════
//  JOB BOARD
// ══════════════════════════════════════════════════════════
function JobBoard({ toast_, setTab }) {
  const { user, token, setPoints } = useAuth();
  const countryList = Object.keys(AFRICAN_COUNTRIES).map(name => ({
    code: name,
    name: AFRICAN_COUNTRIES[name].flag + " " + name,
    label: name,
    states: AFRICAN_COUNTRIES[name].states,
  }));
  const [title, setTitle]       = useState("");
  const [location, setLocation] = useState("");
  const [country, setCountry]   = useState("Nigeria");
  const [jobs, setJobs]         = useState([]);
  const [total, setTotal]       = useState(0);
  const [page, setPage]         = useState(1);
  const [pages, setPages]       = useState(1);
  const [loading, setLoading]   = useState(false);
  const [err, setErr]           = useState("");
  const [searched, setSearched] = useState(false);
  const [state, setState]       = useState("");
  const selectedCountryData     = countryList.find(c=>c.code===country);

  // Store latest search params in ref so pagination always uses current values
  const lastSearchRef = useRef({ title:"", location:"", state:"", country:"Nigeria", countryName:"Nigeria" });

  const isAdmin   = user?.isAdmin;
  const trialDaysLeft = user?.jobBoardTrialDaysLeft ?? Math.max(0, 1 - Math.floor((Date.now() - new Date(user?.jobBoardTrialStart||user?.createdAt||Date.now()).getTime()) / 86400000));
  const onTrial   = trialDaysLeft > 0;
  const hasAccess = isAdmin || user?.jobBoardAccess || onTrial;

  const countries = [
    // Adzuna (best results)
    {code:"us",  name:"🇺🇸 United States",   label:"United States"},
    {code:"gb",  name:"🇬🇧 United Kingdom",   label:"United Kingdom"},
    {code:"ca",  name:"🇨🇦 Canada",           label:"Canada"},
    {code:"au",  name:"🇦🇺 Australia",        label:"Australia"},
    {code:"de",  name:"🇩🇪 Germany",          label:"Germany"},
    {code:"fr",  name:"🇫🇷 France",           label:"France"},
    {code:"nl",  name:"🇳🇱 Netherlands",      label:"Netherlands"},
    {code:"sg",  name:"🇸🇬 Singapore",        label:"Singapore"},
    {code:"za",  name:"🇿🇦 South Africa",     label:"South Africa"},
    {code:"in",  name:"🇮🇳 India",            label:"India"},
    {code:"ae",  name:"🇦🇪 UAE",              label:"UAE"},
    {code:"nz",  name:"🇳🇿 New Zealand",      label:"New Zealand"},
    {code:"at",  name:"🇦🇹 Austria",          label:"Austria"},
    {code:"be",  name:"🇧🇪 Belgium",          label:"Belgium"},
    {code:"br",  name:"🇧🇷 Brazil",           label:"Brazil"},
    {code:"it",  name:"🇮🇹 Italy",            label:"Italy"},
    {code:"mx",  name:"🇲🇽 Mexico",           label:"Mexico"},
    {code:"pl",  name:"🇵🇱 Poland",           label:"Poland"},
    // JSearch (worldwide)
    {code:"ng",  name:"🇳🇬 Nigeria",          label:"Nigeria"},
    {code:"gh",  name:"🇬🇭 Ghana",            label:"Ghana"},
    {code:"ke",  name:"🇰🇪 Kenya",            label:"Kenya"},
    {code:"eg",  name:"🇪🇬 Egypt",            label:"Egypt"},
    {code:"ug",  name:"🇺🇬 Uganda",           label:"Uganda"},
    {code:"tz",  name:"🇹🇿 Tanzania",         label:"Tanzania"},
    {code:"et",  name:"🇪🇹 Ethiopia",         label:"Ethiopia"},
    {code:"rw",  name:"🇷🇼 Rwanda",           label:"Rwanda"},
    {code:"ph",  name:"🇵🇭 Philippines",      label:"Philippines"},
    {code:"pk",  name:"🇵🇰 Pakistan",         label:"Pakistan"},
    {code:"bd",  name:"🇧🇩 Bangladesh",       label:"Bangladesh"},
    {code:"lk",  name:"🇱🇰 Sri Lanka",        label:"Sri Lanka"},
    {code:"my",  name:"🇲🇾 Malaysia",         label:"Malaysia"},
    {code:"id",  name:"🇮🇩 Indonesia",        label:"Indonesia"},
    {code:"th",  name:"🇹🇭 Thailand",         label:"Thailand"},
    {code:"vn",  name:"🇻🇳 Vietnam",          label:"Vietnam"},
    {code:"jp",  name:"🇯🇵 Japan",            label:"Japan"},
    {code:"kr",  name:"🇰🇷 South Korea",      label:"South Korea"},
    {code:"cn",  name:"🇨🇳 China",            label:"China"},
    {code:"sa",  name:"🇸🇦 Saudi Arabia",     label:"Saudi Arabia"},
    {code:"qa",  name:"🇶🇦 Qatar",            label:"Qatar"},
    {code:"kw",  name:"🇰🇼 Kuwait",           label:"Kuwait"},
    {code:"bh",  name:"🇧🇭 Bahrain",          label:"Bahrain"},
    {code:"om",  name:"🇴🇲 Oman",             label:"Oman"},
    {code:"ie",  name:"🇮🇪 Ireland",          label:"Ireland"},
    {code:"se",  name:"🇸🇪 Sweden",           label:"Sweden"},
    {code:"no",  name:"🇳🇴 Norway",           label:"Norway"},
    {code:"dk",  name:"🇩🇰 Denmark",          label:"Denmark"},
    {code:"fi",  name:"🇫🇮 Finland",          label:"Finland"},
    {code:"ch",  name:"🇨🇭 Switzerland",      label:"Switzerland"},
    {code:"es",  name:"🇪🇸 Spain",            label:"Spain"},
    {code:"pt",  name:"🇵🇹 Portugal",         label:"Portugal"},
    {code:"ro",  name:"🇷🇴 Romania",          label:"Romania"},
    {code:"ua",  name:"🇺🇦 Ukraine",          label:"Ukraine"},
    {code:"tr",  name:"🇹🇷 Turkey",           label:"Turkey"},
    {code:"il",  name:"🇮🇱 Israel",           label:"Israel"},
    {code:"ar",  name:"🇦🇷 Argentina",        label:"Argentina"},
    {code:"co",  name:"🇨🇴 Colombia",         label:"Colombia"},
    {code:"cl",  name:"🇨🇱 Chile",            label:"Chile"},
    {code:"pe",  name:"🇵🇪 Peru",             label:"Peru"},
    {code:"remote",name:"🌐 Remote/Worldwide",label:"Remote"},
  ];

  const search = async (p=1, overrideParams=null) => {
    // Use override params (for pagination) or current state values (for new search)
    const sp = overrideParams || (() => {
      const selectedCountry = countryList.find(c=>c.code===country) || {label:country,code:country};
      const params = {
        title:       title.trim(),
        location:    state || location || "",
        country:     selectedCountry.code,
        countryName: selectedCountry.label,
      };
      // Save for pagination use
      lastSearchRef.current = params;
      return params;
    })();

    if (!sp.title) { toast_("Enter a job title to search","err"); return; }
    setLoading(true); setErr(""); setSearched(true);

    try {
      const params = new URLSearchParams({
        title:       sp.title,
        location:    sp.location,
        country:     sp.country,
        countryName: sp.countryName,
        page:        String(p),
      });
      const data = await apiFetch(`/api/jobs/search?${params}`, "GET", null, token);
      setJobs(data.jobs || []);
      setTotal(data.total || 0);
      setPage(p);
      setPages(data.pages || 1);
    } catch(e) {
      setErr(e.message);
      toast_(e.message, "err");
    }
    setLoading(false);
  };

  const timeAgo = (dateStr) => {
    if (!dateStr) return "";
    const diff = Date.now() - new Date(dateStr).getTime();
    const days = Math.floor(diff / 86400000);
    if (days === 0) return "Today";
    if (days === 1) return "Yesterday";
    if (days < 7) return `${days} days ago`;
    if (days < 30) return `${Math.floor(days/7)} weeks ago`;
    return `${Math.floor(days/30)} months ago`;
  };

  // ── Locked screen ──────────────────────────────────────
  if (!hasAccess) return (
    <div style={{maxWidth:560,margin:"0 auto",textAlign:"center",paddingTop:40}}>
      <div style={{fontSize:72,marginBottom:16}}>🌍</div>
      <h1 style={{fontFamily:"'Sora',sans-serif",fontWeight:800,fontSize:28,marginBottom:12,letterSpacing:-1}}>
        Global Job Board
      </h1>
      <p style={{color:T.muted,fontSize:15,lineHeight:1.8,marginBottom:28,maxWidth:420,margin:"0 auto 28px"}}>
        Search millions of real jobs from 20+ countries worldwide. Find your dream job and build a tailored resume in one click.
      </p>

      {/* Feature highlights */}
      <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:12,marginBottom:28,textAlign:"left"}}>
        {[
          {icon:"🔍",t:"Live Job Listings",d:"Real jobs from LinkedIn, Indeed & more"},
          {icon:"🌍",t:"20+ Countries",d:"US, UK, Canada, Nigeria, UAE & more"},
          {icon:"✦",t:"One-Click Resume",d:"Build a tailored resume for any job"},
          {icon:"✉️",t:"Cover Letter",d:"Generate a cover letter instantly"},
          {icon:"💰",t:"Salary Info",d:"See salary ranges for every listing"},
          {icon:"♾️",t:"Lifetime Access",d:"Pay once, use forever"},
        ].map((f,i)=><Card key={i} style={{padding:14}}>
          <div style={{fontSize:22,marginBottom:6}}>{f.icon}</div>
          <div style={{fontWeight:700,fontSize:13,marginBottom:3}}>{f.t}</div>
          <div style={{fontSize:12,color:T.muted,lineHeight:1.5}}>{f.d}</div>
        </Card>)}
      </div>

      {/* Price card */}
      <Card style={{background:`linear-gradient(135deg,${T.accent}15,${T.gold}10)`,border:`2px solid ${T.accent}`,marginBottom:20,padding:28}}>
        <div style={{fontSize:11,color:T.muted,fontWeight:700,letterSpacing:1,marginBottom:8}}>ONE-TIME PURCHASE</div>
        <div style={{fontSize:52,fontWeight:900,color:T.gold,lineHeight:1,marginBottom:4}}>₦2,000</div>
        <div style={{fontSize:14,color:T.muted,marginBottom:8}}>Lifetime access — pay once, use forever</div>
        {onTrial&&<TrialCountdown trialStart={user?.jobBoardTrialStart||user?.createdAt} onExpire={()=>window.location.reload()} style={{marginBottom:12}}/>}
        <UnlockJobBoardBtn toast_={toast_} setPoints={setPoints}/>
        <p style={{fontSize:12,color:T.muted,marginTop:12,textAlign:"center"}}>
          Secure payment via Paystack · Instant activation · Lifetime access
        </p>
      </Card>
      <MeshCode/>
    </div>
  );

  // ── Full job board ─────────────────────────────────────
  return (
    <div style={{maxWidth:900}}>
      <div style={{marginBottom:20}}>
        <h1 style={{fontFamily:"'Sora',sans-serif",fontWeight:800,fontSize:26,marginBottom:4}}>
          🌍 Africa Job Board
        </h1>
        <p style={{color:T.muted,fontSize:14}}>
          Search real jobs across Africa. Select your country and state to find jobs near you.
          {isAdmin && <span style={{marginLeft:8}}><Badge color="red">Admin</Badge></span>}
        </p>
        {onTrial&&!user?.jobBoardAccess&&<TrialCountdown trialStart={user?.jobBoardTrialStart||user?.createdAt} onExpire={()=>window.location.reload()}/>}
      </div>

      {/* Search bar */}
      <Card style={{marginBottom:20,padding:16}}>
        {/* Job title - full width, large on mobile */}
        <div style={{position:"relative",marginBottom:10}}>
          <span style={{position:"absolute",left:14,top:"50%",transform:"translateY(-50%)",color:T.muted,fontSize:18,pointerEvents:"none"}}>🔍</span>
          <input
            value={title} onChange={e=>setTitle(e.target.value)}
            onKeyDown={e=>e.key==="Enter"&&search(1)}
            placeholder="Job title, skills, company..."
            style={{width:"100%",background:T.surface,border:`2px solid ${T.accent}`,borderRadius:12,padding:"14px 14px 14px 46px",color:T.text,fontSize:16,outline:"none",fontFamily:"inherit",boxSizing:"border-box",WebkitAppearance:"none"}}
          />
        </div>
        {/* Country + State row */}
        <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:8,marginBottom:10}}>
          <select value={country} onChange={e=>{setCountry(e.target.value);setState("");}}
            style={{background:T.surface,border:`1px solid ${T.border}`,borderRadius:10,padding:"12px 10px",color:T.text,fontSize:14,fontFamily:"inherit",outline:"none",width:"100%",boxSizing:"border-box"}}>
            {countryList.map(c=><option key={c.code} value={c.code}>{c.name}</option>)}
          </select>
          {selectedCountryData?.states?.length>0
            ? <select value={state} onChange={e=>setState(e.target.value)}
                style={{background:T.surface,border:`1px solid ${T.border}`,borderRadius:10,padding:"12px 10px",color:T.text,fontSize:14,fontFamily:"inherit",outline:"none",width:"100%",boxSizing:"border-box"}}>
                <option value="">All States</option>
                {selectedCountryData.states.map(s=><option key={s} value={s}>{s}</option>)}
              </select>
            : <div style={{position:"relative"}}>
                <span style={{position:"absolute",left:12,top:"50%",transform:"translateY(-50%)",color:T.muted,pointerEvents:"none"}}>📍</span>
                <input value={location} onChange={e=>setLocation(e.target.value)}
                  placeholder="City (optional)"
                  style={{width:"100%",background:T.surface,border:`1px solid ${T.border}`,borderRadius:10,padding:"12px 10px 12px 34px",color:T.text,fontSize:14,outline:"none",fontFamily:"inherit",boxSizing:"border-box"}}/>
              </div>
          }
        </div>
        {/* Search button - full width on mobile */}
        <Btn onClick={()=>search(1)} loading={loading} full size="lg">🔍 Search Jobs</Btn>
      </Card>

      <ErrBox msg={err}/>

      {/* Results count */}
      {searched && !loading && (
        <p style={{fontSize:13,color:T.muted,marginBottom:14}}>
          {total>0 ? `${total.toLocaleString()} jobs found for "${title}"${location?` in ${location}`:""}` : `No jobs found. Try different keywords.`}
        </p>
      )}

      {/* Loading */}
      {loading && (
        <div style={{textAlign:"center",padding:"60px 0"}}>
          <Spin size={44}/>
          <p style={{color:T.muted,marginTop:16}}>Searching jobs worldwide...</p>
        </div>
      )}

      {/* Job listings */}
      {!loading && jobs.map((job,i) => (
        <Card key={i} hover style={{marginBottom:12,padding:20}}>
          <div style={{display:"flex",justifyContent:"space-between",alignItems:"flex-start",gap:12,flexWrap:"wrap"}}>
            <div style={{flex:1,minWidth:0}}>
              {/* Title + company */}
              <div style={{display:"flex",alignItems:"center",gap:10,flexWrap:"wrap",marginBottom:6}}>
                <div style={{width:40,height:40,borderRadius:10,background:`${T.accent}22`,display:"flex",alignItems:"center",justifyContent:"center",fontSize:18,flexShrink:0}}>🏢</div>
                <div>
                  <h3 style={{fontWeight:700,fontSize:15,color:T.text,marginBottom:2}}>{job.title}</h3>
                  <div style={{fontSize:13,color:T.accent,fontWeight:600}}>{job.company}</div>
                </div>
              </div>

              {/* Meta info */}
              <div style={{display:"flex",flexWrap:"wrap",gap:"6px 16px",marginBottom:10}}>
                <span style={{fontSize:12,color:T.muted,display:"flex",alignItems:"center",gap:4}}>📍 {job.location}</span>
                {job.salary!=="Salary not specified"&&<span style={{fontSize:12,color:T.green,fontWeight:700,display:"flex",alignItems:"center",gap:4}}>💰 {job.salary}</span>}
                {job.contractType&&<span style={{fontSize:12,color:T.muted,display:"flex",alignItems:"center",gap:4}}>⏱ {job.contractType}</span>}
                <span style={{fontSize:12,color:T.muted,display:"flex",alignItems:"center",gap:4}}>🕐 {timeAgo(job.postedAt)}</span>
                <Badge color="blue">{job.category}</Badge>
              </div>

              {/* Description */}
              <p style={{fontSize:13,color:T.muted,lineHeight:1.7,marginBottom:12}}>{job.description}</p>

              {/* Action buttons */}
              <div style={{display:"flex",gap:8,flexWrap:"wrap"}}>
                <Btn size="sm" variant="ghost" onClick={async()=>{
                  try{
                    const d=await apiFetch("/api/jobs/save","POST",{
                      jobId:job.id, jobTitle:job.title, company:job.company,
                      location:job.location, salary:job.salary, description:job.description
                    },token);
                    toast_(d.saved?"🔖 Job saved!":"Job removed from saved");
                  }catch(e){toast_(e.message,"err");}
                }}>🔖 Save</Btn>
                <Btn size="sm" onClick={async()=>{
                  try{
                    const d=await apiFetch("/api/jobs/apply","POST",{jobId:job.id,jobTitle:job.title},token);
                    // Open one-time redirect URL — real URL never exposed to browser
                    const redirectUrl=`${process.env.REACT_APP_API_URL||"http://localhost:4000"}/api/jobs/redirect/${d.redirectToken}`;
                    window.open(redirectUrl,"_blank","noopener,noreferrer");
                    setPoints(d.points);
                    toast_(`Applied! ✦ ${COSTS.APPLY} points used`);
                  }catch(e){
                    toast_(e.message||"Could not apply. Try again.","err");
                  }
                }}>🔗 Apply Now ({COSTS.APPLY} pts)</Btn>
                <Btn size="sm" variant="ghost" onClick={()=>{
                  setTab("builder");
                  toast_("Opening Resume Builder with this job... Paste the job description in Step 4!");
                }}>
                  ✦ Build Resume for This Job
                </Btn>
                <Btn size="sm" variant="ghost" onClick={()=>{
                  setTab("cover");
                  toast_("Opening Cover Letter Generator... Enter the company and role!");
                }}>
                  ✉️ Write Cover Letter
                </Btn>
              </div>
            </div>
          </div>
        </Card>
      ))}

      {/* Pagination */}
      {pages > 1 && !loading && (
        <div style={{display:"flex",justifyContent:"center",gap:8,marginTop:20,flexWrap:"wrap"}}>
          <Btn variant="ghost" size="sm" disabled={page===1} onClick={()=>{
            const prevPage = page - 1;
            search(prevPage, lastSearchRef.current);
          }}>← Prev</Btn>
          <span style={{padding:"8px 16px",color:T.muted,fontSize:13}}>Page {page} of {pages}</span>
          <Btn variant="ghost" size="sm" disabled={page===pages} onClick={()=>{
            const nextPage = page + 1;
            search(nextPage, lastSearchRef.current);
          }}>Next →</Btn>
        </div>
      )}

      {!searched && (
        <Card style={{textAlign:"center",padding:48,background:T.surface}}>
          <div style={{fontSize:56,marginBottom:16}}>🔍</div>
          <h3 style={{fontWeight:700,fontSize:18,marginBottom:8}}>Search Jobs Worldwide</h3>
          <p style={{color:T.muted,fontSize:14,maxWidth:400,margin:"0 auto"}}>Enter a job title above and select your country to see live job listings from millions of employers worldwide.</p>
        </Card>
      )}

      <MeshCode/>
    </div>
  );
}

// ══════════════════════════════════════════════════════════
// FEATURE: MY RESUMES — Saved Resume History
// ══════════════════════════════════════════════════════════
function MyResumes({ toast_, setTab }) {
  const { token } = useAuth();
  const [resumes, setResumes] = useState([]);
  const [loading, setLoading] = useState(true);
  const [viewing, setViewing] = useState(null);

  useEffect(() => {
    apiFetch("/api/resumes", "GET", null, token)
      .then(d => setResumes(d.resumes || []))
      .catch(e => toast_(e.message, "err"))
      .finally(() => setLoading(false));
  }, [token, toast_]);

  const deleteResume = async (id) => {
    if (!window.confirm("Delete this resume?")) return;
    try {
      await apiFetch(`/api/resumes/${id}`, "DELETE", null, token);
      setResumes(r => r.filter(x => String(x.id) !== String(id)));
      toast_("Resume deleted");
    } catch(e) { toast_(e.message, "err"); }
  };

  return (
    <div style={{maxWidth:820}}>
      <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:24,flexWrap:"wrap",gap:12}}>
        <div>
          <h1 style={{fontFamily:"'Sora',sans-serif",fontWeight:800,fontSize:26,marginBottom:4}}>📄 My Resumes</h1>
          <p style={{color:T.muted,fontSize:14}}>All your generated resumes saved automatically.</p>
        </div>
        <Btn onClick={()=>setTab("builder")}>+ Create New Resume</Btn>
      </div>

      {loading && <div style={{textAlign:"center",padding:60}}><Spin size={40}/></div>}

      {!loading && resumes.length === 0 && (
        <Card style={{textAlign:"center",padding:60}}>
          <div style={{fontSize:56,marginBottom:16}}>📄</div>
          <h3 style={{fontWeight:700,fontSize:18,marginBottom:8}}>No resumes yet</h3>
          <p style={{color:T.muted,fontSize:14,marginBottom:20}}>Generate your first AI resume and it'll be saved here automatically.</p>
          <Btn onClick={()=>setTab("builder")}>✦ Build My First Resume</Btn>
        </Card>
      )}

      {viewing && (
        <div style={{position:"fixed",inset:0,zIndex:999,background:"rgba(0,0,0,0.85)",display:"flex",alignItems:"center",justifyContent:"center",padding:20}}>
          <div style={{background:T.card,borderRadius:20,padding:24,maxWidth:700,width:"100%",maxHeight:"90vh",overflowY:"auto"}}>
            <div style={{display:"flex",justifyContent:"space-between",marginBottom:16}}>
              <h3 style={{fontWeight:700}}>{viewing.career} Resume</h3>
              <button onClick={()=>setViewing(null)} style={{background:"none",border:"none",color:T.muted,fontSize:20,cursor:"pointer"}}>✕</button>
            </div>
            <ResumeCard text={viewing.content} form={{name:viewing.name||""}} tid={viewing.template||"navy"} photo={null}/>
          </div>
        </div>
      )}

      <div style={{display:"grid",gap:12}}>
        {resumes.map((r,i) => (
          <Card key={i} style={{padding:20}}>
            <div style={{display:"flex",justifyContent:"space-between",alignItems:"flex-start",flexWrap:"wrap",gap:12}}>
              <div style={{flex:1,minWidth:0}}>
                <div style={{display:"flex",alignItems:"center",gap:10,marginBottom:6,flexWrap:"wrap"}}>
                  <div style={{width:36,height:36,borderRadius:9,background:`${T.accent}22`,display:"flex",alignItems:"center",justifyContent:"center",fontSize:18,flexShrink:0}}>📄</div>
                  <div>
                    <h3 style={{fontWeight:700,fontSize:15,color:T.text}}>{r.career} Resume</h3>
                    <div style={{fontSize:12,color:T.muted}}>{new Date(r.createdAt).toLocaleDateString("en-NG",{day:"numeric",month:"short",year:"numeric"})}</div>
                  </div>
                </div>
                <p style={{fontSize:13,color:T.muted,lineHeight:1.6,overflow:"hidden",display:"-webkit-box",WebkitLineClamp:2,WebkitBoxOrient:"vertical"}}>{r.content?.substring(0,150)}...</p>
              </div>
              <div style={{display:"flex",gap:8,flexShrink:0,flexWrap:"wrap"}}>
                <Btn size="sm" variant="ghost" onClick={()=>setViewing(r)}>👁 View</Btn>
                <Btn size="sm" variant="ghost" onClick={()=>{navigator.clipboard.writeText(r.content||"");toast_("Copied!");}}>Copy</Btn>
                <Btn size="sm" variant="danger" onClick={()=>deleteResume(r.id)}>🗑</Btn>
              </div>
            </div>
          </Card>
        ))}
      </div>
    </div>
  );
}

// ══════════════════════════════════════════════════════════
// FEATURE: SAVED JOBS
// ══════════════════════════════════════════════════════════
function SavedJobs({ toast_, setTab }) {
  const { token } = useAuth();
  const [jobs, setJobs] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    apiFetch("/api/jobs/saved", "GET", null, token)
      .then(d => setJobs(d.savedJobs || []))
      .catch(e => toast_(e.message, "err"))
      .finally(() => setLoading(false));
  }, [token, toast_]);

  const unsave = async (jobId) => {
    try {
      await apiFetch("/api/jobs/save", "POST", {jobId}, token);
      setJobs(j => j.filter(x => x.jobId !== jobId));
      toast_("Job removed from saved");
    } catch(e) { toast_(e.message, "err"); }
  };

  return (
    <div style={{maxWidth:820}}>
      <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:24,flexWrap:"wrap",gap:12}}>
        <div>
          <h1 style={{fontFamily:"'Sora',sans-serif",fontWeight:800,fontSize:26,marginBottom:4}}>🔖 Saved Jobs</h1>
          <p style={{color:T.muted,fontSize:14}}>Jobs you bookmarked for later.</p>
        </div>
        <Btn variant="ghost" onClick={()=>setTab("jobs")}>🌍 Browse Jobs</Btn>
      </div>

      {loading && <div style={{textAlign:"center",padding:60}}><Spin size={40}/></div>}

      {!loading && jobs.length === 0 && (
        <Card style={{textAlign:"center",padding:60}}>
          <div style={{fontSize:56,marginBottom:16}}>🔖</div>
          <h3 style={{fontWeight:700,fontSize:18,marginBottom:8}}>No saved jobs yet</h3>
          <p style={{color:T.muted,fontSize:14,marginBottom:20}}>Browse the Job Board and click 🔖 to save jobs you're interested in.</p>
          <Btn onClick={()=>setTab("jobs")}>🌍 Browse Job Board</Btn>
        </Card>
      )}

      <div style={{display:"grid",gap:12}}>
        {jobs.map((job,i) => (
          <Card key={i} hover style={{padding:20}}>
            <div style={{display:"flex",justifyContent:"space-between",alignItems:"flex-start",gap:12,flexWrap:"wrap"}}>
              <div style={{flex:1,minWidth:0}}>
                <div style={{display:"flex",gap:10,alignItems:"center",marginBottom:6}}>
                  <div style={{width:38,height:38,borderRadius:10,background:`${T.accent}22`,display:"flex",alignItems:"center",justifyContent:"center",fontSize:18,flexShrink:0}}>🏢</div>
                  <div>
                    <h3 style={{fontWeight:700,fontSize:15,color:T.text}}>{job.jobTitle}</h3>
                    <div style={{fontSize:13,color:T.accent,fontWeight:600}}>{job.company}</div>
                  </div>
                </div>
                <div style={{display:"flex",flexWrap:"wrap",gap:"4px 14px",marginBottom:8}}>
                  {job.location&&<span style={{fontSize:12,color:T.muted}}>📍 {job.location}</span>}
                  {job.salary&&job.salary!=="Not specified"&&<span style={{fontSize:12,color:T.green,fontWeight:700}}>💰 {job.salary}</span>}
                  <span style={{fontSize:12,color:T.muted}}>🔖 Saved {new Date(job.savedAt).toLocaleDateString()}</span>
                </div>
                {job.description&&<p style={{fontSize:13,color:T.muted,lineHeight:1.6,overflow:"hidden",display:"-webkit-box",WebkitLineClamp:2,WebkitBoxOrient:"vertical"}}>{job.description}</p>}
              </div>
              <div style={{display:"flex",gap:8,flexDirection:"column",flexShrink:0}}>
                <Btn size="sm" onClick={()=>setTab("builder")}>✦ Build Resume</Btn>
                <Btn size="sm" variant="ghost" onClick={()=>unsave(job.jobId)}>🗑 Remove</Btn>
              </div>
            </div>
          </Card>
        ))}
      </div>
    </div>
  );
}

// ══════════════════════════════════════════════════════════
// FEEDBACK PAGE
// ══════════════════════════════════════════════════════════
function FeedbackPage({toast_}){
  const {user, token} = useAuth();
  const [type, setType]       = useState("complaint");
  const [subject, setSubject] = useState("");
  const [message, setMessage] = useState("");
  const [loading, setLoading] = useState(false);
  const [sent, setSent]       = useState(false);

  const submit = async () => {
    if(!subject.trim()||!message.trim()){
      toast_("Please fill in subject and message","err"); return;
    }
    setLoading(true);
    try{
      await apiFetch("/api/feedback","POST",{type,subject,message},token);
      setSent(true);
      toast_("Feedback sent! We'll respond within 24 hours.");
    }catch(e){ toast_(e.message,"err"); }
    setLoading(false);
  };

  if(sent) return (
    <div style={{maxWidth:560,textAlign:"center",paddingTop:60}}>
      <div style={{fontSize:64,marginBottom:16}}>✅</div>
      <h2 style={{fontFamily:"'Sora',sans-serif",fontWeight:800,fontSize:24,marginBottom:10}}>Feedback Received!</h2>
      <p style={{color:T.muted,fontSize:15,lineHeight:1.7,marginBottom:24}}>Thank you for reaching out. We'll review your message and respond within 24 hours to <strong style={{color:T.text}}>{user?.email}</strong>.</p>
      <Btn onClick={()=>{setSent(false);setSubject("");setMessage("");}}>Send Another</Btn>
    </div>
  );

  return (
    <div style={{maxWidth:580}}>
      <h1 style={{fontFamily:"'Sora',sans-serif",fontWeight:800,fontSize:26,marginBottom:6}}>💬 Send Feedback</h1>
      <p style={{color:T.muted,marginBottom:24,fontSize:14}}>Have a complaint, suggestion or question? We read everything and respond within 24 hours.</p>

      <Card>
        {/* Type selector */}
        <div style={{marginBottom:20}}>
          <label style={{display:"block",fontSize:12,color:T.muted,marginBottom:8,fontWeight:600}}>FEEDBACK TYPE</label>
          <div style={{display:"flex",gap:8,flexWrap:"wrap"}}>
            {[
              {val:"complaint",label:"🚨 Complaint",color:T.red},
              {val:"bug",      label:"🐛 Bug Report",color:T.gold},
              {val:"suggestion",label:"💡 Suggestion",color:T.accent},
              {val:"question", label:"❓ Question",color:T.green},
              {val:"other",    label:"📝 Other",color:T.muted},
            ].map(t=><button key={t.val} onClick={()=>setType(t.val)}
              style={{padding:"8px 16px",borderRadius:99,border:`2px solid ${type===t.val?t.color:T.border}`,background:type===t.val?`${t.color}22`:"transparent",color:type===t.val?t.color:T.muted,cursor:"pointer",fontFamily:"inherit",fontSize:13,fontWeight:700,transition:"all 0.2s"}}>
              {t.label}
            </button>)}
          </div>
        </div>

        <Input label="Subject" value={subject} onChange={setSubject} placeholder="Brief description of your feedback..."/>
        <Input label="Message" value={message} onChange={setMessage} multi rows={6}
          placeholder="Describe in detail. For bugs — what happened, what you expected, and what device/browser you're using."/>

        <div style={{background:T.surface,borderRadius:10,padding:"10px 14px",marginBottom:16,fontSize:13,color:T.muted}}>
          Sending as: <strong style={{color:T.text}}>{user?.name}</strong> · {user?.email}
        </div>

        <Btn onClick={submit} loading={loading} full size="lg">📤 Send Feedback</Btn>
      </Card>
      <MeshCode/>
    </div>
  );
}

// ══════════════════════════════════════════════════════════
// SUCCESS STORY SUBMISSION
// ══════════════════════════════════════════════════════════
function SuccessStoryPage({ toast_ }) {
  const { user, token } = useAuth();
  const [role, setRole]       = useState("");
  const [company, setCompany] = useState("");
  const [country, setCountry] = useState("");
  const [quote, setQuote]     = useState("");
  const [loading, setLoading] = useState(false);
  const [sent, setSent]       = useState(false);

  const submit = async () => {
    if (!role.trim() || !company.trim() || !quote.trim()) {
      toast_("Please fill in all fields", "err"); return;
    }
    if (quote.length < 50) {
      toast_("Please write at least 50 characters about your experience", "err"); return;
    }
    setLoading(true);
    try {
      await apiFetch("/api/stories", "POST", { role, company, country, quote }, token);
      setSent(true);
      toast_("Story submitted! We'll review and publish it within 24 hours.");
    } catch(e) { toast_(e.message, "err"); }
    setLoading(false);
  };

  if (sent) return (
    <div style={{maxWidth:560,textAlign:"center",paddingTop:60}}>
      <div style={{fontSize:64,marginBottom:16}}>🎉</div>
      <h2 style={{fontFamily:"'Sora',sans-serif",fontWeight:800,fontSize:24,marginBottom:10}}>Thank You!</h2>
      <p style={{color:T.muted,fontSize:15,lineHeight:1.7,marginBottom:24}}>Your success story has been submitted for review. Once approved it will appear on our landing page and inspire thousands of other job seekers across Africa.</p>
      <div style={{background:`${T.gold}15`,border:`1px solid ${T.gold}44`,borderRadius:12,padding:16,marginBottom:24}}>
        <div style={{fontSize:13,color:T.gold,fontWeight:700}}>✦ Bonus: You earn 5 points when your story is approved!</div>
      </div>
    </div>
  );

  return (
    <div style={{maxWidth:580}}>
      <h1 style={{fontFamily:"'Sora',sans-serif",fontWeight:800,fontSize:26,marginBottom:6}}>🌟 Share Your Success Story</h1>
      <p style={{color:T.muted,marginBottom:6,fontSize:14}}>Did Career Pilot help you land a job or get interviews? Share your story and inspire thousands of other Africans.</p>
      <div style={{background:`${T.gold}15`,border:`1px solid ${T.gold}44`,borderRadius:10,padding:"10px 14px",marginBottom:24,fontSize:13,color:T.gold,fontWeight:600}}>
        ✦ Earn 5 bonus points when your story is approved and published!
      </div>

      <Card>
        <div style={{display:"flex",gap:14,alignItems:"center",marginBottom:20,padding:14,background:T.surface,borderRadius:10}}>
          <div style={{width:44,height:44,borderRadius:"50%",background:`linear-gradient(135deg,${T.accent},${T.accent2})`,display:"flex",alignItems:"center",justifyContent:"center",fontWeight:800,fontSize:18,color:"#fff",flexShrink:0}}>{user?.name?.[0]?.toUpperCase()}</div>
          <div>
            <div style={{fontWeight:700,color:T.text}}>{user?.name}</div>
            <div style={{fontSize:12,color:T.muted}}>{user?.email}</div>
          </div>
        </div>

        <Input label="Your Job Title / Role" value={role} onChange={setRole} placeholder="e.g. Software Engineer, Marketing Manager, Data Analyst"/>
        <Input label="Company You Joined" value={company} onChange={setCompany} placeholder="e.g. Access Bank, Andela, MTN Nigeria"/>
        <Input label="Your Country & City" value={country} onChange={setCountry} placeholder="e.g. Lagos, Nigeria 🇳🇬"/>
        <Input label="Your Success Story" value={quote} onChange={setQuote} multi rows={5}
          placeholder="Tell us how Career Pilot helped you. What changed? What results did you get? Be specific — the more detail, the more it inspires others. (minimum 50 characters)"/>

        <div style={{background:T.surface,borderRadius:10,padding:"10px 14px",marginBottom:16,fontSize:12,color:T.muted,lineHeight:1.6}}>
          📋 By submitting, you agree to your story and first name being displayed publicly on Career Pilot's website to inspire other job seekers.
        </div>

        <Btn onClick={submit} loading={loading} full size="lg">🌟 Submit My Story</Btn>
      </Card>
      <MeshCode/>
    </div>
  );
}
